module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "03d2":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"17\" viewBox=\"0 0 15 17\"><path fill-rule=\"evenodd\" d=\"M.75.25h8.667a.75.75 0 0 1 .743.648l.007.102v3.682a.75.75 0 0 1-1.493.102l-.007-.102V1.75H1.5v12.5h7.167v-2.895a.75.75 0 0 1 1.493-.101l.007.101V15a.75.75 0 0 1-.649.743l-.101.007H.75a.75.75 0 0 1-.743-.648L0 15V1A.75.75 0 0 1 .648.257L.75.25zm11.124 4.336l.088-.053a.75.75 0 0 1 .957.236l.053.087 1.451 2.814a.744.744 0 0 1 0 .66l-1.45 2.814a.75.75 0 0 1-1.375-.594l.041-.094.88-1.706h-8.88a.75.75 0 0 1-.102-1.493l.102-.007h8.881l-.881-1.706a.75.75 0 0 1 .235-.958l.088-.053-.088.053z\"></path></svg>"

/***/ }),

/***/ "054a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMedium_vue_vue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ee41");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMedium_vue_vue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMedium_vue_vue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "06a9":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__medium[data-v-0f65208b]{font-size:14px;font-weight:400;line-height:1.36;letter-spacing:normal}.text__medium.bold[data-v-0f65208b]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0a2c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("11f6");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6262e9db", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "11f6":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("1de5");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("54e0");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.i, "*[data-v-67a9da71],.checkbox[data-v-67a9da71],[data-v-67a9da71]:after,[data-v-67a9da71]:before{-webkit-box-sizing:border-box;box-sizing:border-box}.checkbox[data-v-67a9da71]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;min-height:20px}.checkbox__input[data-v-67a9da71]{display:none}.checkbox__label[data-v-67a9da71]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.checkbox__input+.checkbox__label[data-v-67a9da71]{position:relative;padding:0 0 0 24px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:inherit}.checkbox__input+.checkbox__label[data-v-67a9da71]:hover:before{border:1px solid #009387}.checkbox__input:checked+.checkbox__label[data-v-67a9da71]:hover:before{background-color:#009387;border-color:#009387}.checkbox__input+.checkbox__label[data-v-67a9da71]:after,.checkbox__input+.checkbox__label[data-v-67a9da71]:before{content:\"\";position:absolute;top:1px;left:0;width:16px;height:16px;-webkit-transition:.2s;transition:.2s}.checkbox__input+.checkbox__label[data-v-67a9da71]:before{background-color:transparent;border:.0667rem solid #d2d2d2;border-radius:4px}.checkbox__input+.checkbox__label[data-v-67a9da71]:after{-webkit-transform:scale(0);transform:scale(0);background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat 50%}.checkbox__input:checked+.checkbox__label[data-v-67a9da71]:after{-webkit-transform:scale(1);transform:scale(1)}.checkbox__input:checked+.checkbox__label[data-v-67a9da71]:before{background-color:#00afa1;border-color:#00afa1}.checkbox__input:disabled+.checkbox__label[data-v-67a9da71]:before{background-color:#f6f6f6;border:.0667rem solid #f6f6f6}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "147a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5137");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5a42db40", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1693":
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){ true?module.exports=r():undefined}(this,function(){return function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,r),o.loaded=!0,o.exports}var t={};return r.m=e,r.c=t,r.p="",r(0)}([function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(r,"__esModule",{value:!0});var o=t(3);Object.defineProperty(r,"conformToMask",{enumerable:!0,get:function(){return n(o).default}});var i=t(2);Object.defineProperty(r,"adjustCaretPosition",{enumerable:!0,get:function(){return n(i).default}});var a=t(5);Object.defineProperty(r,"createTextMaskInputElement",{enumerable:!0,get:function(){return n(a).default}})},function(e,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.placeholderChar="_",r.strFunction="function"},function(e,r){"use strict";function t(e){var r=e.previousConformedValue,t=void 0===r?o:r,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,l=void 0===u?0:u,s=e.conformedValue,f=e.rawValue,d=e.placeholderChar,c=e.placeholder,p=e.indexesOfPipedChars,v=void 0===p?n:p,h=e.caretTrapIndexes,m=void 0===h?n:h;if(0===l||!f.length)return 0;var y=f.length,g=t.length,b=c.length,C=s.length,P=y-g,k=P>0,x=0===g,O=P>1&&!k&&!x;if(O)return l;var T=k&&(t===s||s===c),w=0,M=void 0,S=void 0;if(T)w=l-P;else{var j=s.toLowerCase(),_=f.toLowerCase(),V=_.substr(0,l).split(o),A=V.filter(function(e){return j.indexOf(e)!==-1});S=A[A.length-1];var N=a.substr(0,A.length).split(o).filter(function(e){return e!==d}).length,E=c.substr(0,A.length).split(o).filter(function(e){return e!==d}).length,F=E!==N,R=void 0!==a[A.length-1]&&void 0!==c[A.length-2]&&a[A.length-1]!==d&&a[A.length-1]!==c[A.length-1]&&a[A.length-1]===c[A.length-2];!k&&(F||R)&&N>0&&c.indexOf(S)>-1&&void 0!==f[l]&&(M=!0,S=f[l]);for(var I=v.map(function(e){return j[e]}),J=I.filter(function(e){return e===S}).length,W=A.filter(function(e){return e===S}).length,q=c.substr(0,c.indexOf(d)).split(o).filter(function(e,r){return e===S&&f[r]!==e}).length,L=q+W+J+(M?1:0),z=0,B=0;B<C;B++){var D=j[B];if(w=B+1,D===S&&z++,z>=L)break}}if(k){for(var G=w,H=w;H<=b;H++)if(c[H]===d&&(G=H),c[H]===d||m.indexOf(H)!==-1||H===b)return G}else if(M){for(var K=w-1;K>=0;K--)if(s[K]===S||m.indexOf(K)!==-1||0===K)return K}else for(var Q=w;Q>=0;Q--)if(c[Q-1]===d||m.indexOf(Q)!==-1||0===Q)return Q}Object.defineProperty(r,"__esModule",{value:!0}),r.default=t;var n=[],o=""},function(e,r,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(r)){if(("undefined"==typeof r?"undefined":o(r))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");r=r(e,t),r=(0,i.processCaretTraps)(r).maskWithoutCaretTraps}var n=t.guide,s=void 0===n||n,f=t.previousConformedValue,d=void 0===f?l:f,c=t.placeholderChar,p=void 0===c?a.placeholderChar:c,v=t.placeholder,h=void 0===v?(0,i.convertMaskToPlaceholder)(r,p):v,m=t.currentCaretPosition,y=t.keepCharPositions,g=s===!1&&void 0!==d,b=e.length,C=d.length,P=h.length,k=r.length,x=b-C,O=x>0,T=m+(O?-x:0),w=T+Math.abs(x);if(y===!0&&!O){for(var M=l,S=T;S<w;S++)h[S]===p&&(M+=p);e=e.slice(0,T)+M+e.slice(T,b)}for(var j=e.split(l).map(function(e,r){return{char:e,isNew:r>=T&&r<w}}),_=b-1;_>=0;_--){var V=j[_].char;if(V!==p){var A=_>=T&&C===k;V===h[A?_-x:_]&&j.splice(_,1)}}var N=l,E=!1;e:for(var F=0;F<P;F++){var R=h[F];if(R===p){if(j.length>0)for(;j.length>0;){var I=j.shift(),J=I.char,W=I.isNew;if(J===p&&g!==!0){N+=p;continue e}if(r[F].test(J)){if(y===!0&&W!==!1&&d!==l&&s!==!1&&O){for(var q=j.length,L=null,z=0;z<q;z++){var B=j[z];if(B.char!==p&&B.isNew===!1)break;if(B.char===p){L=z;break}}null!==L?(N+=J,j.splice(L,1)):F--}else N+=J;continue e}E=!0}g===!1&&(N+=h.substr(F,P));break}N+=R}if(g&&O===!1){for(var D=null,G=0;G<N.length;G++)h[G]===p&&(D=G);N=null!==D?N.substr(0,D+1):l}return{conformedValue:N,meta:{someCharsRejected:E}}}Object.defineProperty(r,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r.default=n;var i=t(4),a=t(1),u=[],l=""},function(e,r,t){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:s.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(r)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(r)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?r:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return"undefined"==typeof e||null===e}function l(e){for(var r=[],t=void 0;t=e.indexOf(d),t!==-1;)r.push(t),e.splice(t,1);return{maskWithoutCaretTraps:e,indexes:r}}Object.defineProperty(r,"__esModule",{value:!0}),r.convertMaskToPlaceholder=n,r.isArray=o,r.isString=i,r.isNumber=a,r.isNil=u,r.processCaretTraps=l;var s=t(1),f=[],d="[]"},function(e,r,t){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var r={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:r,update:function(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,s=n.mask,d=n.guide,m=n.pipe,g=n.placeholderChar,b=void 0===g?v.placeholderChar:g,C=n.keepCharPositions,P=void 0!==C&&C,k=n.showMask,x=void 0!==k&&k;if("undefined"==typeof t&&(t=o.value),t!==r.previousConformedValue){("undefined"==typeof s?"undefined":l(s))===y&&void 0!==s.pipe&&void 0!==s.mask&&(m=s.pipe,s=s.mask);var O=void 0,T=void 0;if(s instanceof Array&&(O=(0,p.convertMaskToPlaceholder)(s,b)),s!==!1){var w=a(t),M=o.selectionEnd,S=r.previousConformedValue,j=r.previousPlaceholder,_=void 0;if(("undefined"==typeof s?"undefined":l(s))===v.strFunction){if(T=s(w,{currentCaretPosition:M,previousConformedValue:S,placeholderChar:b}),T===!1)return;var V=(0,p.processCaretTraps)(T),A=V.maskWithoutCaretTraps,N=V.indexes;T=A,_=N,O=(0,p.convertMaskToPlaceholder)(T,b)}else T=s;var E={previousConformedValue:S,guide:d,placeholderChar:b,pipe:m,placeholder:O,currentCaretPosition:M,keepCharPositions:P},F=(0,c.default)(w,T,E),R=F.conformedValue,I=("undefined"==typeof m?"undefined":l(m))===v.strFunction,J={};I&&(J=m(R,u({rawValue:w},E)),J===!1?J={value:S,rejected:!0}:(0,p.isString)(J)&&(J={value:J}));var W=I?J.value:R,q=(0,f.default)({previousConformedValue:S,previousPlaceholder:j,conformedValue:W,placeholder:O,rawValue:w,currentCaretPosition:M,placeholderChar:b,indexesOfPipedChars:J.indexesOfPipedChars,caretTrapIndexes:_}),L=W===O&&0===q,z=x?O:h,B=L?z:W;r.previousConformedValue=B,r.previousPlaceholder=O,o.value!==B&&(o.value=B,i(o,q))}}}}}function i(e,r){document.activeElement===e&&(g?b(function(){return e.setSelectionRange(r,r,m)},0):e.setSelectionRange(r,r,m))}function a(e){if((0,p.isString)(e))return e;if((0,p.isNumber)(e))return String(e);if(void 0===e||null===e)return h;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(r,"__esModule",{value:!0});var u=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};r.default=o;var s=t(2),f=n(s),d=t(3),c=n(d),p=t(4),v=t(1),h="",m="none",y="object",g="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),b="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout}])});

/***/ }),

/***/ "195d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".bim-input input[data-v-1d9ee204],.bim-input label[data-v-1d9ee204]{font-size:14px;font-weight:400;line-height:1.57;letter-spacing:.2px;color:#4d4d4d}.input__wrp[data-v-1d9ee204]{position:relative}.desc__block[data-v-1d9ee204]{margin-left:12px;margin-top:6px;color:#6c6c6c;font-size:13px}.bim-input[data-v-1d9ee204]{position:relative;-webkit-transition:all .2s;transition:all .2s;height:36px}.bim-input:hover input[data-v-1d9ee204]{border-color:rgba(77,77,77,.5)}.bim-input:hover label[data-v-1d9ee204]{color:rgba(77,77,77,.6)}.bim-input.focus label[data-v-1d9ee204],.bim-input.notEmpty label[data-v-1d9ee204]{padding:0 5px;height:10px;font-size:8px;font-weight:400;line-height:normal;letter-spacing:normal;color:#4d4d4d;top:0}.bim-input.focus input[data-v-1d9ee204]{border-color:rgba(77,77,77,.75)}.bim-input.valid input[data-v-1d9ee204]{border-color:#00afa1}.bim-input.valid label[data-v-1d9ee204]{color:#00afa1}.bim-input.invalid input[data-v-1d9ee204]{border-color:#e44545}.bim-input.invalid label[data-v-1d9ee204]{color:#e44545}.bim-input input[data-v-1d9ee204]{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;outline:none;border-radius:5px;border:1px solid rgba(77,77,77,.25);height:36px;padding:7px 12px}.bim-input input[data-v-1d9ee204],.bim-input label[data-v-1d9ee204]{-webkit-transition:inherit;transition:inherit}.bim-input label[data-v-1d9ee204]{position:absolute;left:12px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);color:rgba(77,77,77,.4);pointer-events:none}.bim-input.disabled input[data-v-1d9ee204]{border:1px solid #f6f6f6;background-color:#f6f6f6}.bim-input.disabled label[data-v-1d9ee204]{color:rgba(77,77,77,.5)}.bim-input.disabled label[data-v-1d9ee204]:after{background-color:transparent}.suggestions__wrp[data-v-1d9ee204]{position:absolute;top:42px;left:0;right:0;z-index:10;background:#fff;border:1px solid #afafaf;padding:5px 0;border-radius:4px;color:#222;max-height:210px;overflow-y:auto}.suggestion[data-v-1d9ee204]{padding:6px 0 6px 12px;line-height:1.4;font-size:14px}.suggestion__hint[data-v-1d9ee204]{color:#989898;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:2px}.suggestion.active__item[data-v-1d9ee204],.suggestion[data-v-1d9ee204]:hover{background-color:#ececec;cursor:pointer}.error-slide-enter-active[data-v-1d9ee204]{position:relative;-webkit-animation:error-slide-data-v-1d9ee204 .5s;animation:error-slide-data-v-1d9ee204 .5s}.error-slide-leave-active[data-v-1d9ee204]{position:relative;animation:error-slide-data-v-1d9ee204 .5s reverse}@-webkit-keyframes error-slide-data-v-1d9ee204{0%{left:100px;opacity:0}50%{left:-10px;opacity:1}to{left:0}}@keyframes error-slide-data-v-1d9ee204{0%{left:100px;opacity:0}50%{left:-10px;opacity:1}to{left:0}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1985":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports =  true && exports &&
		!exports.nodeType && exports;
	var freeModule =  true && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module), __webpack_require__("c8ba")))

/***/ }),

/***/ "1de5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    // eslint-disable-next-line no-param-reassign
    options = {};
  } // eslint-disable-next-line no-underscore-dangle, no-param-reassign


  url = url && url.__esModule ? url.default : url;

  if (typeof url !== 'string') {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(1, -1);
  }

  if (options.hash) {
    // eslint-disable-next-line no-param-reassign
    url += options.hash;
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, '\\n'), "\"");
  }

  return url;
};

/***/ }),

/***/ "1e73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimButton_vue_vue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a0e7");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimButton_vue_vue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimButton_vue_vue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1fb9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b348");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("247ce844", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "20be":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH4_vue_vue_type_style_index_0_id_5505cf98_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("853b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH4_vue_vue_type_style_index_0_id_5505cf98_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH4_vue_vue_type_style_index_0_id_5505cf98_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2235":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileHeadLinks_vue_vue_type_style_index_0_id_4ae5571b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("147a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileHeadLinks_vue_vue_type_style_index_0_id_4ae5571b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileHeadLinks_vue_vue_type_style_index_0_id_4ae5571b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2427":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2a41");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("31601444", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2a41":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__title .text__inner[data-v-4a4f2161]{margin:0;font-size:32px;font-weight:400;line-height:1.13;letter-spacing:normal}.text__title .text__inner.bold[data-v-4a4f2161]{font-weight:700}@media (max-width:575.98px){.text__inner.adaptive[data-v-4a4f2161]{font-size:24px;line-height:1.29}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2d7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH5_vue_vue_type_style_index_0_id_4a4f2161_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2427");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH5_vue_vue_type_style_index_0_id_4a4f2161_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH5_vue_vue_type_style_index_0_id_4a4f2161_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2e45":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d4d1");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("70475b2e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2ef0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("62e4")(module)))

/***/ }),

/***/ "2fa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Avatar_vue_vue_type_style_index_0_id_53a3d001_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a7bc");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Avatar_vue_vue_type_style_index_0_id_53a3d001_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Avatar_vue_vue_type_style_index_0_id_53a3d001_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "352f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimInput_vue_vue_type_style_index_0_id_1d9ee204_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ef8c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimInput_vue_vue_type_style_index_0_id_1d9ee204_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimInput_vue_vue_type_style_index_0_id_1d9ee204_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3645":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_social_links_vue_vue_type_style_index_0_id_404268a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8512");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_social_links_vue_vue_type_style_index_0_id_404268a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_social_links_vue_vue_type_style_index_0_id_404268a4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "37be":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"8\" viewBox=\"0 0 12 8\"><path fill=\"#4D4D4D\" fill-rule=\"evenodd\" d=\"M1.557.498A.75.75 0 0 0 .443 1.502l4.5 5a.75.75 0 0 0 1.114 0l4.5-5A.75.75 0 0 0 9.443.498L5.5 4.878 1.557.499z\" opacity=\".75\"></path></svg>"

/***/ }),

/***/ "3905":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextAccent_vue_vue_type_style_index_0_id_5a5d6fc5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b16e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextAccent_vue_vue_type_style_index_0_id_5a5d6fc5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextAccent_vue_vue_type_style_index_0_id_5a5d6fc5_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3ad2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH3_vue_vue_type_style_index_0_id_10e92476_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f848");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH3_vue_vue_type_style_index_0_id_10e92476_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH3_vue_vue_type_style_index_0_id_10e92476_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3c71":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".bim-container[data-v-7f28c32a]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0 auto;max-width:1479.98px;padding:0 40px}@media screen and (min-width:1279.98px) and (max-width:1479.98px){.bim-container[data-v-7f28c32a]{max-width:1279.98px;padding:0 40px}}@media screen and (min-width:959.98px) and (max-width:1279.98px){.bim-container[data-v-7f28c32a]{max-width:959.98px;padding:0 30px}}@media screen and (min-width:767.98px) and (max-width:959.98px){.bim-container[data-v-7f28c32a]{max-width:767.98px;padding:0 24px}}@media screen and (min-width:575.98px) and (max-width:767.98px){.bim-container[data-v-7f28c32a]{max-width:575.98px;padding:0 18px}}@media screen and (min-width:319.98px) and (max-width:575.98px){.bim-container[data-v-7f28c32a]{max-width:100%;padding:0 10px}}.bim-container .bim-container[data-v-7f28c32a]{padding:0}.bim-container--fluid[data-v-7f28c32a]{max-width:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3fec":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7e70");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("d29493fc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4129":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7f27");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("11a245c8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "434f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3c71");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3cb6cd61", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "43b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH1_vue_vue_type_style_index_0_id_3d31d668_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("79f9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH1_vue_vue_type_style_index_0_id_3d31d668_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH1_vue_vue_type_style_index_0_id_3d31d668_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4471":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".bl-content[data-v-1dae9183]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bl-content__icon[data-v-1dae9183]{margin-right:10px}@media (max-width:465px){.bl-content__icon[data-v-1dae9183]{display:none}}.bl-content__text[data-v-1dae9183]{margin-right:15px;white-space:break-spaces}@media (max-width:405px){.bl-content__btn[data-v-1dae9183]{display:none}}.bl-wrapper[data-v-1dae9183]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:16px;position:relative}@media (max-width:767px){.bl-wrapper[data-v-1dae9183]{padding-right:35px}}.bl-close[data-v-1dae9183]{position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;font-size:0}.banner-line[data-v-1dae9183]{width:100%;height:48px;display:-webkit-box;display:-ms-flexbox;display:flex;color:#232323;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-decoration:none;background-color:#f4fbfa}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4585":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".desc__block[data-v-d87d93f8]{margin-left:12px;margin-top:6px;color:#6c6c6c;font-size:13px}.reset__icon__wrp[data-v-d87d93f8]{position:absolute;top:50%;right:0;-webkit-transform:translate(150%,-50%);transform:translate(150%,-50%)}.reset__icon__wrp[data-v-d87d93f8]  svg{width:10px}.select__cnt[data-v-d87d93f8],.select__form__wrp[data-v-d87d93f8]{position:relative;cursor:pointer}.select__cnt.disabled[data-v-d87d93f8],.select__form__wrp.disabled[data-v-d87d93f8]{cursor:default;pointer-events:none;background-color:#f6f6f6;border-color:#f6f6f6}.input__form[data-v-d87d93f8]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit;height:36px;border:1px solid #d2d2d2;border-radius:4px;padding:0 12px;outline:none;-webkit-transition:border-color .2s;transition:border-color .2s;font-size:14px;letter-spacing:.1px;cursor:pointer}.input__form[data-v-d87d93f8]:disabled{background:#fff}.select__cnt:hover .input__form[data-v-d87d93f8]{border-color:#7a7a7a}.input__form.infocus[data-v-d87d93f8]{-webkit-transition:none;transition:none;background-color:#eee;border-color:#eee!important}.input__form.disabled[data-v-d87d93f8],.select__cnt:hover .input__form.disabled[data-v-d87d93f8]{cursor:default;pointer-events:none;background-color:#f6f6f6;border-color:#f6f6f6;opacity:.9}.input__form.error__form[data-v-d87d93f8]{border-color:#e44545}.input__form.error__form[data-v-d87d93f8]::-webkit-input-placeholder{color:#e44545;opacity:1}.input__form.error__form[data-v-d87d93f8]::-moz-placeholder{color:#e44545;opacity:1}.input__form.error__form[data-v-d87d93f8]:-ms-input-placeholder{color:#e44545;opacity:1}.input__form.error__form[data-v-d87d93f8]::-ms-input-placeholder{color:#e44545;opacity:1}.input__form.error__form[data-v-d87d93f8]::placeholder{color:#e44545;opacity:1}.arrow__icon__wrp[data-v-d87d93f8]{width:35px;height:36px;position:absolute;top:0;right:0;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.arrow__icon__wrp.disabled[data-v-d87d93f8]{cursor:default;pointer-events:none;opacity:.4}.arrow__icon[data-v-d87d93f8]{position:absolute;top:50%;right:14px;display:block;width:12px;height:8px;-webkit-transform:translateY(-50%);transform:translateY(-50%);pointer-events:none}.arrow__icon.up__icon[data-v-d87d93f8]{-webkit-transform:rotate(180deg) translateY(65%);transform:rotate(180deg) translateY(65%)}.options__items[data-v-d87d93f8]{position:absolute;top:46px;left:0;right:0;background-color:#fff;z-index:10;border-radius:5px;-webkit-box-shadow:0 10px 30px rgba(0,0,0,.05);box-shadow:0 10px 30px rgba(0,0,0,.05);margin:0;list-style-type:none;overflow-y:auto;padding:5px 0;color:#5b5b5b}.options__items.top[data-v-d87d93f8]{top:-14px;-webkit-transform:translateY(-100%);transform:translateY(-100%)}.empty__item[data-v-d87d93f8],.option__item[data-v-d87d93f8]{padding:10px 14px;font-size:15px;cursor:pointer;letter-spacing:.2px}.empty__item[data-v-d87d93f8]{cursor:default;color:#888}.option__item[data-v-d87d93f8]:hover{background-color:#f6f6f6}.option__item.selected[data-v-d87d93f8]{color:#00afa1}.select__label[data-v-d87d93f8]{position:absolute;color:#4d4d4d;left:12px;top:50%;right:38px;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:14px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;pointer-events:none}.arrow__icon[data-v-d87d93f8] svg{display:block}.load__icon[data-v-d87d93f8]{position:absolute;top:50%;right:0;-webkit-transform:translateY(-50%);transform:translateY(-50%);margin-top:-30px;width:20px;height:20px}.load__icon div[data-v-d87d93f8]{display:inline-block;position:absolute;width:2px;background:#999;-webkit-animation:lds-facebook-data-v-d87d93f8 1.2s cubic-bezier(0,.5,.5,1) infinite;animation:lds-facebook-data-v-d87d93f8 1.2s cubic-bezier(0,.5,.5,1) infinite}.load__icon div[data-v-d87d93f8]:first-child{-webkit-animation-delay:-.24s;animation-delay:-.24s}.load__icon div[data-v-d87d93f8]:nth-child(2){left:4px;-webkit-animation-delay:-.12s;animation-delay:-.12s}.load__icon div[data-v-d87d93f8]:nth-child(3){left:8px;-webkit-animation-delay:0;animation-delay:0}@-webkit-keyframes lds-facebook-data-v-d87d93f8{0%{top:20px;height:38px}50%,to{top:30px;height:20px}}@keyframes lds-facebook-data-v-d87d93f8{0%{top:20px;height:38px}50%,to{top:30px;height:20px}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "460b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeadLinks_vue_vue_type_style_index_0_id_58b578b4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4660");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeadLinks_vue_vue_type_style_index_0_id_58b578b4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeadLinks_vue_vue_type_style_index_0_id_58b578b4_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4660":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5f2f");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("a13473ce", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "46f6":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".menu-child[data-v-c3ede230]{position:absolute;top:100%;left:0;display:none;min-width:100%;padding-top:19px;-webkit-transform:scaleY(0);transform:scaleY(0);-webkit-transform-origin:top;transform-origin:top;-webkit-animation:ani-data-v-c3ede230 .25s forwards;animation:ani-data-v-c3ede230 .25s forwards;-webkit-filter:drop-shadow(0 15px 20px #e5eceb);filter:drop-shadow(0 15px 20px #E5ECEB)}@-webkit-keyframes ani-data-v-c3ede230{0%{-webkit-transform:scaleY(0);transform:scaleY(0)}to{-webkit-transform:scaleY(1);transform:scaleY(1)}}@keyframes ani-data-v-c3ede230{0%{-webkit-transform:scaleY(0);transform:scaleY(0)}to{-webkit-transform:scaleY(1);transform:scaleY(1)}}.menu-child a[data-v-c3ede230]{font-weight:500;font-size:16px;color:#252525;padding:12px 24px;display:block;background-color:#fff}.menu-child a[data-v-c3ede230]:hover{color:#00afa1;background-color:#e9faf8}.menu-child a[data-v-c3ede230]:first-child{border-radius:12px 12px 0 0}.menu-child a[data-v-c3ede230]:last-child{border-radius:0 0 12px 12px}.menu-child a[data-v-c3ede230]:only-child{border-radius:12px}.menu-link:hover .menu-child[data-v-c3ede230]{display:block}.head-flex[data-v-c3ede230]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.head-flex-item[data-v-c3ede230]{-webkit-box-flex:1;-ms-flex:1;flex:1}.head-flex-auto[data-v-c3ede230]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.menu-link[data-v-c3ede230]{position:relative}.menu-link:hover .icon-droplist[data-v-c3ede230]{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.icon-droplist[data-v-c3ede230]{position:relative;left:3px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon-droplist[data-v-c3ede230],.icon-droplist[data-v-c3ede230]  svg{-webkit-transition:all .2s ease;transition:all .2s ease}.icon-droplist[data-v-c3ede230]  svg{width:16px!important;height:16px!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4973":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".green-link span[data-v-63ada184]{color:#00afa1;position:relative}.green-link span[data-v-63ada184]:before{content:\"\";position:absolute;right:-15px;top:50%;width:6px;height:6px;margin-top:-4.5px;border-top:2px solid #00afa1;border-left:2px solid #00afa1;-webkit-transform:rotate(135deg);transform:rotate(135deg)}.cursor-pointer[data-v-63ada184]{cursor:pointer}.link-group--mobile[data-v-63ada184]{line-height:1.44;font-size:18px;font-weight:700;color:inherit;text-decoration:none}.link-group--mobile[data-v-63ada184]:first-child{margin-top:14px}.icon-droplist--mobile[data-v-63ada184]{position:relative;top:2px;left:15px}.icon-droplist--mobile[data-v-63ada184]  svg{-webkit-transition:all .2s ease;transition:all .2s ease;width:18px!important;height:18px!important}.link-group__inner[data-v-63ada184]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.link-group__inner--mobile[data-v-63ada184]{padding-left:15px}.mobile-menu__links[data-v-63ada184]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:15px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4cb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimContainer_vue_vue_type_style_index_0_id_7f28c32a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("434f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimContainer_vue_vue_type_style_index_0_id_7f28c32a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimContainer_vue_vue_type_style_index_0_id_7f28c32a_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4ffb":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"20\" viewBox=\"0 0 18 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 15V12H0V8H7V5L12 10L7 15ZM7 0H16C16.5304 0 17.0391 0.210714 17.4142 0.585786C17.7893 0.960859 18 1.46957 18 2V18C18 18.5304 17.7893 19.0391 17.4142 19.4142C17.0391 19.7893 16.5304 20 16 20H7C6.46957 20 5.96086 19.7893 5.58579 19.4142C5.21071 19.0391 5 18.5304 5 18V16H7V18H16V2H7V4H5V2C5 1.46957 5.21071 0.960859 5.58579 0.585786C5.96086 0.210714 6.46957 0 7 0Z\" fill=\"black\"></path></svg>"

/***/ }),

/***/ "5137":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".head-links[data-v-4ae5571b]{border-top:1px solid #eee;border-bottom:1px solid #eee;padding-bottom:24px;margin-bottom:37.5px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "54e0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg width='12px' height='8px' viewBox='0 0 12 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='input/select/square/added-hover' transform='translate(-2.000000, -4.000000)' fill='%23FFFFFF'%3E %3Cpath d='M13.3012938,5.10434049 L12.33615,4.18852638 C12.2038118,4.06285785 12.0428634,4 11.8536775,4 C11.6643176,4 11.5033691,4.06285785 11.371031,4.18852638 L6.71548219,8.61279918 L4.62901861,6.62623165 C4.49653131,6.50051595 4.33568229,6.43772886 4.1464964,6.43772886 C3.95718623,6.43772886 3.79633721,6.50051595 3.66384992,6.62623165 L2.69870608,7.54206936 C2.56621879,7.66776147 2.5,7.82043647 2.5,8.00004717 C2.5,8.17951636 2.56621879,8.33233288 2.69870608,8.4580014 L5.26769187,10.8956359 L6.23291028,11.81145 C6.365323,11.9372129 6.52622173,12 6.71548219,12 C6.90466808,12 7.06556682,11.9370478 7.19805411,11.81145 L8.16324766,10.8956359 L13.3012938,6.02022537 C13.4336568,5.89450967 13.5,5.74185826 13.5,5.56224755 C13.5,5.38273119 13.4336568,5.23005619 13.3012938,5.10434049 Z' id='Path'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ "5595":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f619");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0ed4c8b9", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5800":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9641");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3531de7a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5a11":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ee63");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1cc540c7", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5c75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_default_vue_vue_type_style_index_0_id_162ff93b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae19");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_default_vue_vue_type_style_index_0_id_162ff93b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_default_vue_vue_type_style_index_0_id_162ff93b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5f2f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".head_links[data-v-58b578b4]{height:100%}.separator[data-v-58b578b4]{height:37px;margin:auto 0;border-left:1px solid #eaeaea}@media (max-width:1279px){.separator[data-v-58b578b4]{display:none}}.green-link[data-v-58b578b4]  a{position:relative;color:#00afa1!important;padding-right:30px!important}.green-link[data-v-58b578b4]  a:before{content:\"\";position:absolute;right:15px;top:50%;width:6px;height:6px;margin-top:-4.5px;border-top:2px solid #00afa1;border-left:2px solid #00afa1;-webkit-transform:rotate(135deg);transform:rotate(135deg)}.head-flex[data-v-58b578b4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.head-flex-item[data-v-58b578b4]{-webkit-box-flex:1;-ms-flex:1;flex:1}.head-flex-auto[data-v-58b578b4]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.link-group__inner[data-v-58b578b4]{position:absolute;width:100%;left:0;top:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.link-group__inner[data-v-58b578b4]:after{content:\"\";position:absolute;top:0;left:-100vw;z-index:-1;width:200vw;height:100%;background-color:#fff;-webkit-box-shadow:0 5px 40px 0 rgba(0,0,0,.03);box-shadow:0 5px 40px 0 rgba(0,0,0,.03)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "6124":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTopBannerLine_vue_vue_type_style_index_0_id_1dae9183_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("778d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTopBannerLine_vue_vue_type_style_index_0_id_1dae9183_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTopBannerLine_vue_vue_type_style_index_0_id_1dae9183_prod_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6144":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimNotices_vue_vue_type_style_index_0_id_3252723b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5a11");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimNotices_vue_vue_type_style_index_0_id_3252723b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimNotices_vue_vue_type_style_index_0_id_3252723b_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "618d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7686");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2c4f7eac", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "6369":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"115\" height=\"19\" viewBox=\"0 0 115 19\"><path fill=\"#00AFA1\" fill-rule=\"evenodd\" d=\"M57.443.161v18.633h-4.87v-5.802l-4.737 5.868-4.83-5.997v5.931h-4.778V.161l9.608 11.532L57.443.16zm33.684 0v18.633h-4.856V.161h4.856zm-62.396 0v18.633H23.88V.161h4.85zm43.445 0v13.937h4.598v4.696H67.49V.161h4.687zm42.684 0v18.633h-9.757c-1.957 0-6.161-.928-6.161-5.352 0-4.423 3.112-4.885 3.112-4.885s-1.503-.83-1.503-3.534c0-2.704 1.985-4.883 5.95-4.883 2.642 0 5.428.007 8.359.021zM8.438.161c3.964 0 5.953 2.094 5.953 4.798s-1.503 3.534-1.503 3.534S16 8.955 16 13.378 11.796 18.73 9.84 18.73H.144L.14.183C3.03.169 5.795.16 8.438.16zm101.424 11.525h-3.881c-.951 0-1.98.38-1.98 1.681 0 1.302 1.029 1.832 1.958 1.832h3.903v-3.513zm-100.9-.064H5.08v3.512h3.903c.93 0 1.957-.53 1.957-1.83 0-1.302-1.028-1.682-1.979-1.682zM109.835 4.22h-2.978c-.768 0-1.192.584-1.192 1.248 0 .663.424 1.236 1.11 1.236h3.049l.01-2.484zM8.084 4.176H5.106l.011 2.485h3.05c.685 0 1.109-.573 1.109-1.237 0-.664-.424-1.248-1.192-1.248z\"></path></svg>"

/***/ }),

/***/ "66ca":
/***/ (function(module, exports) {

module.exports = "<svg width=\"19\" height=\"19\" viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.86072 8.54171C5.30072 11.3717 7.62072 13.6917 10.4507 15.1317L12.6507 12.9317C12.9307 12.6517 13.3207 12.5717 13.6707 12.6817C14.7907 13.0517 15.9907 13.2517 17.2407 13.2517C17.5059 13.2517 17.7603 13.3571 17.9478 13.5446C18.1354 13.7321 18.2407 13.9865 18.2407 14.2517V17.7517C18.2407 18.0169 18.1354 18.2713 17.9478 18.4588C17.7603 18.6464 17.5059 18.7517 17.2407 18.7517C12.732 18.7517 8.40803 16.9606 5.21991 13.7725C2.03179 10.5844 0.240723 6.26039 0.240723 1.75171C0.240723 1.48649 0.346079 1.23214 0.533616 1.0446C0.721152 0.857066 0.975506 0.751709 1.24072 0.751709H4.74072C5.00594 0.751709 5.26029 0.857066 5.44783 1.0446C5.63537 1.23214 5.74072 1.48649 5.74072 1.75171C5.74072 3.00171 5.94072 4.20171 6.31072 5.32171C6.42072 5.67171 6.34072 6.06171 6.06072 6.34171L3.86072 8.54171Z\" fill=\"#2EBCB1\"></path></svg>"

/***/ }),

/***/ "67a6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimSelect_vue_vue_type_style_index_0_id_d87d93f8_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7eb1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimSelect_vue_vue_type_style_index_0_id_d87d93f8_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimSelect_vue_vue_type_style_index_0_id_d87d93f8_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "69b5":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__title .text__inner[data-v-10e92476]{margin:0;font-size:50px;font-weight:400;line-height:1.08;letter-spacing:normal}.text__title .text__inner.bold[data-v-10e92476]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "756c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextDesc_vue_vue_type_style_index_0_id_521d930c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b678");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextDesc_vue_vue_type_style_index_0_id_521d930c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextDesc_vue_vue_type_style_index_0_id_521d930c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "75d0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "*[data-v-644bc4a4],[data-v-644bc4a4]:after,[data-v-644bc4a4]:before{-webkit-box-sizing:border-box;box-sizing:border-box}.bim-btn[data-v-644bc4a4]{--text-color:#fff;--primary-color:#00afa1;--primary-color-hover:#06baab;--primary-color-active:#02a497;--box-shadow-color:rgba(0,175,161,0.2);display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border:none;background-color:var(--primary-color);color:var(--text-color);border-radius:4px;font-weight:700;white-space:nowrap;font-size:14px;line-height:1.36;-webkit-box-shadow:0 10px 10px 0 var(--box-shadow-color);box-shadow:0 10px 10px 0 var(--box-shadow-color);outline:none;-webkit-transition:.2s;transition:.2s;cursor:pointer}.bim-btn i[data-v-644bc4a4]{margin-right:4px}.bim-btn i[data-v-644bc4a4]:before{color:var(--text-color)}.bim-btn[data-v-644bc4a4]:hover{-webkit-box-shadow:0 30px 30px 0 var(--box-shadow-color);box-shadow:0 30px 30px 0 var(--box-shadow-color);background-color:var(--primary-color-hover)}.bim-btn[data-v-644bc4a4]:active{-webkit-box-shadow:none;box-shadow:none;background-color:var(--primary-color-active)}.bim-btn--big[data-v-644bc4a4]{height:54px;padding:18px 60px}.bim-btn--normal[data-v-644bc4a4]{height:42px;padding:12px 34px}.bim-btn--small[data-v-644bc4a4]{height:36px;font-size:12px;padding:8px 24px}.bim-btn--square[data-v-644bc4a4]{width:42px;height:42px;padding:0}.bim-btn--square.bim-btn--big[data-v-644bc4a4]{width:54px;height:54px}.bim-btn--square.bim-btn--small[data-v-644bc4a4]{width:36px;height:36px}.bim-btn--square i[data-v-644bc4a4]{margin:0}.bim-btn--square[data-v-644bc4a4]:active,.bim-btn--square[data-v-644bc4a4]:hover{opacity:1}.bim-btn--rounded[data-v-644bc4a4]{width:40px;height:40px;padding:0;border-radius:50%}.bim-btn--rounded.bim-btn--big[data-v-644bc4a4]{width:54px;height:54px}.bim-btn--rounded.bim-btn--small[data-v-644bc4a4]{width:36px;height:36px}.bim-btn--rounded i[data-v-644bc4a4]{margin:0}.bim-btn--luxury[data-v-644bc4a4]{--primary-color:#ff9126;--primary-color-hover:#ff9d3e;--primary-color-active:#f48820;--box-shadow-color:rgba(255,145,38,0.2)}.bim-btn--white[data-v-644bc4a4]{--text-color:#00afa1;--primary-color:#fff;--primary-color-hover:#f6f6f6;--primary-color-active:#eee;--box-shadow-color:none}.bim-btn--gray[data-v-644bc4a4]{--text-color:#4d4d4d;--primary-color:#eee;--primary-color-hover:#f6f6f6;--primary-color-active:#e6e6e6;--box-shadow-color:none}.bim-btn--darkgray[data-v-644bc4a4]{--text-color:#fff;--primary-color:#4d4d4d;--primary-color-hover:#5b5b5b;--primary-color-active:#444;--box-shadow-color:none}.bim-btn--red[data-v-644bc4a4]{--primary-color:#e44545;--primary-color-hover:#f65959;--primary-color-active:#d43838;--box-shadow-color:rgba(228,69,69,0.2)}.bim-btn--lightred[data-v-644bc4a4]{--text-color:#e44545;--primary-color:#fff;--primary-color-hover:rgba(228,69,69,0.1);--primary-color-active:rgba(228,69,69,0.25);--box-shadow-color:none}.bim-btn--outline[data-v-644bc4a4]{position:relative;top:-1px;border:1px solid var(--primary-color);background:transparent;color:var(--primary-color);--box-shadow-color:none;-webkit-transition:all .2s,color 0s;transition:all .2s,color 0s}.bim-btn--outline[data-v-644bc4a4]:hover{border:1px solid var(--primary-color-hover);color:#fff}.bim-btn--noshadow[data-v-644bc4a4]{--box-shadow-color:none}.bim-custom-color[data-v-644bc4a4],.bim-custom-color[data-v-644bc4a4]:hover{background-color:var(--propscolor);-webkit-box-shadow:none;box-shadow:none}.bim-custom-color[data-v-644bc4a4]:hover{opacity:.9}.bim-btn.disabled[data-v-644bc4a4]{opacity:.4;-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7686":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__title .text__inner[data-v-037e675e]{margin:0;font-size:68px;font-weight:400;line-height:1.09;letter-spacing:normal}.text__title .text__inner.bold[data-v-037e675e]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "778d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4471");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3274d55e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "79f9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f124");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("46021d2a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7a08":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.62 7.79C5.06 10.62 7.38 12.94 10.21 14.38L12.41 12.18C12.69 11.9 13.08 11.82 13.43 11.93C14.55 12.3 15.75 12.5 17 12.5C17.2652 12.5 17.5196 12.6054 17.7071 12.7929C17.8946 12.9804 18 13.2348 18 13.5V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C12.4913 18 8.1673 16.2089 4.97918 13.0208C1.79107 9.8327 0 5.50868 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H4.5C4.76522 0 5.01957 0.105357 5.20711 0.292893C5.39464 0.48043 5.5 0.734784 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z\" fill=\"#3E3E3E\"></path></svg>"

/***/ }),

/***/ "7a59":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".socs[data-v-404268a4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.socs a+a[data-v-404268a4]{margin-left:10px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7d47":
/***/ (function(module, exports) {

module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 1.25a.75.75 0 0 1 .743.648L10.75 2v2.25H13a.75.75 0 0 1 .102 1.493L13 5.75h-.25V14a.75.75 0 0 1-.648.743L12 14.75H4a.75.75 0 0 1-.75-.75V5.75H3a.75.75 0 0 1-.102-1.493L3 4.25h2.25V2a.75.75 0 0 1 .648-.743L6 1.25h4zm1.25 4.5h-6.5v7.5h6.5v-7.5zm-2-3h-2.5v1.5h2.5v-1.5z\" fill=\"#4D4D4D\" fill-rule=\"evenodd\" opacity=\".5\"></path></svg>"

/***/ }),

/***/ "7e70":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__main[data-v-7355df6c]{font-size:18px;font-weight:400;line-height:1.44;letter-spacing:normal}.text__main.bold[data-v-7355df6c]{font-weight:700}@media (max-width:575.98px){.text__main.adaptive[data-v-7355df6c]{font-size:16px;line-height:1.33}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7e73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimErrorField_vue_vue_type_style_index_0_id_6c076c8e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4129");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimErrorField_vue_vue_type_style_index_0_id_6c076c8e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimErrorField_vue_vue_type_style_index_0_id_6c076c8e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7eb1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4585");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7dfc59f1", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7ef6":
/***/ (function(module, exports) {

module.exports = "<svg width=\"21\" height=\"17\" viewBox=\"0 0 21 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.2407 9.75171L0.240723 3.51171V2.75171C0.240723 1.64171 1.13072 0.751709 2.24072 0.751709H18.2407C18.7712 0.751709 19.2799 0.962423 19.6549 1.3375C20.03 1.71257 20.2407 2.22128 20.2407 2.75171V3.50171L10.2407 9.75171ZM20.2407 14.7517C20.2407 15.2821 20.03 15.7908 19.6549 16.1659C19.2799 16.541 18.7712 16.7517 18.2407 16.7517H2.24072C1.13072 16.7517 0.240723 15.8517 0.240723 14.7517V5.86171L2.24072 7.11171V14.7517H18.2407V7.11171L20.2407 5.86171V14.7517Z\" fill=\"#2EBCB1\"></path></svg>"

/***/ }),

/***/ "7f27":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".error__text[data-v-6c076c8e]{font-size:12px;color:#f74949;margin-top:6px;margin-left:12px}.check__error[data-v-6c076c8e]{margin-left:32px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "824e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeadLink_vue_vue_type_style_index_0_id_c3ede230_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fa97");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeadLink_vue_vue_type_style_index_0_id_c3ede230_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HeadLink_vue_vue_type_style_index_0_id_c3ede230_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "829f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("c8f7");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("017d8d85", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8512":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7a59");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("0f1cf346", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "853b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d8a7");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3db85471", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8725":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4973");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7f992c86", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8b13":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__desc[data-v-521d930c]{font-size:12px;font-weight:400;line-height:1.67;letter-spacing:normal}.text__desc.bold[data-v-521d930c]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "8b55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextHint_vue_vue_type_style_index_0_id_46b016bf_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1fb9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextHint_vue_vue_type_style_index_0_id_46b016bf_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextHint_vue_vue_type_style_index_0_id_46b016bf_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8bdb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b1d0");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1eb0e13e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8dfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextSmall_vue_vue_type_style_index_0_id_438fb726_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a741");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextSmall_vue_vue_type_style_index_0_id_438fb726_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextSmall_vue_vue_type_style_index_0_id_438fb726_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "90c9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = () => /xn--[a-z0-9]+/i


/***/ }),

/***/ "93ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMain_vue_vue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3fec");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMain_vue_vue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextMain_vue_vue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9416":
/***/ (function(module, exports) {

module.exports = "<svg width=\"23\" height=\"13\" viewBox=\"0 0 23 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.5624 6.5239C13.1601 6.38205 13.1601 5.8403 13.1352 5.46304C13.0346 4.11924 13.5374 2.06769 12.934 1.19546C12.5068 0.676351 10.4447 0.723885 9.18799 0.794811C8.83559 0.842346 8.40837 0.912517 8.10666 1.05437C7.80495 1.19622 7.50324 1.43163 7.50324 1.64365C7.50324 1.94998 8.25792 1.9032 8.53388 2.30386C8.83559 2.72865 8.83559 3.64766 8.83559 4.40218C8.83559 5.27441 8.68433 6.43034 8.3078 6.47712C7.72932 6.50051 7.40267 5.95801 7.10096 5.55736C6.49754 4.77944 5.89412 3.81215 5.44115 2.86899C5.21507 2.37403 5.08875 1.83152 4.7621 1.6195C4.25925 1.28902 3.35412 1.26563 2.47393 1.28902C1.66936 1.31241 0.512404 1.2181 0.286323 1.66628C0.110124 2.16125 0.487463 2.63283 0.688603 3.03423C1.71925 5.13256 2.82552 6.97209 4.18362 8.71654C5.44115 10.3433 6.62224 11.6403 8.93536 12.3239C9.58947 12.5125 12.4553 13.055 13.0338 12.3239C13.2349 12.041 13.1851 11.4042 13.2856 10.9326C13.3862 10.461 13.5117 9.98942 13.9896 9.96603C14.3919 9.94264 14.618 10.2724 14.8698 10.5085C15.1466 10.7681 15.3727 10.9801 15.5738 11.2163C16.0517 11.6645 16.5546 12.2771 17.158 12.5133C17.9875 12.8438 19.2699 12.7495 20.4768 12.7019C21.4576 12.6785 22.1615 12.4899 22.2372 11.9474C22.2879 11.5226 21.7842 10.9099 21.4825 10.5561C20.7278 9.68384 20.3762 9.42429 19.521 8.62223C19.1436 8.26836 18.6657 7.8911 18.6657 7.46705C18.6408 7.2075 18.8669 6.97209 19.068 6.71253C19.9482 5.48643 20.8284 4.6142 21.6329 3.34057C21.859 2.96331 22.3876 2.09108 22.1865 1.66628C21.9604 1.19471 20.7029 1.3358 19.9233 1.3358C18.9176 1.3358 17.6101 1.26488 17.3583 1.45351C16.8804 1.75985 16.6793 2.25557 16.4532 2.72714C15.9503 3.81215 15.2713 4.91979 14.5673 5.74523C14.3155 6.02818 13.8384 6.61746 13.5616 6.52315L13.5624 6.5239Z\" fill=\"#2EBCB1\"></path></svg>"

/***/ }),

/***/ "9641":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".refresh[data-v-54c42e66]{color:#00afa1;cursor:pointer;text-decoration:underline}.refresh[data-v-54c42e66]:hover{text-decoration:none}.buttons[data-v-54c42e66]{display:-webkit-box;display:-ms-flexbox;display:flex}.buttons__item[data-v-54c42e66]{-webkit-box-flex:1;-ms-flex:1;flex:1;padding:0 17px}.phone[data-v-54c42e66] .bim-input label{display:none}.agreement[data-v-54c42e66]{font-size:14px}.agreement a[data-v-54c42e66]{color:#00afa1}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9db1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileMenu_vue_vue_type_style_index_0_id_259f4f5f_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2e45");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileMenu_vue_vue_type_style_index_0_id_259f4f5f_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileMenu_vue_vue_type_style_index_0_id_259f4f5f_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a0e7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("75d0");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("57358bea", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a4b2":
/***/ (function(module, exports) {

module.exports = "<svg width=\"19\" height=\"18\" viewBox=\"0 0 19 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.00390625 8.74046C3.77304 8.69644 5.89192 8.45473 7.30591 7.12931C8.72 5.80389 8.97772 3.81795 9.02476 0.285156C4.108 0.420857 0.148623 4.132 0.00390625 8.74046ZM9.58266 0.285156C9.6294 3.81795 9.88712 5.80389 11.3015 7.12931C12.7155 8.45473 14.8344 8.69634 18.6035 8.74046C18.4588 4.132 14.4994 0.420857 9.58266 0.285156ZM18.6035 9.26316C14.8344 9.30729 12.7155 9.54879 11.3015 10.8743C9.88742 12.1997 9.6294 14.1857 9.58266 17.7185C14.4994 17.5828 18.4588 13.8716 18.6035 9.26316ZM9.02476 17.7185C8.97772 14.1857 8.72 12.1997 7.30591 10.8743C5.89192 9.54889 3.77304 9.30729 0.00390631 9.26316C0.148624 13.8716 4.108 17.5828 9.02476 17.7185Z\" fill=\"#2EBCB1\"></path></svg>"

/***/ }),

/***/ "a741":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fd12");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2ed45c81", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a7bc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f7d7");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("a6edd6e2", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a863":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const punycodeRegex = __webpack_require__("90c9")()

module.exports = (string) => punycodeRegex.test(string)


/***/ }),

/***/ "ae19":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e04f");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("62cd6047", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b16e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bbc1");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("516f3f85", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b1d0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".region-notice[data-v-d596974c]{position:relative}.region-notice .region-notice__button-wrapper[data-v-d596974c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.region-notice .region-notice__save-button[data-v-d596974c]{display:block;margin-left:auto}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b257":
/***/ (function(module, exports) {

module.exports = "<svg width=\"20\" height=\"16\" viewBox=\"0 0 20 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.2065 12.6063L8.55837 14.7445L7.8097 14.8422L6.1343 9.28019L0.240723 7.41511L18.3848 0.751709L19.2407 0.770157L16.382 15.7517L11.2065 12.6063ZM15.7444 3.56686L7.43058 8.36886L8.38796 12.3038L8.65028 12.2466L9.64977 9.21009L16.2939 3.62958L15.7444 3.56686Z\" fill=\"#2EBCB1\"></path></svg>"

/***/ }),

/***/ "b348":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__hint[data-v-46b016bf]{font-size:10px;font-weight:400;line-height:1.5;letter-spacing:normal}.text__hint.bold[data-v-46b016bf]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b678":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8b13");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4df4326c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "bb27":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dzen-green.svg": "a4b2",
	"./email-green.svg": "7ef6",
	"./phone-green.svg": "66ca",
	"./telegram-green.svg": "b257",
	"./vk-green.svg": "9416",
	"./youtube-green.svg": "ce8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb27";

/***/ }),

/***/ "bbc1":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__accent[data-v-5a5d6fc5]{font-size:24px;font-weight:400;line-height:1.29;letter-spacing:normal}.text__accent.bold[data-v-5a5d6fc5]{font-weight:700}@media (max-width:575.98px){.text__accent.adaptive[data-v-5a5d6fc5]{font-size:20px;line-height:1.35}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "bf3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimCheckbox_vue_vue_type_style_index_0_id_67a9da71_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0a2c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimCheckbox_vue_vue_type_style_index_0_id_67a9da71_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimCheckbox_vue_vue_type_style_index_0_id_67a9da71_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bf52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileHeadLink_vue_vue_type_style_index_0_id_63ada184_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8725");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileHeadLink_vue_vue_type_style_index_0_id_63ada184_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MobileHeadLink_vue_vue_type_style_index_0_id_63ada184_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c470":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_formPhoneVerification_vue_vue_type_style_index_0_id_54c42e66_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5800");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_formPhoneVerification_vue_vue_type_style_index_0_id_54c42e66_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_formPhoneVerification_vue_vue_type_style_index_0_id_54c42e66_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c84a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimHeader_vue_vue_type_style_index_0_id_bde68a26_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("829f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimHeader_vue_vue_type_style_index_0_id_bde68a26_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimHeader_vue_vue_type_style_index_0_id_bde68a26_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8f7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".hamburger[data-v-bde68a26]{width:18px;cursor:pointer;padding:5px 0 5px 10px}@media (min-width:961px){.hamburger[data-v-bde68a26]{display:none}}.hamburger[data-v-bde68a26]:after,.hamburger[data-v-bde68a26]:before{content:\"\";width:100%;height:2px;margin:7px 0;display:block;background-color:#4d4d4d}.head-flex[data-v-bde68a26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.head-flex-item[data-v-bde68a26]{-webkit-box-flex:1;-ms-flex:1;flex:1}.head-flex-auto[data-v-bde68a26]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.nav-up[data-v-bde68a26]{top:-64px!important}.nav-down[data-v-bde68a26]{top:0!important}.bim-header[data-v-bde68a26]{width:100%;font-weight:500;font-family:Helvetica Neue,sans-serif;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:top .5s ease;transition:top .5s ease;position:fixed;z-index:1001;white-space:nowrap;color:#4d4d4d;-webkit-box-shadow:0 5px 40px 0 rgba(0,0,0,.03);box-shadow:0 5px 40px 0 rgba(0,0,0,.03);background:#fff;-webkit-filter:drop-shadow(0 15px 20px #e5eceb);filter:drop-shadow(0 15px 20px #E5ECEB)}.bim-header-content[data-v-bde68a26]{height:64px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bim-header-content.w100[data-v-bde68a26]{max-width:100%}@media screen and (max-width:575.98px){.change-lang--desktop[data-v-bde68a26]{display:none!important}}.bim-logo[data-v-bde68a26]{cursor:pointer;margin-right:20px}@media (min-width:1280px){.bim-logo[data-v-bde68a26]{margin-right:40px}}.bim-logo[data-v-bde68a26] svg{width:95px}@media (min-width:1280px){.phone-wrp[data-v-bde68a26]{padding:0 24px 0 12px}}.notice-wrp[data-v-bde68a26]{margin-left:6px}.head-tel[data-v-bde68a26]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px;color:#4d4d4d;line-height:1;letter-spacing:.2px;text-decoration:none}@media screen and (max-width:575.98px){.head-tel[data-v-bde68a26]{font-size:0}}@media (max-width:1279px) and (min-width:960px){.head-tel[data-v-bde68a26]{font-size:0!important}}@media (max-width:959px) and (min-width:576px){.head-tel[data-v-bde68a26]{margin-right:20px}}.head-tel__icon[data-v-bde68a26]{font-size:0}@media (min-width:1280px){.head-tel__icon[data-v-bde68a26]{margin-right:7px}}@media (max-width:959px){.head-tel__icon[data-v-bde68a26]{margin-right:7px}}@media (max-width:1280px){.head-tel__icon[data-v-bde68a26]{margin-left:15px}}.head-menu[data-v-bde68a26] svg{display:block!important;width:18px}.head-menu[data-v-bde68a26]{margin-left:25px;cursor:pointer}[data-v-bde68a26] .link-group{height:64px;color:#4d4d4d;line-height:1.1;padding:0 14px;font-size:16px;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;letter-spacing:.005em;-webkit-transition:background-color .2s;transition:background-color .2s;text-decoration:none;white-space:pre}@media screen and (max-width:1279.98px){[data-v-bde68a26] .link-group{padding:0 14px}}[data-v-bde68a26] .link-group:hover{background:#f6f6f6;cursor:pointer}.link-group-wrp[data-v-bde68a26]{display:none!important;position:relative}.head-tel[data-v-bde68a26]:hover{color:#00afa1;cursor:pointer}.telegram-icon[data-v-bde68a26]{margin-left:12px;padding:12px 11px 12px 10px}.telegram-icon[data-v-bde68a26]  svg path{width:19px;height:16px;fill:#a6a6a6;cursor:pointer}.telegram-icon[data-v-bde68a26] :hover svg path{fill:#00afa1}.user-info-text[data-v-bde68a26]{-webkit-box-flex:1;-ms-flex:1;flex:1;position:relative;top:1px;padding-right:40px}.user-info[data-v-bde68a26]{margin:0 24px;padding:0 20px 0 8px;height:64px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;display:none!important}.user-info.opened[data-v-bde68a26],.user-info[data-v-bde68a26]:hover{background-color:#f6f6f6}.user-info[data-v-bde68a26]:hover{cursor:pointer}.user-fullname[data-v-bde68a26]{font-size:14px;font-weight:700}.message-info[data-v-bde68a26]{color:#4d4d4d;font-size:12px;opacity:.5;line-height:1.83;margin-top:2px}.login-wrp[data-v-bde68a26]{line-height:1!important}.login-wrp[data-v-bde68a26],.login-wrp__text[data-v-bde68a26]{display:-webkit-box;display:-ms-flexbox;display:flex}.login-wrp__text[data-v-bde68a26]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.login-wrp__icon[data-v-bde68a26]{font-size:0;margin-right:7px}.login-wrp[data-v-bde68a26],.service-wrp[data-v-bde68a26]{padding:0 12px;height:64px;line-height:64px;font-size:14px;letter-spacing:.2px}@media screen and (max-width:1279.98px){.login-wrp[data-v-bde68a26],.service-wrp[data-v-bde68a26]{padding:0 14px}}@media screen and (max-width:959.98px){.login-wrp[data-v-bde68a26],.service-wrp[data-v-bde68a26],.telegram-icon[data-v-bde68a26]{display:none!important}}.login-wrp[data-v-bde68a26]:hover{cursor:pointer;background-color:#f6f6f6;color:#000!important}.service-wrp[data-v-bde68a26]{color:#fff;background-color:#00afa1}@media screen and (max-width:1279.98px) and (min-width:959.98px){.service-wrp[data-v-bde68a26]{display:none!important}}.service-wrp[data-v-bde68a26]:hover{cursor:pointer;background-color:#06baab}.user-menu-wrp[data-v-bde68a26]{font-weight:700;line-height:1.54;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;position:absolute;right:0;top:100%;padding-top:27px;cursor:default;z-index:30;-webkit-filter:drop-shadow(0 15px 20px #e5eceb);filter:drop-shadow(0 15px 20px #E5ECEB);-webkit-transform:scaleY(0);transform:scaleY(0);-webkit-transform-origin:top;transform-origin:top;-webkit-animation:ani-data-v-bde68a26 .25s forwards;animation:ani-data-v-bde68a26 .25s forwards}@-webkit-keyframes ani-data-v-bde68a26{0%{-webkit-transform:scaleY(0);transform:scaleY(0)}to{-webkit-transform:scaleY(1);transform:scaleY(1)}}@keyframes ani-data-v-bde68a26{0%{-webkit-transform:scaleY(0);transform:scaleY(0)}to{-webkit-transform:scaleY(1);transform:scaleY(1)}}.arrow-down[data-v-bde68a26]{-webkit-transition:all .2s ease;transition:all .2s ease;position:absolute;top:24px;right:11px;width:7px;height:7px;border:2px solid #252525;border-top:0;border-right:0;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.arrow-down.up[data-v-bde68a26]{-webkit-transform:rotate(-225deg);transform:rotate(-225deg);top:28px;opacity:.5}.search__block[data-v-bde68a26]{padding:10px;cursor:pointer;display:none!important}.menu-item[data-v-bde68a26]{font-weight:500;font-size:16px;cursor:pointer;color:#252525;display:-webkit-box;display:-ms-flexbox;display:flex;padding:12px 24px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;font-family:Helvetica Neue,sans-serif;-webkit-transition:background-color .2s,color .2s;transition:background-color .2s,color .2s}.menu-item[data-v-bde68a26]:first-child{border-radius:12px 12px 0 0}.menu-item[data-v-bde68a26]:last-child{border-radius:0 0 12px 12px}.menu-item[data-v-bde68a26]:hover{color:#00afa1;background-color:#e9faf8}.menu-item[data-v-bde68a26]:hover svg{fill:#00afa1}.menu-icon[data-v-bde68a26] svg{display:block!important;max-width:18px;margin-bottom:1px;margin-right:7px;fill:#3e3e3e;-webkit-transition:fill .2s;transition:fill .2s}@media (min-width:959.98px){.bim-logo[data-v-bde68a26] svg{width:115px}.head-menu[data-v-bde68a26]{display:none!important}.link-group-wrp[data-v-bde68a26],.search__block[data-v-bde68a26],.user-info[data-v-bde68a26]{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.head-tel[data-v-bde68a26]{font-size:15px}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ca54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_region_vue_vue_type_style_index_0_id_d596974c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8bdb");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_region_vue_vue_type_style_index_0_id_d596974c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_region_vue_vue_type_style_index_0_id_d596974c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ce8c":
/***/ (function(module, exports) {

module.exports = "<svg width=\"21\" height=\"15\" viewBox=\"0 0 21 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.22916 10.3378V4.72601C10.2214 5.66344 11.7643 6.56901 13.5892 7.54534C12.0841 8.38005 10.2214 9.31662 8.22916 10.3378ZM19.3317 1.93499C18.9881 1.48223 18.4024 1.1298 17.7788 1.01312C15.946 0.665068 4.51171 0.664078 2.67988 1.01312C2.17983 1.10686 1.73456 1.33344 1.35206 1.68548C-0.25964 3.18138 0.245389 11.2034 0.63387 12.5029C0.79723 13.0653 1.00841 13.471 1.27437 13.7372C1.61703 14.0893 2.08619 14.3317 2.62508 14.4404C4.13418 14.7525 11.9088 14.927 17.7469 14.4872C18.2848 14.3935 18.7609 14.1433 19.1365 13.7763C20.6266 12.2864 20.5251 3.81384 19.3317 1.93499Z\" fill=\"#2EBCB1\"></path></svg>"

/***/ }),

/***/ "d240":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_occupation_vue_vue_type_style_index_0_id_24d62e3c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fda9");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_occupation_vue_vue_type_style_index_0_id_24d62e3c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_notice_occupation_vue_vue_type_style_index_0_id_24d62e3c_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d4d1":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ava__logo[data-v-259f4f5f]{width:50px;height:50px;display:block}.w-100[data-v-259f4f5f]{width:100%}.container[data-v-259f4f5f]{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;margin:0 auto;max-width:1479.98px;padding:0 40px}@media screen and (min-width:1279.98px) and (max-width:1479.98px){.container[data-v-259f4f5f]{max-width:1279.98px;padding:0 40px}}@media screen and (min-width:959.98px) and (max-width:1279.98px){.container[data-v-259f4f5f]{max-width:959.98px;padding:0 30px}}@media screen and (min-width:767.98px) and (max-width:959.98px){.container[data-v-259f4f5f]{max-width:767.98px;padding:0 24px}}@media screen and (min-width:575.98px) and (max-width:767.98px){.container[data-v-259f4f5f]{max-width:575.98px;padding:0 18px}}@media screen and (min-width:319.98px) and (max-width:575.98px){.container[data-v-259f4f5f]{max-width:100%;padding:0 10px}}.container-fluid[data-v-259f4f5f]{max-width:100%}.container-fluid>.row[data-v-259f4f5f]{margin:0}.br50p[data-v-259f4f5f]{border-radius:50%;overflow:hidden}.op05[data-v-259f4f5f]{opacity:.5}ul[data-v-259f4f5f]{list-style:none;padding:0;margin:0}a[data-v-259f4f5f]{text-decoration:none;color:inherit}.mobile-menu[data-v-259f4f5f]{display:-webkit-box;display:-ms-flexbox;display:flex;overflow:auto;z-index:9998;position:fixed;top:0;left:0;width:100%;height:100vh;background-color:#fff;font-family:Bimlib-Helvetica,sans-serif}@media screen and (min-width:959.98px){.mobile-menu[data-v-259f4f5f]{display:none}}.mobile-menu__close[data-v-259f4f5f]{width:40px;height:40px;cursor:pointer;position:relative;border-radius:40px;background-color:#f6f6f6}.mobile-menu__close[data-v-259f4f5f]:after,.mobile-menu__close[data-v-259f4f5f]:before{content:\"\";width:18px;height:2px;position:absolute;left:50%;top:50%;background-color:#4d4d4d}.mobile-menu__close[data-v-259f4f5f]:before{-webkit-transform:translate(-50%,-50%) rotate(45deg);transform:translate(-50%,-50%) rotate(45deg)}.mobile-menu__close[data-v-259f4f5f]:after{-webkit-transform:translate(-50%,-50%) rotate(-45deg);transform:translate(-50%,-50%) rotate(-45deg)}.mobile_header[data-v-259f4f5f]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.ava-block--mobile[data-v-259f4f5f],.mobile_header[data-v-259f4f5f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ava-block--mobile[data-v-259f4f5f]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.mobile_header__menu-text[data-v-259f4f5f]{font-size:24px}.profile-list__item[data-v-259f4f5f]{cursor:pointer;font-size:14px;line-height:1.57;letter-spacing:.2px}.contacts-list[data-v-259f4f5f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.contacts-item[data-v-259f4f5f]{font-weight:700;font-size:14px;color:#4d4d4d;line-height:1.36}.mobile_socials[data-v-259f4f5f]{padding-top:35px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.social-list li[data-v-259f4f5f]:not(:last-child){margin-right:16px}.social-link[data-v-259f4f5f]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;width:30px;height:30px;font-size:20px;background-color:#f2fbfa;color:#00afa1}.change-lang[data-v-259f4f5f],.social-link[data-v-259f4f5f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.mobile-profile__name[data-v-259f4f5f]{font-size:14px;font-weight:700}.mobile-profile__messages[data-v-259f4f5f]{letter-spacing:.5px;opacity:.5;font-size:12px}.mobile-menu__wrp[data-v-259f4f5f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.mobile-menu__button-top[data-v-259f4f5f]{cursor:pointer;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:3px;text-align:center;padding:18px 68px}.mobile-menu__button-top.get-service[data-v-259f4f5f]{-webkit-box-shadow:0 10px 10px 0 #e5f7f5;box-shadow:0 10px 10px 0 #e5f7f5;background-color:#00afa1}.mobile-menu__button-top.get-service .button[data-v-259f4f5f]{color:#fff}.mobile-menu__button-top.login[data-v-259f4f5f]{background-color:#f6f6f6}.mobile-menu__button-top.login .button[data-v-259f4f5f]{color:#00afa1}.mobile-menu__button-top .button[data-v-259f4f5f]{font-size:14px;font-weight:700;line-height:1.36}.icon-telegram[data-v-259f4f5f]:before{color:#00afa1!important}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d8a7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__title .text__inner[data-v-5505cf98]{margin:0;font-size:42px;font-weight:400;line-height:1.14;letter-spacing:normal}.text__title .text__inner.bold[data-v-5505cf98]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "daa1":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".region-notice .toast__button-wrapper[data-v-24d62e3c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.region-notice .toast__button[data-v-24d62e3c]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding-left:0;padding-right:0}.region-notice .region-notice__save-button[data-v-24d62e3c]{display:block;margin-left:auto}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "dc34":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><g fill=\"none\" fill-rule=\"evenodd\"><g fill=\"#252525\"><g><path d=\"M2.47 4.97c.266-.267.683-.29.976-.073l.084.073L8 9.439l4.47-4.47c.266-.266.683-.29.976-.072l.084.073c.267.266.29.683.073.976l-.073.084-5 5c-.266.267-.683.29-.976.073l-.084-.073-5-5c-.293-.293-.293-.767 0-1.06z\" transform=\"translate(-561 -24) translate(561 24)\"></path></g></g></g></svg>"

/***/ }),

/***/ "e04f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".notice-default[data-v-162ff93b]{display:block;height:100%;text-decoration:none;color:inherit}.notice-default .notice-default__title[data-v-162ff93b]{color:#00afa1}.notice-default .notice-default__text[data-v-162ff93b],.notice-default .notice-default__title[data-v-162ff93b]{word-break:break-word}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ee41":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("06a9");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("75f7b670", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ee63":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".notices[data-v-3252723b]{position:relative}.notices .notices__icon-dot[data-v-3252723b]{-webkit-box-sizing:content-box;box-sizing:content-box;position:absolute;top:8px;right:8px;width:6px;height:6px;border:2px solid #fff;background-color:#eb3030;border-radius:50%}.notices .notices__icon-wrapper[data-v-3252723b]:hover{opacity:.75}.notices .notices__icon-image[data-v-3252723b]{border-radius:50%;-webkit-transition:all .2s;transition:all .2s;cursor:pointer;width:40px;height:40px}.notices .notices__icon-image[data-v-3252723b]  svg{padding:10px 11px}.notices .notices__icon-image[data-v-3252723b]  path{-webkit-transition:fill .2s;transition:fill .2s}.notices .notices__icon-image.active[data-v-3252723b],.notices .notices__icon-image[data-v-3252723b]:active{background-color:#a6a6a6}.notices .notices__icon-image.active[data-v-3252723b]  svg path,.notices .notices__icon-image[data-v-3252723b]:active  svg path{fill:#fff}.notices .notices__list-wrapper[data-v-3252723b]{position:absolute;z-index:1010;top:66px;left:-108px;width:436px;max-height:552px;height:auto;overflow:auto;border-radius:5px;-webkit-box-shadow:0 20px 40px 0 rgba(0,0,0,.1);box-shadow:0 20px 40px 0 rgba(0,0,0,.1);background-color:#fff;-webkit-box-sizing:border-box;box-sizing:border-box}.notices .notices__list-wrapper[data-v-3252723b]::-webkit-scrollbar-track{background-color:#f6f6f6}.notices .notices__list-wrapper[data-v-3252723b]::-webkit-scrollbar{width:8px}.notices .notices__list-wrapper[data-v-3252723b]::-webkit-scrollbar-thumb{background-color:#dbdbdb}.notices .notices__list-wrapper[data-v-3252723b]:hover::-webkit-scrollbar-thumb{background-color:#d2d2d2}.notices .notices__list-header[data-v-3252723b]{background-color:#fff;position:sticky;top:0;z-index:1;padding:24px 0;border-bottom:1px solid #f0f0f0}.list .list__count[data-v-3252723b]{font-family:Helvetica,sans-serif,arial}.list .list__item[data-v-3252723b]{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer;padding:14px 0;border-bottom:1px solid #f0f0f0}.list .list__item .list__item-description[data-v-3252723b],.list .list__item .list__item-title[data-v-3252723b]{word-break:break-word;white-space:break-spaces}.list .list__item.seen[data-v-3252723b]{opacity:.75}.list .list__item:hover .list__item-delete[data-v-3252723b]{opacity:1}.list .list__item .list__item-delete[data-v-3252723b]{position:absolute;top:16px;right:24px;opacity:0;-webkit-transition:opacity .2s;transition:opacity .2s;padding:8px 9px 6px;background-color:#fff;border-radius:50%;cursor:pointer}.list .list__item .list__item-content[data-v-3252723b]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-decoration:none;color:inherit;-webkit-transition:.2s ease;transition:.2s ease}.list .list__item .list__item-content[data-v-3252723b]:hover{opacity:.6}.list .list__item-bottom[data-v-3252723b]{display:-webkit-box;display:-ms-flexbox;display:flex}.list .list__item-time[data-v-3252723b],.list .list__item-type[data-v-3252723b]{opacity:.5;font-size:8px;line-height:1.88;letter-spacing:.8px;text-transform:uppercase}.management-buttons[data-v-3252723b]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.management-buttons .management-buttons__checkbox[data-v-3252723b]{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}.management-buttons .management-buttons__button[data-v-3252723b]{padding:8px 0;font-size:12px;line-height:1.67;height:auto;font-weight:700}.management-buttons .management-buttons__button--primary[data-v-3252723b]{padding:6px 0;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;border:1px solid #f0f0f0}.management-buttons .management-buttons__button--gray[data-v-3252723b]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ef8c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("195d");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7e64241c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f124":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__title .text__inner[data-v-3d31d668]{margin:0;font-size:86px;font-weight:400;line-height:1.02;letter-spacing:normal}.text__title .text__inner.bold[data-v-3d31d668]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f4d0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH2_vue_vue_type_style_index_0_id_037e675e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("618d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH2_vue_vue_type_style_index_0_id_037e675e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_bimTextH2_vue_vue_type_style_index_0_id_037e675e_prod_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f619":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".loader__overlay[data-v-e1d9552c]{position:absolute;top:0;left:0;right:0;bottom:0;background-color:hsla(0,0%,100%,.5);z-index:20}.lds-hourglass[data-v-e1d9552c]{position:absolute;top:50%;left:50%;width:80px;height:80px;margin-top:-40px;margin-left:-40px}.lds-hourglass[data-v-e1d9552c]:after{content:\" \";display:block;border-radius:50%;width:0;height:0;margin:8px;-webkit-box-sizing:border-box;box-sizing:border-box;border:32px solid #999;border-color:#999 transparent #999 transparent;-webkit-animation:lds-hourglass-data-v-e1d9552c 1.2s infinite;animation:lds-hourglass-data-v-e1d9552c 1.2s infinite}@-webkit-keyframes lds-hourglass-data-v-e1d9552c{0%{-webkit-transform:rotate(0);transform:rotate(0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}50%{-webkit-transform:rotate(900deg);transform:rotate(900deg);-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}to{-webkit-transform:rotate(5turn);transform:rotate(5turn)}}@keyframes lds-hourglass-data-v-e1d9552c{0%{-webkit-transform:rotate(0);transform:rotate(0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}50%{-webkit-transform:rotate(900deg);transform:rotate(900deg);-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}to{-webkit-transform:rotate(5turn);transform:rotate(5turn)}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f7ba":
/***/ (function(module, exports) {

module.exports = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.72648 39.2313H8.61389C8.08716 39.2313 7.66016 39.6583 7.66016 40.185V45.5286C7.66016 46.0553 8.08716 46.4823 8.61389 46.4823H8.72648C9.25321 46.4823 9.68021 46.0553 9.68021 45.5286V40.185C9.68021 39.6583 9.25321 39.2313 8.72648 39.2313Z\" fill=\"#263238\"></path><path d=\"M15.7613 47.9897C15.7613 47.9897 13.128 47.9897 11.9663 47.9897C10.8046 47.9897 9.55415 48.1222 9.05211 47.436C8.65472 46.9062 8.72625 46.1922 8.75672 45.5511C8.84503 43.7469 8.93025 41.9428 9.01237 40.1387C9.03489 39.6499 9.06138 39.1505 9.26538 38.6935C9.46937 38.2365 10.39 31.914 10.9437 31.8054H15.6355L15.7613 47.9897Z\" fill=\"#263238\"></path><path d=\"M14.7736 45.0981C14.7736 45.1166 13.5166 45.1325 11.9654 45.1325C10.4143 45.1325 9.15723 45.1166 9.15723 45.0981C9.15723 45.0795 10.4143 45.0623 11.9654 45.0623C13.5166 45.0623 14.7736 45.0782 14.7736 45.0981Z\" fill=\"#455A64\"></path><path d=\"M12.5374 37.7742C12.5572 37.7742 12.5718 39.4114 12.5718 41.4315C12.5718 43.4515 12.5572 45.0901 12.5374 45.0901C12.5175 45.0901 12.5029 43.4528 12.5029 41.4315C12.5029 39.4101 12.5188 37.7742 12.5374 37.7742Z\" fill=\"#455A64\"></path><path d=\"M9.03139 46.0558C9.02532 46.0338 9.02264 46.011 9.02345 45.9882C9.02345 45.9366 9.02345 45.873 9.01417 45.7962C9.00623 45.6279 8.9996 45.3855 8.99298 45.0862C8.97973 44.4874 8.97179 43.6595 8.97973 42.7455C8.98768 41.8316 9.00887 41.0023 9.03272 40.4036C9.04331 40.1042 9.05524 39.8618 9.06451 39.6949L9.07776 39.5015C9.07776 39.4791 9.08088 39.4568 9.08703 39.4353C9.09022 39.4577 9.09022 39.4805 9.08703 39.5029V39.6949C9.08703 39.8738 9.08703 40.1135 9.07511 40.4049C9.06716 41.0129 9.05656 41.8355 9.04331 42.7455C9.03007 43.6556 9.04331 44.4768 9.03669 45.0862C9.03669 45.3776 9.03669 45.616 9.03669 45.7962C9.03669 45.873 9.03669 45.9366 9.03669 45.9882C9.03782 46.0109 9.03604 46.0336 9.03139 46.0558Z\" fill=\"#455A64\"></path><path d=\"M34.9777 22.6575C34.9777 22.6575 37.0375 23.0549 38.0866 26.3758C39.2854 30.1788 41.3081 37.9755 41.2922 38.8749C41.2763 39.7744 38.982 41.2182 38.982 41.2182L35.6956 40.1227L33.9736 33.6321L34.9777 22.6575Z\" fill=\"#00AFA1\"></path><path d=\"M34.9787 22.6575L29.9107 20.7779L29.5623 20.3328L23.0266 20.5355L22.5418 20.8481C22.5418 20.8481 17.6288 21.925 17.1201 21.9913C15.928 22.1436 14.6788 23.7835 14.6788 23.7835C14.5464 23.9358 8.37891 32.9141 8.37891 32.9141L9.81613 38.569C9.81613 38.569 10.4957 38.8087 12.4495 37.5278C13.9966 36.5118 15.1994 34.9037 15.6286 34.2785L15.622 47.995H34.7708L33.7283 39.2949L34.9787 22.6575Z\" fill=\"#00AFA1\"></path><path d=\"M34.006 31.6942C34.0051 31.6714 34.0078 31.6486 34.014 31.6266C34.0246 31.5749 34.0365 31.5114 34.0511 31.4345L34.1928 30.7298C34.3107 30.1351 34.4577 29.3098 34.6008 28.3958C34.7439 27.4818 34.8353 26.6473 34.8975 26.0446C34.928 25.7506 34.9518 25.5081 34.9704 25.3293C34.9783 25.2512 34.9849 25.1876 34.9916 25.1346C34.9923 25.1116 34.9964 25.0889 35.0035 25.067C35.0066 25.0899 35.0066 25.1131 35.0035 25.1359C35.0035 25.1889 35.0035 25.2525 34.9955 25.332C34.9876 25.5015 34.9704 25.7466 34.9452 26.0486C34.8949 26.654 34.8048 27.4885 34.667 28.4051C34.5293 29.3217 34.369 30.1457 34.2392 30.7391C34.1743 31.0358 34.1186 31.2756 34.0762 31.4398C34.0564 31.5153 34.0405 31.5789 34.0259 31.6292C34.022 31.6516 34.0153 31.6734 34.006 31.6942Z\" fill=\"#263238\"></path><path d=\"M15.0247 28.0223C15.0333 28.0495 15.039 28.0774 15.0419 28.1058C15.0512 28.1667 15.0631 28.2462 15.079 28.3429C15.1095 28.5508 15.1492 28.8502 15.1956 29.2224C15.287 29.9655 15.3943 30.9948 15.4777 32.1366C15.5612 33.2784 15.6102 34.3103 15.6208 35.0574C15.6287 35.4323 15.6327 35.7356 15.6327 35.9449C15.6327 36.0429 15.6327 36.1224 15.6327 36.186C15.6349 36.2138 15.6349 36.2417 15.6327 36.2694C15.6266 36.242 15.6235 36.2141 15.6234 36.186C15.6234 36.1237 15.6168 36.0429 15.6128 35.9449C15.6036 35.7277 15.593 35.427 15.5784 35.0601C15.5479 34.3116 15.4976 33.2798 15.4155 32.1459C15.3333 31.012 15.2327 29.9801 15.1505 29.2317C15.1108 28.8661 15.079 28.5694 15.0565 28.3508C15.0459 28.2528 15.0379 28.1733 15.0326 28.1111C15.0262 28.0819 15.0235 28.0521 15.0247 28.0223Z\" fill=\"#263238\"></path><path d=\"M29.9085 21.4575C29.889 21.4824 29.8668 21.505 29.8423 21.525C29.7959 21.5661 29.727 21.627 29.6383 21.7025C29.4581 21.8562 29.1959 22.0721 28.8594 22.3251C28.4683 22.6285 28.0497 22.8946 27.609 23.1199C27.0524 23.3673 26.4544 23.5083 25.8459 23.5358C25.2379 23.5808 24.6272 23.4973 24.0537 23.2907C23.5909 23.1072 23.1812 22.8113 22.8615 22.4297C22.6443 22.1735 22.4828 21.8749 22.3873 21.5528C22.3619 21.4661 22.3433 21.3775 22.3316 21.2879C22.3247 21.257 22.3216 21.2255 22.3224 21.1938C22.3332 21.2234 22.3407 21.2541 22.3449 21.2852C22.3629 21.3747 22.3854 21.4631 22.4124 21.5502C22.5169 21.8637 22.6821 22.1536 22.8986 22.4032C23.219 22.7739 23.6257 23.06 24.0828 23.2364C24.6474 23.4339 25.2467 23.5129 25.8432 23.4682C26.4428 23.4407 27.0322 23.3038 27.5825 23.0642C28.0203 22.843 28.4379 22.5837 28.8303 22.2893C29.1694 22.0416 29.4369 21.831 29.625 21.6853L29.837 21.5171C29.8596 21.4957 29.8835 21.4758 29.9085 21.4575Z\" fill=\"#263238\"></path><g opacity=\"0.3\"><path d=\"M20.1301 27.8064C19.3671 28.3362 19.2743 29.4052 19.232 30.3324C19.0531 34.1394 16.6238 41.4076 15.625 45.0848C18.7697 40.2261 20.6983 33.5672 20.1301 27.8064Z\" fill=\"black\"></path></g><path d=\"M20.339 21.325C20.339 21.325 20.0847 29.5178 19.3826 34.4388C18.6806 39.3598 15.2763 45.8982 15.2763 45.8982L14.7266 44.8213C14.7266 44.8213 16.6075 39.3638 17.4593 34.7845C18.062 31.5511 17.4593 21.8032 17.4593 21.8032C18.3199 21.2739 19.3535 21.1023 20.339 21.325Z\" fill=\"#263238\"></path><path d=\"M18.5306 29.437C18.5121 29.437 18.5558 27.7309 18.63 25.6274C18.7041 23.5238 18.7797 21.819 18.7982 21.8204C18.8167 21.8217 18.773 23.5265 18.6988 25.63C18.6247 27.7335 18.5492 29.4383 18.5306 29.437Z\" fill=\"#455A64\"></path><path d=\"M7.91784 29.9072L7.26479 31.5948C7.26479 31.5948 6.39849 33.3605 6.47002 34.5607C6.54155 35.7608 8.04897 40.1453 11.1062 38.724C14.1635 37.3026 12.6322 34.9925 12.6322 34.9925L11.1963 31.061L8.94442 29.5787C8.85814 29.5217 8.76016 29.4848 8.6577 29.4706C8.55525 29.4565 8.45093 29.4655 8.35242 29.497C8.25391 29.5285 8.16373 29.5818 8.08852 29.6528C8.01331 29.7238 7.95498 29.8107 7.91784 29.9072Z\" fill=\"#00AFA1\"></path><path d=\"M11.5259 25.2181C11.7259 25.483 12.8796 25.1783 13.1419 25.7174C13.2201 25.8628 13.261 26.0253 13.261 26.1903C13.261 26.3554 13.2201 26.5179 13.1419 26.6632C13.2738 26.8298 13.3549 27.0308 13.3755 27.2422C13.3962 27.4536 13.3556 27.6665 13.2585 27.8554C13.3691 28.1048 13.4116 28.379 13.3817 28.6502C13.3377 28.9218 13.2005 29.1696 12.9935 29.3509C13.0186 29.4891 13.0034 29.6316 12.9499 29.7614C12.8964 29.8913 12.8067 30.003 12.6915 30.0834C12.2941 30.3483 11.2424 30.5523 11.2424 30.5523L10.8106 31.3471C10.8106 31.3471 10.2118 32.0094 9.47004 31.7127C8.72825 31.416 8.22754 29.9364 8.22754 29.9364C8.26065 29.747 9.09384 28.368 9.09384 28.368C9.09384 28.368 9.25942 26.3162 9.6237 25.8168C9.98797 25.3174 10.1535 25.2167 10.1535 25.2167C10.1535 25.2167 10.4715 24.5319 10.4715 24.2378C10.4715 23.9438 10.1986 23.0033 10.3628 22.8125C10.5271 22.6218 11.1987 22.7543 11.4927 23.5318C11.7868 24.3094 11.5259 25.2181 11.5259 25.2181Z\" fill=\"#FFDEC7\"></path><path d=\"M13.1034 26.601C13.1034 26.6222 12.706 26.5533 12.2186 26.5506C11.7311 26.548 11.335 26.6116 11.3311 26.5904C11.4125 26.5565 11.4988 26.5355 11.5867 26.5281C12.0052 26.4636 12.4314 26.4663 12.8491 26.5361C12.9367 26.5446 13.0224 26.5665 13.1034 26.601Z\" fill=\"#FFFDF6\"></path><path d=\"M13.1957 27.9561C13.1957 27.9773 12.8222 27.9018 12.3612 27.9018C11.9003 27.9018 11.5294 27.9706 11.5254 27.9495C12.0713 27.7918 12.6511 27.7941 13.1957 27.9561Z\" fill=\"#FFFDF6\"></path><path d=\"M13.1027 29.3244C12.8729 29.4205 12.6272 29.4735 12.3782 29.4807C12.1305 29.5096 11.8796 29.4935 11.6377 29.433C11.6377 29.4132 11.9689 29.4423 12.3729 29.4118C12.7769 29.3814 13.0974 29.3045 13.1027 29.3244Z\" fill=\"#FFFDF6\"></path><path d=\"M12.09 30.3086C11.9961 30.3694 11.8926 30.4142 11.784 30.4411C11.263 30.6038 10.7019 30.5827 10.1945 30.3815C10.0885 30.3453 9.9892 30.292 9.90039 30.2238C10.2474 30.3666 10.615 30.4529 10.9892 30.4795C11.3629 30.4819 11.7346 30.4242 12.09 30.3086Z\" fill=\"#FFFDF6\"></path><path d=\"M12.1021 25.3876C12.1021 25.4101 11.6743 25.3187 11.1444 25.3386C10.6146 25.3585 10.1987 25.4711 10.1934 25.4486C10.2767 25.4058 10.366 25.3758 10.4583 25.3598C10.6816 25.3064 10.9097 25.2758 11.1391 25.2684C11.368 25.2609 11.597 25.2769 11.8227 25.3161C11.9189 25.3258 12.0131 25.3499 12.1021 25.3876Z\" fill=\"#FFFDF6\"></path><path d=\"M12.3332 36.9635C12.3266 36.9635 12.3677 36.8801 12.4259 36.7291C12.5093 36.5157 12.568 36.2935 12.6008 36.0668C12.6509 35.7323 12.6468 35.3919 12.5889 35.0587C12.5187 34.6514 12.3649 34.2631 12.1372 33.9182C11.8961 33.55 11.6272 33.2135 11.4749 32.8506C11.3436 32.5337 11.2502 32.2025 11.1967 31.8637C11.149 31.5763 11.1265 31.3418 11.1119 31.1789C11.1119 31.1047 11.1013 31.0464 11.0973 30.9921C11.0939 30.9706 11.0939 30.9487 11.0973 30.9272C11.1049 30.9477 11.1098 30.969 11.1119 30.9908C11.1119 31.0411 11.1278 31.1021 11.1384 31.1762C11.1609 31.3378 11.1914 31.5736 11.2457 31.8544C11.3034 32.1882 11.3999 32.514 11.5331 32.8254C11.6815 33.1777 11.9464 33.5076 12.1955 33.8851C12.4293 34.2371 12.5851 34.635 12.6525 35.0521C12.7091 35.3919 12.7091 35.7388 12.6525 36.0787C12.6138 36.3068 12.547 36.5292 12.4538 36.741C12.4294 36.7991 12.4015 36.8558 12.3703 36.9105C12.3597 36.9294 12.3473 36.9471 12.3332 36.9635Z\" fill=\"#263238\"></path><g opacity=\"0.3\"><path d=\"M11.1426 30.8861C11.1598 30.9577 11.181 31.0265 11.2035 31.0954V30.8861H11.1426Z\" fill=\"black\"></path></g><g opacity=\"0.3\"><path d=\"M12.4552 33.2559C12.0009 32.5565 11.4591 31.8876 11.2021 31.1007C11.2021 31.7697 11.2339 32.4505 11.5134 33.0546C11.6976 33.452 11.9784 33.7924 12.2128 34.1606C12.4473 34.5289 12.6394 34.9488 12.6102 35.3846C12.5825 35.5372 12.5785 35.6931 12.5983 35.8469C12.6367 35.9979 12.7917 36.1356 12.9374 36.084C12.9889 36.0562 13.0332 36.0166 13.0666 35.9685C13.0999 35.9204 13.1215 35.8651 13.1295 35.8071C13.3573 34.9302 12.948 34.0162 12.4552 33.2559Z\" fill=\"black\"></path></g><path d=\"M33.1155 13.658C32.8121 13.8289 32.4055 13.609 32.2677 13.2898C32.1299 12.9706 32.1948 12.6023 32.2995 12.2698C32.4041 11.9373 32.5485 11.6075 32.5644 11.2671C32.5776 10.9498 32.4883 10.6368 32.3096 10.3743C32.1308 10.1118 31.8723 9.91395 31.5723 9.80999C32.1617 9.3424 32.2107 8.33966 31.6676 7.82305C31.4146 7.578 31.0769 7.44553 30.7828 7.25346C30.6153 7.1417 30.4588 7.01442 30.3152 6.87329C30.5785 6.93802 30.8526 6.94615 31.1192 6.89714C31.3337 6.85033 31.5327 6.74997 31.6979 6.60544C31.863 6.4609 31.9889 6.27689 32.0637 6.07057C32.1333 5.86264 32.1435 5.63943 32.0932 5.42603C32.0429 5.21262 31.934 5.01747 31.7789 4.86251C31.6184 4.71267 31.4162 4.6152 31.199 4.58302C30.9818 4.55085 30.7599 4.58549 30.5629 4.68236C30.1827 4.8837 29.9734 5.29831 29.788 5.68643L29.6158 6.04805C29.0793 5.33805 28.5746 4.60288 27.7481 4.35385C26.997 4.12734 26.1903 4.38035 25.4088 4.32339C24.8392 4.28232 24.2934 4.07568 23.7265 4.01475C23.1596 3.95381 22.5131 4.07303 22.178 4.53533C21.9806 4.80688 21.9131 5.1579 21.7197 5.42812C21.3091 5.98447 20.4229 6.05997 20.0851 6.664C19.8109 7.15411 20.0215 7.77404 19.9036 8.32376C19.7712 8.92249 19.2837 9.35962 18.8797 9.81794C18.4757 10.2763 18.1247 10.9094 18.3498 11.4777C18.5485 11.9771 19.1314 12.246 19.3221 12.7493C19.4546 13.1163 19.3592 13.5242 19.3526 13.9163C19.346 14.3084 19.5023 14.7747 19.8824 14.8634L24.2338 16.0132C25.732 16.6226 27.2805 17.2425 28.8965 17.2398C30.5126 17.2372 32.2412 16.4609 32.8797 14.9747C32.6431 14.9644 32.4193 14.8639 32.2545 14.6939C32.4667 14.5972 32.6544 14.4539 32.8035 14.2745C32.9526 14.0951 33.0592 13.8844 33.1155 13.658Z\" fill=\"#263238\"></path><path d=\"M29.5501 15.0237C29.9091 13.9203 30.2627 12.8076 30.427 11.6591C30.5912 10.5107 30.5594 9.3119 30.1501 8.22438C30.0892 8.0588 29.5673 6.95274 29.3911 6.96996C29.2666 6.98188 29.5885 8.01509 29.5236 8.12371C28.9196 9.16089 28.7553 10.4074 28.852 11.6035C28.9566 12.7659 29.1903 13.913 29.5488 15.0237\" fill=\"#263238\"></path><path d=\"M25.2322 5.18839L24.9673 5.20296C23.6614 5.27304 22.4299 5.83212 21.5175 6.76899C20.6052 7.70586 20.079 8.95184 20.0436 10.2591C19.9761 12.7758 19.882 15.2012 19.9708 16.5471C20.1549 19.3288 23.0174 19.6255 23.0174 19.6255V21.064C23.1406 22.5317 25.0414 22.7953 25.762 22.7317C28.251 22.7317 29.5491 20.6945 29.5491 20.6945L29.6657 10.5915C29.7584 7.68663 28.1437 5.20693 25.2322 5.18839Z\" fill=\"#FFDEC7\"></path><path d=\"M23.0166 19.6268C23.0166 19.6268 24.7797 19.6361 26.5931 18.3591C26.5931 18.3591 25.8169 20.4348 23.0166 20.3328V19.6268Z\" fill=\"#FFFDF6\"></path><path d=\"M21.3242 12.5493C21.3284 12.6533 21.3731 12.7516 21.4489 12.8229C21.5247 12.8942 21.6255 12.933 21.7296 12.9308C21.7809 12.9328 21.8322 12.9244 21.8802 12.9061C21.9283 12.8878 21.9722 12.86 22.0092 12.8244C22.0463 12.7888 22.0759 12.7461 22.0961 12.6989C22.1163 12.6516 22.1268 12.6007 22.1269 12.5493C22.1228 12.4453 22.078 12.3471 22.0022 12.2758C21.9264 12.2044 21.8257 12.1657 21.7216 12.1678C21.6702 12.1659 21.619 12.1743 21.5709 12.1926C21.5229 12.2108 21.479 12.2386 21.4419 12.2742C21.4048 12.3098 21.3753 12.3525 21.3551 12.3998C21.3349 12.4471 21.3244 12.4979 21.3242 12.5493Z\" fill=\"#263238\"></path><path d=\"M20.6992 11.3876C20.7509 11.438 21.041 11.1982 21.4688 11.1757C21.8967 11.1532 22.2239 11.3519 22.2636 11.2962C22.2848 11.2724 22.2292 11.181 22.0874 11.0883C21.8949 10.9699 21.6705 10.914 21.445 10.928C21.2223 10.9392 21.0089 11.0208 20.8357 11.1611C20.7125 11.2697 20.6727 11.3664 20.6992 11.3876Z\" fill=\"#263238\"></path><path d=\"M25.2031 12.5586C25.2073 12.6626 25.252 12.7608 25.3278 12.8322C25.4036 12.9035 25.5044 12.9422 25.6085 12.9401C25.6599 12.9422 25.7112 12.9339 25.7593 12.9157C25.8075 12.8975 25.8514 12.8698 25.8886 12.8341C25.9257 12.7985 25.9552 12.7557 25.9754 12.7083C25.9955 12.661 26.0059 12.61 26.0058 12.5586C26.0017 12.4546 25.9569 12.3564 25.8811 12.285C25.8053 12.2137 25.7046 12.1749 25.6005 12.1771C25.5491 12.1749 25.4978 12.1832 25.4496 12.2014C25.4015 12.2196 25.3575 12.2474 25.3204 12.283C25.2833 12.3187 25.2538 12.3615 25.2336 12.4088C25.2135 12.4562 25.2031 12.5071 25.2031 12.5586Z\" fill=\"#263238\"></path><path d=\"M24.9071 11.336C24.9601 11.3863 25.2502 11.1466 25.6781 11.124C26.1059 11.1015 26.4318 11.3002 26.4729 11.2446C26.4954 11.2207 26.4397 11.1293 26.2967 11.0366C26.1047 10.9182 25.8807 10.8622 25.6556 10.8763C25.4325 10.8878 25.2188 10.9693 25.0449 11.1095C24.927 11.2181 24.882 11.3148 24.9071 11.336Z\" fill=\"#263238\"></path><path d=\"M23.5451 14.7124C23.5451 14.6873 23.2802 14.6555 22.8417 14.6237C22.7318 14.6237 22.6271 14.6025 22.6046 14.5283C22.5891 14.4157 22.6085 14.301 22.6603 14.1998C22.7486 13.9296 22.8417 13.6461 22.9398 13.3494C23.3252 12.1387 23.6021 11.1452 23.5491 11.1307C23.4961 11.1161 23.1517 12.0844 22.7623 13.2951C22.674 13.5936 22.5856 13.8788 22.4973 14.1508C22.436 14.2864 22.4238 14.4391 22.4629 14.5826C22.481 14.6205 22.5075 14.6537 22.5403 14.6798C22.5731 14.706 22.6114 14.7244 22.6523 14.7336C22.7138 14.7461 22.7764 14.7515 22.8391 14.7495C23.2749 14.7495 23.5438 14.7363 23.5451 14.7124Z\" fill=\"#263238\"></path><path d=\"M24.8223 14.9416C24.7521 14.9416 24.776 15.4065 24.3958 15.7576C24.0156 16.1086 23.5176 16.0847 23.5176 16.1549C23.5176 16.1841 23.6328 16.2397 23.8421 16.2344C24.1151 16.2235 24.3755 16.1166 24.5773 15.9324C24.7708 15.7561 24.8881 15.5115 24.9045 15.2502C24.9124 15.0489 24.8541 14.9363 24.8223 14.9416Z\" fill=\"#263238\"></path><path d=\"M24.8361 9.59538C24.8838 9.71062 25.309 9.63247 25.815 9.66559C26.321 9.6987 26.7356 9.81394 26.7966 9.70665C26.8231 9.65499 26.7476 9.54902 26.5767 9.44172C26.3501 9.31583 26.098 9.24292 25.8392 9.22847C25.5804 9.21402 25.3217 9.25839 25.0825 9.35827C24.9024 9.44437 24.8149 9.54107 24.8361 9.59538Z\" fill=\"#263238\"></path><path d=\"M20.8003 9.95701C20.8811 10.0497 21.1699 9.93316 21.5249 9.90932C21.8799 9.88548 22.1872 9.93979 22.2482 9.83382C22.276 9.78216 22.223 9.68811 22.0866 9.60333C21.9062 9.49776 21.6972 9.45143 21.4891 9.47087C21.2805 9.48601 21.0816 9.56511 20.9196 9.69738C20.8003 9.806 20.7646 9.90799 20.8003 9.95701Z\" fill=\"#263238\"></path><path d=\"M29.5469 12.6738C29.5932 12.65 31.4331 12.0036 31.4742 13.9137C31.5153 15.8238 29.5893 15.4715 29.5853 15.4171C29.5813 15.3628 29.5469 12.6738 29.5469 12.6738Z\" fill=\"#FFDEC7\"></path><path d=\"M30.153 14.6806C30.1609 14.6806 30.1874 14.7031 30.2444 14.727C30.3238 14.7593 30.4127 14.7593 30.4921 14.727C30.6934 14.6488 30.8564 14.3296 30.8577 13.9799C30.8592 13.8161 30.8239 13.654 30.7544 13.5057C30.7352 13.4464 30.7019 13.3926 30.6573 13.349C30.6128 13.3054 30.5584 13.2733 30.4987 13.2553C30.4602 13.246 30.4197 13.2504 30.3841 13.2678C30.3485 13.2852 30.3202 13.3146 30.304 13.3507C30.2801 13.405 30.2921 13.4434 30.2828 13.4461C30.2735 13.4487 30.2404 13.4156 30.255 13.3361C30.2639 13.2888 30.2893 13.2461 30.3265 13.2156C30.378 13.1744 30.4438 13.1554 30.5093 13.1626C30.5883 13.1762 30.6625 13.2099 30.7247 13.2604C30.7869 13.311 30.8349 13.3768 30.8643 13.4514C30.9502 13.6149 30.9956 13.7966 30.9968 13.9812C30.9968 14.3654 30.8034 14.731 30.5292 14.8157C30.4782 14.8319 30.4242 14.8364 30.3712 14.8288C30.3182 14.8212 30.2676 14.8018 30.2232 14.772C30.1583 14.7257 30.1464 14.6833 30.153 14.6806Z\" fill=\"#FFFDF6\"></path><path d=\"M21.2353 7.08256C20.924 6.91565 21.8393 5.90231 22.5944 5.54731C23.7362 5.01746 25.486 4.66909 26.5484 4.9552C27.828 5.30093 28.8943 5.92086 29.55 7.07461C30.2057 8.22836 30.4626 9.5755 30.4415 10.9001C30.4415 11.2975 30.3991 11.7267 30.1884 12.0711C29.9235 12.4963 29.4175 12.7692 29.448 13.3507C29.4628 13.5616 29.3943 13.7699 29.2572 13.9309C28.9128 14.3071 28.4797 13.9627 28.2783 13.6156C27.8492 12.8725 27.7909 11.9797 27.7485 11.1227C27.714 10.5133 27.6823 9.89209 27.8465 9.30396C27.9353 8.98472 28.0823 8.6827 28.1538 8.35817C28.2253 8.03364 28.2108 7.66672 28.0055 7.40577C27.9581 7.34953 27.9058 7.29767 27.8492 7.25078C27.5791 7.02094 27.2526 6.86724 26.9033 6.80554C26.5541 6.74384 26.1947 6.77636 25.8622 6.89976C24.7906 7.29714 22.9613 7.8866 22.4765 7.52763C21.7797 7.01103 21.6102 6.6706 21.6102 6.6706L21.2353 7.08256Z\" fill=\"#263238\"></path><path d=\"M26.4455 4.69695C25.3858 4.3605 24.1937 4.39362 23.2201 4.91552C22.7021 5.19237 22.2372 5.63214 22.0849 6.19908C21.9325 6.76602 22.1842 7.46013 22.7313 7.67472L22.7684 7.69724C23.587 7.96216 24.1155 7.8456 24.9248 7.55418C25.6044 7.3078 26.2084 6.87862 26.8893 6.63621C27.6201 6.37867 28.4112 6.34546 29.161 6.54084C28.4192 5.71824 27.4999 5.03473 26.4455 4.69695Z\" fill=\"#263238\"></path><path d=\"M30.0775 6.58587C30.0616 6.60045 29.9079 6.41765 29.598 6.20306C29.4177 6.07683 29.2229 5.97276 29.0178 5.89309C28.7722 5.79134 28.507 5.74607 28.2416 5.76063C27.7556 5.81545 27.2951 6.00647 26.913 6.31168C26.6176 6.54613 26.4811 6.74218 26.4626 6.72893C26.444 6.71569 26.4838 6.67065 26.546 6.5819C26.6363 6.45756 26.7403 6.34381 26.856 6.2428C27.2416 5.90065 27.7248 5.68801 28.2376 5.63479C28.5222 5.61856 28.8067 5.66938 29.0681 5.78315C29.2796 5.87117 29.478 5.98795 29.6576 6.1302C29.9596 6.37128 30.0921 6.57925 30.0775 6.58587Z\" fill=\"#455A64\"></path><path d=\"M30.2687 7.26274C30.2833 7.26274 30.2502 7.4813 30.1244 7.80849C29.7807 8.66469 29.1499 9.37466 28.3401 9.81662C28.1795 9.91699 28.0023 9.98787 27.8169 10.0259C27.7943 9.98882 28.6183 9.67621 29.3124 8.88276C30.0065 8.08931 30.225 7.24552 30.2687 7.26274Z\" fill=\"#455A64\"></path><path d=\"M31.047 7.57269C31.0616 7.64417 31.0643 7.71758 31.055 7.78993C31.0442 7.98758 31.0163 8.18392 30.9715 8.37674C30.8256 9.01973 30.5225 9.61647 30.0892 10.1135C29.656 10.6105 29.1062 10.9923 28.4892 11.2247C28.3043 11.295 28.1137 11.3495 27.9196 11.3876C27.8512 11.4075 27.7801 11.4165 27.709 11.4141C27.709 11.3916 28.0097 11.3386 28.4614 11.1492C29.0513 10.901 29.5768 10.5214 29.9978 10.0394C30.4189 9.55729 30.7242 8.98546 30.8907 8.36747C31.0206 7.88001 31.0206 7.57269 31.047 7.57269Z\" fill=\"#455A64\"></path><path d=\"M24.2646 4.52603C24.2646 4.54723 24.0672 4.59359 23.7586 4.71678C22.9524 5.03637 22.2671 5.60122 21.7994 6.3315C21.6193 6.60967 21.5345 6.80042 21.5146 6.79115C21.5531 6.6116 21.6231 6.44028 21.7213 6.28514C21.9403 5.89809 22.2285 5.55461 22.5717 5.2718C22.9142 4.98873 23.3063 4.77178 23.7281 4.632C23.8988 4.5638 24.0807 4.52787 24.2646 4.52603Z\" fill=\"#455A64\"></path><path d=\"M31.6448 4.76313C31.6766 4.76313 31.5931 5.31683 31.1613 5.82284C30.7294 6.32884 30.2022 6.51562 30.1983 6.48515C30.1943 6.45468 30.6606 6.2295 31.0632 5.74203C31.4659 5.25457 31.6077 4.74989 31.6448 4.76313Z\" fill=\"#455A64\"></path><path d=\"M25.6011 13.7203C25.6011 13.7344 25.5969 13.7482 25.589 13.76C25.5812 13.7718 25.57 13.7809 25.5569 13.7864C25.5438 13.7918 25.5295 13.7932 25.5156 13.7904C25.5017 13.7877 25.489 13.7809 25.479 13.7709C25.469 13.7608 25.4621 13.7481 25.4594 13.7342C25.4566 13.7204 25.458 13.706 25.4635 13.6929C25.4689 13.6798 25.478 13.6687 25.4898 13.6608C25.5016 13.6529 25.5154 13.6487 25.5295 13.6487C25.5485 13.6487 25.5667 13.6563 25.5801 13.6697C25.5935 13.6831 25.6011 13.7013 25.6011 13.7203Z\" fill=\"#FFFDF6\"></path><path d=\"M26.0559 13.7918C26.0954 13.7918 26.1274 13.7598 26.1274 13.7203C26.1274 13.6808 26.0954 13.6487 26.0559 13.6487C26.0164 13.6487 25.9844 13.6808 25.9844 13.7203C25.9844 13.7598 26.0164 13.7918 26.0559 13.7918Z\" fill=\"#FFFDF6\"></path><path d=\"M34.4173 27.1099L26.1953 24.6541C26.0551 24.6122 25.9075 24.6919 25.8656 24.8321L22.4753 36.1828C22.4335 36.323 22.5132 36.4706 22.6534 36.5124L30.8754 38.9682C31.0156 39.0101 31.1632 38.9304 31.205 38.7902L34.5953 27.4395C34.6372 27.2993 34.5575 27.1517 34.4173 27.1099Z\" fill=\"#455A64\"></path><path d=\"M22.905 34.8335C22.7367 34.8013 22.5857 34.7098 22.4792 34.5756C22.3727 34.4414 22.3179 34.2735 22.3248 34.1023C22.336 33.915 22.42 33.7394 22.5589 33.6132C22.6977 33.4869 22.8804 33.4199 23.068 33.4265C23.2555 33.4331 23.4331 33.5127 23.5627 33.6483C23.6924 33.784 23.7639 33.965 23.762 34.1526H23.6296C23.6335 34.0406 23.6053 33.9298 23.5483 33.8333C23.4912 33.7368 23.4078 33.6586 23.3077 33.6081C23.2076 33.5575 23.0952 33.5367 22.9836 33.548C22.8721 33.5594 22.7662 33.6025 22.6783 33.6722C22.5905 33.7419 22.5245 33.8352 22.4881 33.9413C22.4517 34.0473 22.4464 34.1616 22.4729 34.2705C22.4994 34.3794 22.5565 34.4785 22.6376 34.556C22.7186 34.6334 22.8201 34.6861 22.9301 34.7077L22.905 34.8335Z\" fill=\"#263238\"></path><path d=\"M23.2041 33.8586C23.0693 33.8322 22.9448 33.7677 22.8455 33.6728C22.7461 33.5779 22.676 33.4565 22.6435 33.323C22.611 33.1895 22.6174 33.0495 22.6619 32.9195C22.7065 32.7895 22.7873 32.675 22.8949 32.5895C23.0025 32.5041 23.1323 32.4512 23.269 32.4372C23.4057 32.4232 23.5435 32.4486 23.6662 32.5105C23.7889 32.5724 23.8913 32.6681 23.9613 32.7864C24.0313 32.9046 24.0659 33.0404 24.0612 33.1777H23.9287C23.934 33.0993 23.9234 33.0207 23.8977 32.9464C23.872 32.8722 23.8316 32.8038 23.779 32.7455C23.7263 32.6871 23.6625 32.6399 23.5913 32.6067C23.5201 32.5735 23.4429 32.5549 23.3644 32.552C23.2859 32.5492 23.2076 32.5622 23.1341 32.5902C23.0607 32.6182 22.9937 32.6606 22.9369 32.715C22.8802 32.7694 22.835 32.8347 22.804 32.9069C22.773 32.9791 22.7568 33.0568 22.7564 33.1354C22.7505 33.275 22.795 33.412 22.8818 33.5215C22.9687 33.6309 23.092 33.7055 23.2293 33.7314L23.2041 33.8586Z\" fill=\"#263238\"></path><path d=\"M23.499 32.8824C23.3641 32.8559 23.2396 32.7914 23.1402 32.6964C23.0409 32.6014 22.9708 32.48 22.9383 32.3464C22.9059 32.2128 22.9123 32.0728 22.957 31.9428C23.0017 31.8128 23.0827 31.6983 23.1904 31.6129C23.2981 31.5275 23.428 31.4747 23.5648 31.4609C23.7015 31.447 23.8394 31.4727 23.962 31.5347C24.0847 31.5968 24.187 31.6927 24.2568 31.8111C24.3266 31.9295 24.3611 32.0654 24.356 32.2028H24.2236C24.2282 32.0867 24.1982 31.9719 24.1373 31.8729C24.0765 31.7739 23.9876 31.6953 23.8819 31.647C23.7762 31.5987 23.6586 31.583 23.5439 31.6017C23.4293 31.6205 23.3228 31.673 23.238 31.7524C23.1588 31.8259 23.1014 31.9199 23.0722 32.0241C23.0431 32.1282 23.0434 32.2383 23.073 32.3423C23.1026 32.4462 23.1605 32.54 23.2401 32.6131C23.3197 32.6862 23.4181 32.7358 23.5242 32.7565L23.499 32.8824Z\" fill=\"#263238\"></path><path d=\"M23.7949 31.9074C23.66 31.881 23.5355 31.8165 23.4361 31.7215C23.3368 31.6265 23.2667 31.505 23.2342 31.3715C23.2018 31.2379 23.2082 31.0978 23.2529 30.9678C23.2976 30.8378 23.3785 30.7234 23.4863 30.638C23.594 30.5525 23.7239 30.4998 23.8607 30.4859C23.9974 30.4721 24.1353 30.4977 24.2579 30.5598C24.3806 30.6219 24.4829 30.7178 24.5527 30.8362C24.6225 30.9546 24.657 31.0905 24.6519 31.2279H24.5195C24.5234 31.1158 24.4952 31.005 24.4382 30.9085C24.3812 30.812 24.2977 30.7338 24.1976 30.6833C24.0975 30.6327 23.9851 30.6119 23.8735 30.6233C23.762 30.6346 23.6561 30.6777 23.5683 30.7474C23.4804 30.8171 23.4144 30.9105 23.378 31.0165C23.3416 31.1226 23.3363 31.2368 23.3628 31.3457C23.3893 31.4547 23.4465 31.5537 23.5275 31.6312C23.6085 31.7087 23.7101 31.7613 23.8201 31.7829L23.7949 31.9074Z\" fill=\"#263238\"></path><path d=\"M24.0908 30.9325C23.9607 30.907 23.8402 30.8461 23.7426 30.7564C23.6449 30.6668 23.574 30.5519 23.5375 30.4244C23.501 30.297 23.5005 30.1619 23.536 30.0342C23.5715 29.9065 23.6415 29.791 23.7385 29.7006C23.8426 29.6035 23.9732 29.5395 24.1137 29.5166C24.2543 29.4938 24.3984 29.5132 24.5279 29.5723C24.6574 29.6315 24.7664 29.7277 24.8412 29.8489C24.916 29.9701 24.9531 30.1107 24.9479 30.253H24.8154C24.8208 30.0975 24.7642 29.9463 24.6582 29.8326C24.5521 29.7188 24.4052 29.6518 24.2498 29.6463C24.1729 29.6435 24.0962 29.6558 24.0241 29.6826C23.9519 29.7095 23.8858 29.7503 23.8295 29.8027C23.7731 29.8551 23.7277 29.9181 23.6957 29.9881C23.6637 30.0581 23.6458 30.1337 23.6431 30.2106C23.6371 30.3503 23.6816 30.4876 23.7684 30.5973C23.8552 30.7069 23.9786 30.7817 24.116 30.808L24.0908 30.9325Z\" fill=\"#263238\"></path><path d=\"M24.3897 29.9589C24.2596 29.9334 24.139 29.8725 24.0414 29.7828C23.9437 29.6932 23.8728 29.5783 23.8363 29.4508C23.7999 29.3234 23.7993 29.1883 23.8348 29.0606C23.8703 28.9329 23.9404 28.8174 24.0373 28.727C24.1776 28.5975 24.3632 28.5285 24.5539 28.5349C24.6483 28.538 24.7411 28.5597 24.827 28.5987C24.913 28.6378 24.9904 28.6934 25.0548 28.7625C25.1191 28.8316 25.1692 28.9126 25.2022 29.0011C25.2351 29.0896 25.2502 29.1837 25.2467 29.278H25.1142C25.1196 29.1226 25.063 28.9714 24.957 28.8576C24.8509 28.7439 24.704 28.6769 24.5486 28.6714C24.4018 28.6674 24.2589 28.7186 24.148 28.8149C24.0371 28.9112 23.9664 29.0456 23.9498 29.1915C23.9331 29.3374 23.9718 29.4842 24.0581 29.603C24.1445 29.7218 24.2722 29.8039 24.4162 29.8331L24.3897 29.9589Z\" fill=\"#263238\"></path><path d=\"M24.6855 28.9827C24.5103 28.9486 24.3541 28.8507 24.2472 28.7079C24.1402 28.5651 24.0901 28.3877 24.1066 28.2101C24.1231 28.0324 24.205 27.8673 24.3365 27.7467C24.4679 27.626 24.6395 27.5586 24.8179 27.5574H24.8444C25.0349 27.5646 25.2147 27.647 25.3445 27.7865C25.4744 27.9261 25.5436 28.1113 25.5372 28.3018H25.4047C25.41 28.2234 25.3995 28.1447 25.3737 28.0705C25.348 27.9962 25.3077 27.9279 25.255 27.8695C25.2024 27.8112 25.1386 27.764 25.0674 27.7308C24.9961 27.6975 24.919 27.6789 24.8405 27.6761C24.7619 27.6733 24.6836 27.6862 24.6102 27.7142C24.5368 27.7422 24.4697 27.7847 24.413 27.8391C24.3563 27.8935 24.3111 27.9587 24.2801 28.0309C24.2491 28.1031 24.2329 28.1808 24.2324 28.2594C24.2265 28.399 24.271 28.5361 24.3579 28.6455C24.4447 28.755 24.5681 28.8295 24.7053 28.8555L24.6855 28.9827Z\" fill=\"#263238\"></path><path d=\"M24.9815 28.0077C24.8466 27.9813 24.7222 27.9169 24.6228 27.8219C24.5235 27.727 24.4534 27.6056 24.4208 27.4721C24.3883 27.3386 24.3947 27.1986 24.4393 27.0686C24.4838 26.9386 24.5647 26.8241 24.6722 26.7387C24.7798 26.6532 24.9097 26.6003 25.0463 26.5863C25.183 26.5723 25.3209 26.5978 25.4436 26.6596C25.5662 26.7215 25.6686 26.8172 25.7386 26.9355C25.8086 27.0537 25.8433 27.1895 25.8385 27.3269H25.706C25.7103 27.2148 25.6823 27.1038 25.6254 27.0072C25.5685 26.9105 25.4851 26.8321 25.3851 26.7814C25.2851 26.7307 25.1726 26.7097 25.061 26.7209C24.9494 26.7321 24.8434 26.775 24.7554 26.8446C24.6675 26.9143 24.6013 27.0076 24.5648 27.1137C24.5283 27.2197 24.5229 27.334 24.5494 27.443C24.5758 27.552 24.6329 27.6512 24.714 27.7287C24.795 27.8063 24.8966 27.859 25.0066 27.8806L24.9815 28.0077Z\" fill=\"#263238\"></path><path d=\"M25.2783 27.0315C25.1482 27.006 25.0277 26.9451 24.9301 26.8554C24.8324 26.7658 24.7615 26.6509 24.725 26.5234C24.6885 26.3959 24.688 26.2609 24.7235 26.1332C24.759 26.0054 24.829 25.89 24.926 25.7996C25.0301 25.7025 25.1607 25.6384 25.3012 25.6156C25.4418 25.5928 25.5859 25.6122 25.7154 25.6713C25.8449 25.7305 25.9539 25.8267 26.0287 25.9479C26.1035 26.069 26.1406 26.2097 26.1354 26.3519H26.0029C26.0069 26.2399 25.9787 26.1291 25.9216 26.0326C25.8646 25.936 25.7811 25.8579 25.681 25.8073C25.581 25.7568 25.4685 25.736 25.357 25.7473C25.2455 25.7587 25.1395 25.8018 25.0517 25.8715C24.9639 25.9412 24.8979 26.0345 24.8615 26.1406C24.8251 26.2466 24.8198 26.3608 24.8463 26.4698C24.8728 26.5787 24.9299 26.6778 25.0109 26.7553C25.092 26.8327 25.1935 26.8854 25.3035 26.907L25.2783 27.0315Z\" fill=\"#263238\"></path><path d=\"M25.5742 26.0565C25.4441 26.0311 25.3236 25.9701 25.226 25.8805C25.1283 25.7908 25.0573 25.6759 25.0209 25.5485C24.9844 25.421 24.9839 25.2859 25.0194 25.1582C25.0549 25.0305 25.1249 24.915 25.2219 24.8246C25.326 24.7275 25.4566 24.6635 25.5971 24.6407C25.7377 24.6178 25.8818 24.6372 26.0113 24.6964C26.1408 24.7555 26.2498 24.8518 26.3246 24.9729C26.3994 25.0941 26.4365 25.2347 26.4313 25.377H26.2988C26.3028 25.265 26.2746 25.1541 26.2175 25.0576C26.1605 24.9611 26.077 24.8829 25.9769 24.8324C25.8769 24.7819 25.7644 24.761 25.6529 24.7724C25.5414 24.7838 25.4354 24.8268 25.3476 24.8965C25.2598 24.9662 25.1938 25.0596 25.1574 25.1656C25.121 25.2717 25.1157 25.3859 25.1422 25.4948C25.1687 25.6038 25.2258 25.7028 25.3068 25.7803C25.3879 25.8578 25.4894 25.9104 25.5994 25.932L25.5742 26.0565Z\" fill=\"#263238\"></path><path d=\"M22.6085 35.8084C22.4741 35.7813 22.3502 35.7164 22.2515 35.6213C22.1528 35.5262 22.0833 35.4048 22.0512 35.2716C22.0191 35.1383 22.0258 34.9986 22.0705 34.869C22.1152 34.7394 22.1959 34.6252 22.3033 34.54C22.4107 34.4547 22.5402 34.402 22.6766 34.3879C22.8129 34.3738 22.9505 34.3989 23.073 34.4604C23.1956 34.5219 23.298 34.6171 23.3682 34.7348C23.4385 34.8525 23.4736 34.9879 23.4695 35.1249H23.337C23.341 35.0091 23.3106 34.8947 23.2496 34.7961C23.1886 34.6975 23.0999 34.6192 22.9944 34.5711C22.889 34.5229 22.7717 34.507 22.6573 34.5254C22.5429 34.5438 22.4365 34.5957 22.3515 34.6745C22.2723 34.7482 22.215 34.8423 22.1859 34.9465C22.1569 35.0506 22.1571 35.1608 22.1867 35.2648C22.2163 35.3689 22.2741 35.4627 22.3537 35.5359C22.4332 35.6092 22.5315 35.659 22.6376 35.6799L22.6085 35.8084Z\" fill=\"#263238\"></path><path d=\"M23.6091 35.0508C23.7561 34.6759 25.3417 29.0979 26.0663 26.8076C26.1534 26.5581 26.3333 26.3517 26.5687 26.2313C26.804 26.1109 27.0766 26.0858 27.33 26.1612L35.4751 28.5826C35.7121 28.6598 35.9098 28.826 36.0265 29.0463C36.1432 29.2665 36.1697 29.5235 36.1003 29.7629L32.5 42.2342C32.4302 42.4764 32.2681 42.6815 32.0486 42.8053C31.8291 42.9292 31.5698 42.962 31.3264 42.8966L23.0263 40.654C22.9034 40.6206 22.7883 40.5632 22.6878 40.485C22.5872 40.4068 22.5032 40.3095 22.4406 40.1985C22.378 40.0876 22.3381 39.9654 22.3231 39.8389C22.3081 39.7124 22.3184 39.5843 22.3534 39.4618L23.5906 35.1011L23.6091 35.0508Z\" fill=\"white\"></path><path d=\"M26.5153 25.887C26.3573 25.8448 26.1891 25.8656 26.0461 25.9449C25.903 26.0242 25.7963 26.1558 25.7484 26.3122C25.143 28.2991 23.1865 34.6984 23.0408 35.0971L21.5983 39.8247C21.5732 39.906 21.5649 39.9916 21.5738 40.0762C21.5827 40.1608 21.6087 40.2427 21.6501 40.317C21.6916 40.3913 21.7477 40.4564 21.8151 40.5084C21.8825 40.5604 21.9597 40.5982 22.0421 40.6195L30.9846 42.9402C31.1439 42.9816 31.3129 42.9591 31.4559 42.8778C31.5989 42.7964 31.7045 42.6624 31.7503 42.5044L35.646 28.9932C35.6693 28.9127 35.6763 28.8283 35.6666 28.745C35.6568 28.6618 35.6306 28.5813 35.5894 28.5082C35.5482 28.4352 35.4929 28.3711 35.4266 28.3198C35.3604 28.2684 35.2845 28.2308 35.2036 28.209L26.5153 25.887Z\" fill=\"#E0E0E0\"></path><path d=\"M29.8804 29.2436L29.4044 30.8761L29.0933 30.7854L29.2682 30.1857L28.9198 30.0841L28.1577 30.5126L27.7844 30.4037L27.7982 30.3564L28.5 29.9589C28.3332 29.9013 28.2137 29.8143 28.1414 29.6978C28.0697 29.5797 28.0551 29.4476 28.0976 29.3016L28.1056 29.2742C28.1511 29.1183 28.2408 29.0112 28.3748 28.9531C28.5109 28.8938 28.6727 28.8915 28.8601 28.9461L29.8804 29.2436ZM29.4881 29.4316L28.7863 29.227C28.6901 29.199 28.6105 29.1973 28.5474 29.2222C28.4849 29.2453 28.443 29.2934 28.4217 29.3664L28.4137 29.3938C28.3924 29.4668 28.4017 29.5307 28.4415 29.5855C28.4818 29.6386 28.5501 29.6792 28.6463 29.7073L29.348 29.9119L29.4881 29.4316Z\" fill=\"#9D9D9D\"></path><path d=\"M28.6068 32.1453C28.6678 32.1953 28.709 32.2523 28.7305 32.3164C28.7524 32.379 28.7528 32.4467 28.7316 32.5192L28.7245 32.5437C28.7003 32.6266 28.6569 32.6927 28.5943 32.742C28.5332 32.7917 28.4577 32.8219 28.3678 32.8326C28.2779 32.8434 28.1796 32.8332 28.073 32.8021L27.1775 32.541L27.6025 31.0835L28.4535 31.3316C28.6209 31.3804 28.7408 31.4515 28.8132 31.545C28.8875 31.6373 28.9072 31.7435 28.8722 31.8635L28.8651 31.888C28.8262 32.0213 28.7401 32.1071 28.6068 32.1453ZM27.8077 31.4133L27.706 31.7621L28.277 31.9286C28.3615 31.9533 28.4276 31.9581 28.4753 31.9431C28.5246 31.9285 28.5572 31.8938 28.5732 31.839L28.5803 31.8146C28.5958 31.7612 28.586 31.715 28.5508 31.6758C28.5176 31.6356 28.4609 31.6038 28.381 31.5804L27.8077 31.4133ZM28.452 32.4281C28.468 32.3733 28.4591 32.3265 28.4254 32.2877C28.3922 32.2475 28.3326 32.2148 28.2467 32.1898L27.6334 32.011L27.5278 32.3732L28.1411 32.552C28.2211 32.5753 28.2876 32.5786 28.3407 32.5619C28.3942 32.5438 28.4289 32.5073 28.4449 32.4525L28.452 32.4281Z\" fill=\"#9D9D9D\"></path><path d=\"M29.6292 31.6744L29.2042 33.132L28.9265 33.051L29.3515 31.5934L29.6292 31.6744Z\" fill=\"#9D9D9D\"></path><path d=\"M31.4946 33.7998L31.2191 33.7195L31.5372 32.6285L30.6836 33.5633L30.397 33.4798L30.1809 32.2282L29.8615 33.3236L29.586 33.2433L30.011 31.7857L30.4021 31.8998L30.6328 33.2086L31.5286 32.2282L31.9196 32.3423L31.4946 33.7998Z\" fill=\"#9D9D9D\"></path><g clip-path=\"url(#clip0_78_4927)\"><path d=\"M30.9786 31.3688L30.884 31.2139C30.5473 30.6654 30.3252 30.3027 30.4229 29.9676C30.503 29.693 30.7805 29.5415 31.0542 29.6213C31.2089 29.6664 31.3363 29.7817 31.4003 29.9228C31.5301 29.8382 31.6995 29.8095 31.8541 29.8546C32.1279 29.9344 32.2805 30.2113 32.2004 30.4859C32.1027 30.821 31.7204 31.0075 31.1417 31.2891L30.9786 31.3688Z\" fill=\"#9D9D9D\"></path></g><path d=\"M26.5159 25.887L26.6484 25.9175L27.0179 26.0128L28.434 26.3824L33.653 27.7693L34.4981 27.9945L34.9352 28.111L35.1564 28.1707C35.2348 28.1871 35.31 28.2162 35.379 28.2568C35.5206 28.3424 35.6251 28.4781 35.6717 28.6369C35.6955 28.7167 35.7036 28.8004 35.6956 28.8833C35.6838 28.9648 35.6647 29.045 35.6386 29.1231L35.3657 30.0728C34.9948 31.3604 34.6001 32.7366 34.1828 34.1792C33.7656 35.6217 33.3285 37.1477 32.8741 38.724C32.648 39.5117 32.4171 40.3131 32.1813 41.1282C32.0648 41.5353 31.9469 41.945 31.8277 42.3574L31.7826 42.5124C31.7663 42.5667 31.7431 42.6188 31.7137 42.6674C31.6551 42.7655 31.572 42.8467 31.4727 42.9032C31.3216 42.9879 31.1437 43.0112 30.9759 42.9681L30.8183 42.927L25.9026 41.6487L23.566 41.0407L22.4334 40.7453L22.1539 40.6725C22.0572 40.6532 21.9636 40.6207 21.8757 40.5758C21.7888 40.5264 21.7143 40.4579 21.6576 40.3755C21.6009 40.2932 21.5637 40.1991 21.5485 40.1003C21.5339 40.0024 21.5407 39.9025 21.5684 39.8075C21.5962 39.7188 21.624 39.6287 21.6505 39.5426L21.8135 39.0127C21.9208 38.6617 22.0267 38.3147 22.1314 37.9742L22.7394 35.9873L23.8401 32.424C24.5157 30.2477 25.0615 28.4872 25.4403 27.2686C25.5357 26.9639 25.6191 26.6937 25.6933 26.4592C25.7201 26.3485 25.762 26.242 25.8178 26.1427C25.8698 26.0625 25.9396 25.9954 26.0218 25.9466C26.1325 25.8798 26.261 25.8483 26.3901 25.8565C26.435 25.8588 26.4796 25.8668 26.5225 25.8804C26.5225 25.8804 26.4801 25.8698 26.3901 25.8645C26.2633 25.8593 26.1378 25.8921 26.0298 25.9585C25.9507 26.0074 25.8837 26.0735 25.8337 26.1519C25.7795 26.2506 25.7389 26.3562 25.7132 26.4659L25.4668 27.2765C25.0932 28.4965 24.5541 30.2596 23.8878 32.4426C23.554 33.5314 23.1871 34.7262 22.795 36.0072C22.5999 36.6483 22.3985 37.3106 22.191 37.9941C22.0868 38.3358 21.9813 38.6825 21.8744 39.0339C21.8201 39.2088 21.7671 39.3863 21.7128 39.5638C21.685 39.6525 21.6585 39.7426 21.6307 39.8287C21.6053 39.9146 21.599 40.005 21.6121 40.0936C21.6258 40.183 21.6596 40.2681 21.711 40.3424C21.7624 40.4168 21.8301 40.4784 21.9088 40.5228C21.9926 40.5648 22.0817 40.5952 22.1738 40.6129L22.4533 40.6857L23.5871 40.9798L25.9238 41.5865L30.8395 42.8634C30.9397 42.8968 31.044 42.9168 31.1494 42.923C31.2522 42.9232 31.3532 42.8966 31.4426 42.846C31.532 42.7954 31.6067 42.7224 31.6594 42.6343C31.7072 42.5412 31.7428 42.4423 31.7654 42.3402C31.8846 41.9282 32.0025 41.5176 32.1204 41.1109C32.3553 40.2976 32.5862 39.4967 32.8132 38.7081C33.2688 37.1331 33.7073 35.6124 34.1259 34.1646C34.5445 32.7168 34.9419 31.3418 35.318 30.0583L35.5922 29.1085C35.6173 29.0338 35.6359 28.9572 35.6479 28.8793C35.6548 28.8032 35.6476 28.7264 35.6267 28.6528C35.5846 28.5075 35.4903 28.3829 35.3618 28.3031C35.2967 28.2653 35.226 28.2381 35.1525 28.2223L34.9313 28.1627L34.4941 28.0461L33.649 27.8183L28.4366 26.4102L27.0193 26.0248L26.6523 25.9214C26.5596 25.9016 26.5159 25.887 26.5159 25.887Z\" fill=\"#263238\"></path><g opacity=\"0.3\"><path d=\"M27.1569 39.0035L21.8584 38.5955C21.926 38.9929 22.2333 39.3042 22.5869 39.4843C22.95 39.6474 23.336 39.7538 23.7314 39.7996L25.5316 40.0989C25.7608 40.1374 26.0032 40.1811 26.174 40.3387C26.3449 40.4963 26.4217 40.7718 26.5648 40.9772C26.8019 41.3136 27.2271 41.4527 27.6245 41.5693C29.1841 42.0433 30.7674 42.4355 32.368 42.7442C32.8117 42.825 33.2727 42.8966 33.7125 42.7893C34.1523 42.682 34.5682 42.3548 34.6397 41.9084L27.1569 39.0035Z\" fill=\"black\"></path></g><path d=\"M26.8885 26.1175C26.9057 26.1175 25.903 29.3761 24.6472 33.3844C23.3915 37.3927 22.3596 40.6367 22.3411 40.6314C22.3225 40.6262 23.3266 37.3715 24.5823 33.3632C25.8381 29.3549 26.87 26.1096 26.8885 26.1175Z\" fill=\"#263238\"></path><path d=\"M27.9104 35.1978C27.9104 35.1978 26.6017 33.4546 26.1288 33.0585C25.6559 32.6625 23.6955 32.9791 23.6955 32.9791L22.8451 33.8745C22.8451 33.8745 23.012 34.5554 23.8067 34.2189L24.0279 34.052H24.9366L25.5009 34.7143L23.7339 34.6772C23.7339 34.6772 22.8636 34.1116 22.6649 34.1116C22.4662 34.1116 21.9893 34.4944 22.3351 35.1713C22.3351 35.1713 21.6728 35.3846 21.9019 36.2867C21.9019 36.2867 21.3469 36.439 21.8529 37.508L21.9165 37.6298C21.9165 37.6298 21.3363 37.9054 21.7178 38.516C22.0993 39.1267 23.0623 39.3108 23.3524 39.2949C23.6425 39.279 28.8655 40.0486 28.8655 40.0486L30.2762 36.3794L27.9104 35.1978Z\" fill=\"#FFDEC7\"></path><path d=\"M23.9529 36.0892C23.8597 36.1024 23.7649 36.0979 23.6734 36.076C23.2213 35.9988 22.8086 35.771 22.5024 35.4296C22.4354 35.3634 22.3807 35.2858 22.3408 35.2004C22.7531 35.6818 23.3258 35.9976 23.9529 36.0892Z\" fill=\"#FFFDF6\"></path><path d=\"M23.115 37.2629C23.0327 37.2553 22.9526 37.2319 22.8792 37.194C22.5099 37.0414 22.1893 36.7909 21.9519 36.4694C21.8988 36.4068 21.8576 36.3349 21.8301 36.2575C22.007 36.4692 22.2005 36.6663 22.4089 36.847C22.632 37.0055 22.8682 37.1446 23.115 37.2629Z\" fill=\"#FFFDF6\"></path><path d=\"M23.1178 38.3266C22.8727 38.2994 22.6366 38.2184 22.4264 38.0895C22.2052 37.9804 22.0104 37.8244 21.8555 37.6325C21.87 37.6166 22.1098 37.8391 22.4595 38.0299C22.8092 38.2206 23.1231 38.3041 23.1178 38.3266Z\" fill=\"#FFFDF6\"></path><path d=\"M41.0668 37.5265L35.3908 36.6429L28.7186 35.3819L27.1582 40.6274C27.1582 40.6274 35.1325 42.9654 37.3168 43.2528C39.6508 43.5601 40.5555 43.2528 41.2907 41.7189C41.7649 40.7413 41.4721 38.7796 41.0668 37.5265Z\" fill=\"#00AFA1\"></path><path d=\"M35.7786 42.9522C35.7642 42.9513 35.75 42.9486 35.7363 42.9442L35.6117 42.9137L35.1309 42.7892L33.3347 42.315L27.1474 40.6592L27.1143 40.6513L27.1249 40.6182C27.4361 39.5704 27.7726 38.4378 28.1196 37.2669L28.6839 35.3726L28.6932 35.3422L28.7237 35.3488L36.0316 36.7953L38.1908 37.2311L38.7723 37.3503L38.922 37.3834L38.9723 37.3967C38.9551 37.3981 38.9379 37.3981 38.9207 37.3967L38.7697 37.3702L38.1855 37.2616L36.0224 36.847L28.7104 35.4217L28.7488 35.3978C28.5687 36.0071 28.3793 36.6443 28.1859 37.292C27.8375 38.4643 27.4997 39.5969 27.1884 40.6433L27.1646 40.6023L33.3453 42.2779L35.1362 42.7707L35.6144 42.9031L35.7376 42.9389L35.7786 42.9522Z\" fill=\"#263238\"></path><defs><clipPath id=\"clip0_78_4927\"><rect width=\"2.22183\" height=\"2.22183\" fill=\"white\" transform=\"translate(30.4658 29.1604) rotate(16.256)\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "f7d7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".user-avatar[data-v-53a3d001]{width:42px;height:42px;border-radius:50%;overflow:hidden;-o-object-fit:cover;object-fit:cover;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:12px;background-color:#e8edff;line-height:1.5;letter-spacing:.2px;font-size:18px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f848":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("69b5");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3efc3b46", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fa97":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("46f6");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("621929d6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimHeader/bimHeader.vue?vue&type=template&id=bde68a26&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{ref:"header",staticClass:"bim-header"},[_c('bim-top-banner-line'),_c('bim-container',[_c('div',{staticClass:"bim-header-content head-flex",class:{ w100: _vm.w100 }},[_c('div',{staticClass:"head-flex-auto"},[_c('div',{staticClass:"bim-logo",domProps:{"innerHTML":_vm._s(__webpack_require__("6369"))},on:{"click":_vm.logoClicked}})]),_c('HeadLinks',{staticClass:"link-group-wrp",attrs:{"links":_vm.headerLinks,"headerLinkTarget":_vm.headerLinkTarget,"logActionEvent":_vm.logActionEvent}}),(_vm.$slots.left)?_c('div',{staticClass:"head-flex-auto"},[_vm._t("left")],2):_vm._e(),_c('div',{staticClass:"head-flex-item flex-grow-1"}),(_vm.$slots.right)?_c('div',{staticClass:"head-flex-auto"},[_vm._t("right")],2):_vm._e(),_c('div',{staticClass:"head-flex-auto flex-grow-0 phone-wrp"},[_c('a',{staticClass:"head-tel",attrs:{"href":"tel:88005002575"},on:{"click":function($event){return _vm.logActionEvent('headerClickPhone')}}},[_c('div',{staticClass:"head-tel__icon",domProps:{"innerHTML":_vm._s(__webpack_require__("7a08"))}}),_vm._v(" 8 800 500-25-75 ")])]),(_vm.user && _vm.showNotices)?_c('bimNotices',{staticClass:"notice-wrp",attrs:{"apiHost":_vm.apiHost,"user":_vm.user,"logActionEvent":_vm.logActionEvent},on:{"updateContext":_vm.updateContext}}):_vm._e(),(_vm.user)?_c('div',{staticClass:"head-flex-auto user-info",class:{opened: _vm.show.userMenu},on:{"mouseover":function($event){_vm.show.userMenu=true},"mouseleave":function($event){_vm.show.userMenu=false},"click":function($event){_vm.show.userMenu=!_vm.show.userMenu}}},[_c('div',{staticClass:"head-flex-auto"},[_c('Avatar',{attrs:{"user":_vm.user,"imgHost":_vm.imgHost}})],1),_c('div',{staticClass:"arrow-down",class:{ up: _vm.show.userMenu }}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show.userMenu),expression:"show.userMenu"}],staticClass:"user-menu-wrp",on:{"click":function($event){$event.stopPropagation();},"mouseleave":function($event){_vm.show.userMenu=false}}},[(_vm.showMenuItem('home'))?_c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.menuItemClicked('home')}}},[_c('div',{staticClass:"flex-grow-1 menu-text"},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.personalAccount', _vm.activeLang))+" ")])]):_vm._e(),(_vm.showMenuItem('models'))?_c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.menuItemClicked('models')}}},[_c('div',{staticClass:"flex-grow-1 menu-text"},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.models', _vm.activeLang))+" ")])]):_vm._e(),(_vm.showMenuItem('contacts'))?_c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.menuItemClicked('contacts')}}},[_c('div',{staticClass:"flex-grow-1 menu-text"},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.contacts', _vm.activeLang))+" ")])]):_vm._e(),(_vm.showMenuItem('statistics'))?_c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.menuItemClicked('statistics')}}},[_c('div',{staticClass:"flex-grow-1 menu-text"},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.statistics', _vm.activeLang))+" ")])]):_vm._e(),(_vm.showMenuItem('logout'))?_c('div',{staticClass:"menu-item d-flex",on:{"click":function($event){return _vm.menuItemClicked('logout')}}},[_c('div',{staticClass:"flex-grow-0 menu-icon",domProps:{"innerHTML":_vm._s(__webpack_require__("03d2"))}}),_c('div',{staticClass:"flex-grow-1 menu-text"},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.logout', _vm.activeLang))+" ")])]):_vm._e()])]):_c('div',{staticClass:"head-flex-auto login-wrp",on:{"click":_vm.loginClicked}},[_c('span',{staticClass:"login-wrp__text"},[_c('span',{staticClass:"login-wrp__icon",domProps:{"innerHTML":_vm._s(__webpack_require__("4ffb"))}}),_vm._v(" "+_vm._s(_vm.$bimTranslate('header.login', _vm.activeLang))+" ")]),_c('i',{staticClass:"login-wrp__icon"})]),_c('div',{staticClass:"hamburger",on:{"click":_vm.handleMobileMenu}})],1),(_vm.show.mobileMenu)?_c('MobileMenu',{attrs:{"user":_vm.user,"links":_vm.headerLinks,"headerLinkTarget":_vm.headerLinkTarget,"activeLang":_vm.activeLang,"makeChangeLanguage":_vm.makeChangeLanguage,"imgHost":_vm.imgHost,"handleMobileMenu":_vm.handleMobileMenu},on:{"login-clicked":_vm.loginClicked,"change-lang":_vm.changeLang,"menuItemClicked":_vm.menuItemClicked,"socialLinkClick":_vm.socialLinkClick}}):_vm._e()],1)],1),_c('div',{style:(("height: " + _vm.headerHeight + "px"))})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/bimHeader/bimHeader.vue?vue&type=template&id=bde68a26&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/MobileMenu.vue?vue&type=template&id=259f4f5f&scoped=true&
var MobileMenuvue_type_template_id_259f4f5f_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-menu"},[_c('div',{staticClass:"container p-9"},[_c('div',{staticClass:"row mobile_header"},[_c('span',{staticClass:"mobile_header__menu-text"},[_vm._v(_vm._s(_vm.$bimTranslate('header.menu', _vm.activeLang)))]),_c('div',{staticClass:"mobile-menu__close",on:{"click":_vm.handleMobileMenu}})]),_c('div',{staticClass:"row mobile_lk mx-0 my-9"},[_c('div',{staticClass:"d-flex justify-center flex-column align-self-center posr dropdown profile-block w-100 h-100"},[(!_vm.user)?_c('div',{staticClass:"mobile-menu__wrp"},[_c('a',{staticClass:"mobile-menu__button-top login open-modal login-btn",attrs:{"id":"open-button"},on:{"click":function($event){return _vm.$emit('login-clicked')}}},[_c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.$bimTranslate('header.login', _vm.activeLang)))])])]):_c('div',[_c('a',{staticClass:"nav-link user_auth align-center d-flex w-100",attrs:{"href":"https://lk.bimlib.pro/","rel":"nofollow"}},[_c('div',{staticClass:"pr-4 ava-block--mobile"},[_c('Avatar',{attrs:{"user":_vm.user,"imgHost":_vm.imgHost}})],1),_c('div',{staticClass:"mobile-profile"},[_c('div',{staticClass:"mobile-profile__name"},[_vm._v(" "+_vm._s(_vm.userInitials)+" ")]),_c('span',{staticClass:"mobile-profile__messages"},[(_vm.user.count_new_message)?_c('span',[_vm._v(" "+_vm._s(_vm.user.count_new_message)+" "+_vm._s(_vm.messageCountText)+" ")]):_c('span',[_vm._v(_vm._s(_vm.$bimTranslate('header.noNewMessages', _vm.activeLang)))])])])]),_c('ul',{staticClass:"profile-list"},[_c('li',{staticClass:"profile-list__item pt-6",on:{"click":function($event){return _vm.menuItemClicked('home')}}},[_c('div',{staticClass:"pSmall",attrs:{"href":"","rel":"nofollow"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.personalAccount', _vm.activeLang))+" ")])]),_c('li',{staticClass:"profile-list__item pt-3",on:{"click":function($event){return _vm.menuItemClicked('messages')}}},[_c('div',{staticClass:"pSmall",attrs:{"href":"","rel":"nofollow"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.messages', _vm.activeLang))+" ")])]),_c('li',{staticClass:"profile-list__item pt-3",on:{"click":function($event){return _vm.menuItemClicked('models')}}},[_c('div',{staticClass:"pSmall",attrs:{"href":"","rel":"nofollow"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.models', _vm.activeLang))+" ")])]),_c('li',{staticClass:"profile-list__item pt-3",on:{"click":function($event){return _vm.menuItemClicked('statistic')}}},[_c('div',{staticClass:"pSmall",attrs:{"href":"","rel":"nofollow"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.contacts', _vm.activeLang))+" ")])]),_c('li',{staticClass:"profile-list__item pt-6",on:{"click":function($event){return _vm.menuItemClicked('logout')}}},[_c('div',{staticClass:"pSmall op05",attrs:{"href":"","rel":"nofollow"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('header.logout', _vm.activeLang))+" ")])])])])])]),_c('MobileHeadLinks',{attrs:{"links":_vm.links,"headerLinkTarget":_vm.headerLinkTarget}}),_vm._m(0),_c('SocialLinks',{staticStyle:{"margin-top":"30px","justify-content":"space-between"}})],1)])}
var MobileMenuvue_type_template_id_259f4f5f_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mobile_contact mx-0"},[_c('ul',{staticClass:"contacts-list w-100"},[_c('li',{staticClass:"contacts-item mb-3"},[_c('a',{staticClass:"contacts-link fw-bold",attrs:{"href":"tel:88005002575","rel":"nofollow"}},[_vm._v("8 800 500-25-75")])]),_c('li',{staticClass:"contacts-item mb-3"},[_c('a',{staticClass:"contacts-link fw-bold",attrs:{"href":"tel:+74954452575","rel":"nofollow"}},[_vm._v("+7 495 445-25-75")])])])])}]


// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileMenu.vue?vue&type=template&id=259f4f5f&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/Avatar.vue?vue&type=template&id=53a3d001&scoped=true&lang=html&
var Avatarvue_type_template_id_53a3d001_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.user.avatar)?_c('img',{staticClass:"user-avatar",attrs:{"src":_vm.avaSrc}}):(_vm.user)?_c('div',{staticClass:"user-avatar"},[_vm._v(_vm._s(_vm.user.firstName && _vm.user.firstName[0])+_vm._s(_vm.user.lastName && _vm.user.lastName[0]))]):_vm._e()}
var Avatarvue_type_template_id_53a3d001_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimHeader/Avatar.vue?vue&type=template&id=53a3d001&scoped=true&lang=html&

// CONCATENATED MODULE: ./src/enums/enum.js
/* harmony default export */ var enums_enum = ({
  eachExcludes: ['eachExcludes'],
  name: function name(value) {
    var name = null;
    this.each(function (val, item) {
      if (val === value) {
        name = item;
        return false;
      }
      return true;
    });
    return name;
  },
  each: function each(callback) {
    for (var item in this) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.hasOwnProperty(item)) {
        if (typeof this[item] !== 'function' && this.eachExcludes.indexOf(item) < 0) {
          if (callback.call(this, this[item], item) === false) {
            break;
          }
        }
      }
    }
  },
  values: function values() {
    var values = [];
    this.each(function (v) {
      return values.push(v);
    });
    return values;
  },
  title: function title(value) {
    return this.name(value);
  },
  options: function options(empty) {
    var _this = this;
    if (empty === void 0) {
      empty = false;
    }
    var options = [];
    if (empty) {
      options.push({
        value: 0,
        label: ''
      });
    }
    this.each(function (val) {
      options.push({
        value: val,
        label: _this.title(val)
      });
    });
    return options;
  }
});
// CONCATENATED MODULE: ./src/enums/avatars.js

/* harmony default export */ var avatars = (Object.assign({}, enums_enum, {
  Avatar1: 1,
  Avatar2: 2,
  Avatar3: 3,
  Avatar4: 4,
  Avatar5: 5,
  Avatar6: 6,
  Avatar7: 7,
  Avatar8: 8,
  Avatar9: 9,
  Avatar10: 10,
  Avatar11: 11,
  Avatar12: 12,
  Avatar13: 13,
  Avatar14: 14,
  Avatar15: 15,
  icon: function icon(value) {
    switch (+value) {
      case this.Avatar1:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava1.png';
      case this.Avatar2:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava2.png';
      case this.Avatar3:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava3.png';
      case this.Avatar4:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava4.png';
      case this.Avatar5:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava5.png';
      case this.Avatar6:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava6.png';
      case this.Avatar7:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava7.png';
      case this.Avatar8:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava8.png';
      case this.Avatar9:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava9.png';
      case this.Avatar10:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava10.png';
      case this.Avatar11:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava11.png';
      case this.Avatar12:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava12.png';
      case this.Avatar13:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava13.png';
      case this.Avatar14:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava14.png';
      case this.Avatar15:
        return 'https://ui.bimlib.ru/src/assets/avatar/ava15.png';
    }
    return '';
  }
}));
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/Avatar.vue?vue&type=script&lang=js&
//
//
//
//
//


/* harmony default export */ var Avatarvue_type_script_lang_js_ = ({
  name: 'Avatar',
  props: {
    /**
     * Объект пользователя
     * user { avatar: String, count_new_message: Number, firstName: String, lastName: String }
     */
    user: Object,
    imgHost: {
      type: String,
      default: ''
    }
  },
  computed: {
    isEmoji: function isEmoji() {
      return !!avatars[this.user.avatar];
    },
    avaSrc: function avaSrc() {
      return this.isEmoji ? avatars.icon(avatars[this.user.avatar]) : "" + this.imgHost + this.user.avatar;
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimHeader/Avatar.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimHeader_Avatarvue_type_script_lang_js_ = (Avatarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimHeader/Avatar.vue?vue&type=style&index=0&id=53a3d001&prod&lang=scss&scoped=true&
var Avatarvue_type_style_index_0_id_53a3d001_prod_lang_scss_scoped_true_ = __webpack_require__("2fa6");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/core/bimHeader/Avatar.vue






/* normalize component */

var Avatar_component = normalizeComponent(
  bimHeader_Avatarvue_type_script_lang_js_,
  Avatarvue_type_template_id_53a3d001_scoped_true_lang_html_render,
  Avatarvue_type_template_id_53a3d001_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "53a3d001",
  null
  
)

/* harmony default export */ var Avatar = (Avatar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/social-links.vue?vue&type=template&id=404268a4&scoped=true&
var social_linksvue_type_template_id_404268a4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socs"},_vm._l((_vm.links),function(item){return _c('a',_vm._b({key:item.title,domProps:{"innerHTML":_vm._s(__webpack_require__("bb27")("./" + (item.title) + "-green.svg"))}},'a',item,false))}),0)}
var social_linksvue_type_template_id_404268a4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/social-links.vue?vue&type=template&id=404268a4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/social-links.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var social_linksvue_type_script_lang_js_ = ({
  name: 'SocialLinks',
  data: function data() {
    return {
      links: [{
        href: 'https://vk.com/bimlib',
        target: '_blank',
        title: 'vk'
      }, {
        href: 'https://t.me/bimlib_pro',
        target: '_blank',
        title: 'telegram'
      }, {
        href: 'https://www.youtube.com/channel/UCIVQgYmqw8cXDJlDd_2S_6w',
        target: '_blank',
        title: 'youtube'
      }, {
        href: 'https://dzen.ru/bimlib',
        target: '_blank',
        title: 'dzen'
      }]
    };
  }
});
// CONCATENATED MODULE: ./src/components/core/social-links.vue?vue&type=script&lang=js&
 /* harmony default export */ var core_social_linksvue_type_script_lang_js_ = (social_linksvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/social-links.vue?vue&type=style&index=0&id=404268a4&prod&lang=scss&scoped=true&
var social_linksvue_type_style_index_0_id_404268a4_prod_lang_scss_scoped_true_ = __webpack_require__("3645");

// CONCATENATED MODULE: ./src/components/core/social-links.vue






/* normalize component */

var social_links_component = normalizeComponent(
  core_social_linksvue_type_script_lang_js_,
  social_linksvue_type_template_id_404268a4_scoped_true_render,
  social_linksvue_type_template_id_404268a4_scoped_true_staticRenderFns,
  false,
  null,
  "404268a4",
  null
  
)

/* harmony default export */ var social_links = (social_links_component.exports);
// CONCATENATED MODULE: ./src/utils/helpers.js
function declOfNum(number, titles) {
  var cases = [2, 0, 1, 1, 1, 2];
  return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
}
function getMainDomain(link) {
  return link.split('.').slice(-2).join('.');
}
function getValue(object, value, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = null;
  }
  var result = defaultValue;
  if (typeof value === 'undefined') {
    return result;
  }
  function isObject(value) {
    return value && typeof value === 'object';
  }
  if (!isObject(object)) {
    return result;
  }
  var innerGetValue = function innerGetValue(object, value) {
    if (!isObject(object)) {
      return null;
    }
    return object[value] || null;
  };
  var keys = value.split('.');
  result = object;
  for (var i in keys) {
    // eslint-disable-next-line no-prototype-builtins
    if (keys.hasOwnProperty(i)) {
      result = innerGetValue(result, keys[i]);
      if (result === null) {
        result = defaultValue;
        break;
      }
    }
  }
  return result;
}
function forEach(listItems, callback) {
  for (var key in listItems) {
    // eslint-disable-next-line no-prototype-builtins
    if (listItems.hasOwnProperty(key)) {
      if (callback(listItems[key], key) === false) {
        break;
      }
    }
  }
}
function isObject(value) {
  return value !== null && typeof value === 'object';
}
function isFunction(value) {
  return typeof value === 'function';
}
function isNil(value) {
  return typeof value === 'undefined' || value === null;
}
function isEmpty(value) {
  if (typeof value === 'string') {
    return String(value).trim().length === 0;
  }
  return isNil(value);
}

/*
 * сортировка
 * extractor - название колонки (если это массив объектов)
 * reverse - default=false сортировать в обратном порядке
 * */
function sort(array, extractor, reverse) {
  if (!Array.isArray(array)) {
    return array;
  }
  extractor = extractor || null;
  reverse = reverse || false;
  var sort = function sort(sArray, sReverse) {
    var data = sArray.slice().sort(function (a, b) {
      return a - b;
    });
    if (sReverse) {
      data = data.reverse();
    }
    return data;
  };
  var sortWithExtractor = function sortWithExtractor(eArray, element, eReverse) {
    var data = eArray.slice().sort(function (i, ii) {
      if (i[element] > ii[element]) {
        return 1;
      } else if (i[element] < ii[element]) {
        return -1;
      }
      return 0;
    });
    if (eReverse) {
      data = data.reverse();
    }
    return data;
  };
  if (extractor) {
    return sortWithExtractor(array, extractor, reverse);
  }
  return sort(array, reverse);
}

/*
 * сортировка
 * extractor - название колонки (если это массив объектов)
 * reverse - default=false сортировать в обратном порядке
 * */
function sortByString(items, extractor, reverse) {
  if (reverse === void 0) {
    reverse = false;
  }
  return items.sort(function (a, b) {
    return reverse ? b[extractor].localeCompare(a[extractor]) : a[extractor].localeCompare(b[extractor]);
  });
}

/**
 * Синхронный враппер try/catch
 *
 * @param {Function} func
 * @param {Function} errorHandler
 * @returns
 */
var tryWrapper = function tryWrapper(func, errorHandler) {
  if (errorHandler === void 0) {
    errorHandler = function errorHandler() {};
  }
  var res;
  try {
    res = func();
  } catch (e) {
    errorHandler(e);
  }
  return res;
};

/**
 * pick object
 * @param {Object} obj
 * @param {Array|String} props
 */
function pick(obj, props) {
  if (!isObject(obj)) return {};
  if (!Array.isArray(props)) {
    props = [props];
  }
  var res = {};
  props.forEach(function (prop) {
    if (prop in obj) {
      res[prop] = obj[prop];
    }
  });
  return res;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/MobileHeadLinks.vue?vue&type=template&id=4ae5571b&scoped=true&
var MobileHeadLinksvue_type_template_id_4ae5571b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"head_links_mobile",staticClass:"d-flex flex-column head-links",on:{"click":_vm.onClick}},[_c('MobileHeadLink',{attrs:{"links":_vm.links,"headerLinkTarget":_vm.headerLinkTarget}})],1)}
var MobileHeadLinksvue_type_template_id_4ae5571b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileHeadLinks.vue?vue&type=template&id=4ae5571b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/MobileHeadLink.vue?vue&type=template&id=63ada184&scoped=true&
var MobileHeadLinkvue_type_template_id_63ada184_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column mobile-menu__links"},[_vm._l((_vm.headLinks),function(link){return [(!link.separator)?_c('a',_vm._b({key:link.name},'a',link,false),[_c('div',{staticClass:"d-flex cursor-pointer"},[_c('span',{domProps:{"innerHTML":_vm._s(link.name)}})]),_c('div',{staticClass:"link-group__inner--mobile"},[_c('MobileHeadLink',{attrs:{"data-head-link":link.name,"links":link.links,"headerLinkTarget":_vm.headerLinkTarget}})],1)]):_vm._e()]})],2)}
var MobileHeadLinkvue_type_template_id_63ada184_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileHeadLink.vue?vue&type=template&id=63ada184&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/MobileHeadLink.vue?vue&type=script&lang=js&
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var MobileHeadLinkvue_type_script_lang_js_ = ({
  name: 'MobileHeadLink',
  props: {
    links: Array,
    headerLinkTarget: String
  },
  computed: {
    headLinks: function headLinks() {
      var _this = this;
      return this.links.map(function (link) {
        var _link = _extends({
          target: _this.headerLinkTarget,
          'data-head-link': link.name,
          'data-head-link-list': !!_this.isAdditionalLinks(link)
        }, link, {
          class: 'link-group--mobile' + (link.class ? " " + link.class : '')
        });
        if (link.url) {
          _link.href = link.url;
        }
        return _link;
      });
    }
  },
  methods: {
    isAdditionalLinks: function isAdditionalLinks(link) {
      return link.links && link.links.length;
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileHeadLink.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimHeader_MobileHeadLinkvue_type_script_lang_js_ = (MobileHeadLinkvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimHeader/MobileHeadLink.vue?vue&type=style&index=0&id=63ada184&prod&lang=scss&scoped=true&
var MobileHeadLinkvue_type_style_index_0_id_63ada184_prod_lang_scss_scoped_true_ = __webpack_require__("bf52");

// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileHeadLink.vue






/* normalize component */

var MobileHeadLink_component = normalizeComponent(
  bimHeader_MobileHeadLinkvue_type_script_lang_js_,
  MobileHeadLinkvue_type_template_id_63ada184_scoped_true_render,
  MobileHeadLinkvue_type_template_id_63ada184_scoped_true_staticRenderFns,
  false,
  null,
  "63ada184",
  null
  
)

/* harmony default export */ var MobileHeadLink = (MobileHeadLink_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/MobileHeadLinks.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//


/* harmony default export */ var MobileHeadLinksvue_type_script_lang_js_ = ({
  components: {
    MobileHeadLink: MobileHeadLink
  },
  name: 'MobileHeadLinks',
  props: {
    /**
     * link - String
     * name - String
     * links - links[]
     */
    links: Array,
    headerLinkTarget: String
  },
  methods: {
    findEl: function findEl(target) {
      var overEl = target.dataset.headLink;
      var links = this.$refs.head_links_mobile.querySelectorAll('[data-head-link]');
      var link = [].filter.call(links, function (el) {
        return el.dataset.headLink === overEl;
      })[1];
      return link;
    },
    onClick: function onClick(event) {
      var target = event.target.closest('a');
      var link = this.findEl(target);
      var droplist = target.querySelector('.icon-droplist--mobile svg');
      if (!droplist) return;
      var title = target.firstChild;
      event.preventDefault();
      if (link.dataset.show && link.dataset.show === 'true') {
        title.style.opacity = 1;
        link.dataset.show = false;
        link.style.setProperty('display', 'none', 'important');
        droplist && (droplist.style.transform = 'none');
      } else {
        title.style.opacity = 0.5;
        link.dataset.show = true;
        link.style.setProperty('display', 'flex', 'important');
        droplist && (droplist.style.transform = 'rotate(-180deg)');
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileHeadLinks.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimHeader_MobileHeadLinksvue_type_script_lang_js_ = (MobileHeadLinksvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimHeader/MobileHeadLinks.vue?vue&type=style&index=0&id=4ae5571b&prod&lang=scss&scoped=true&
var MobileHeadLinksvue_type_style_index_0_id_4ae5571b_prod_lang_scss_scoped_true_ = __webpack_require__("2235");

// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileHeadLinks.vue






/* normalize component */

var MobileHeadLinks_component = normalizeComponent(
  bimHeader_MobileHeadLinksvue_type_script_lang_js_,
  MobileHeadLinksvue_type_template_id_4ae5571b_scoped_true_render,
  MobileHeadLinksvue_type_template_id_4ae5571b_scoped_true_staticRenderFns,
  false,
  null,
  "4ae5571b",
  null
  
)

/* harmony default export */ var MobileHeadLinks = (MobileHeadLinks_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/MobileMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import ChangeLang from './ChangeLang'

/* harmony default export */ var MobileMenuvue_type_script_lang_js_ = ({
  components: {
    // ChangeLang,
    MobileHeadLinks: MobileHeadLinks,
    Avatar: Avatar,
    SocialLinks: social_links
  },
  props: {
    user: Object,
    links: Array,
    headerLinkTarget: String,
    activeLang: String,
    makeChangeLanguage: Boolean,
    imgHost: String,
    handleMobileMenu: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  },
  methods: {
    menuItemClicked: function menuItemClicked(val) {
      this.$emit('menuItemClicked', val);
    }
  },
  computed: {
    messageCountText: function messageCountText() {
      return declOfNum(this.user.count_new_message, ['новое сообщение', 'новых сообщения', 'новых сообщений']);
    },
    userInitials: function userInitials() {
      var _this$user = this.user,
        firstName = _this$user.firstName,
        lastName = _this$user.lastName;
      var initials = firstName;
      if (lastName) {
        initials += " " + lastName + ".";
      }
      return initials;
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimHeader_MobileMenuvue_type_script_lang_js_ = (MobileMenuvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimHeader/MobileMenu.vue?vue&type=style&index=0&id=259f4f5f&prod&lang=scss&scoped=true&
var MobileMenuvue_type_style_index_0_id_259f4f5f_prod_lang_scss_scoped_true_ = __webpack_require__("9db1");

// CONCATENATED MODULE: ./src/components/core/bimHeader/MobileMenu.vue






/* normalize component */

var MobileMenu_component = normalizeComponent(
  bimHeader_MobileMenuvue_type_script_lang_js_,
  MobileMenuvue_type_template_id_259f4f5f_scoped_true_render,
  MobileMenuvue_type_template_id_259f4f5f_scoped_true_staticRenderFns,
  false,
  null,
  "259f4f5f",
  null
  
)

/* harmony default export */ var MobileMenu = (MobileMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/HeadLinks.vue?vue&type=template&id=58b578b4&scoped=true&
var HeadLinksvue_type_template_id_58b578b4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"head_links",staticClass:"head_links"},[_c('div',{staticClass:"head-flex"},[_vm._l((_vm.links),function(link){return [(!link.separator)?_c('HeadLink',{key:link.name,attrs:{"data-head-link":link.name,"headerLinkTarget":_vm.headerLinkTarget,"link":link},on:{"click":_vm.handlerCLick}}):_c('div',{key:link.name,staticClass:"separator"})]})],2)])}
var HeadLinksvue_type_template_id_58b578b4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimHeader/HeadLinks.vue?vue&type=template&id=58b578b4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/HeadLink.vue?vue&type=template&id=c3ede230&scoped=true&
var HeadLinkvue_type_template_id_c3ede230_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-link",class:_vm.link.class},[_c('a',_vm._b({on:{"click":function($event){return _vm.$emit('click', _vm.link)}}},'a',_vm.linkAttrs(_vm.link),false),[_c('div',{staticClass:"head-flex align-center"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.link.name)}}),(_vm.link.links && _vm.link.links.length)?_c('i',{staticClass:"icon-droplist",domProps:{"innerHTML":_vm._s(__webpack_require__("dc34"))}}):_vm._e()])]),_c('div',{staticClass:"menu-child"},_vm._l((_vm.link.links),function(child){return _c('a',_vm._b({key:child.name,domProps:{"innerHTML":_vm._s(child.name)},on:{"click":function($event){return _vm.$emit('click', _vm.link)}}},'a',_vm.linkAttrs(child),false))}),0)])}
var HeadLinkvue_type_template_id_c3ede230_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimHeader/HeadLink.vue?vue&type=template&id=c3ede230&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/HeadLink.vue?vue&type=script&lang=js&
function HeadLinkvue_type_script_lang_js_extends() { HeadLinkvue_type_script_lang_js_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return HeadLinkvue_type_script_lang_js_extends.apply(this, arguments); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HeadLinkvue_type_script_lang_js_ = ({
  name: 'HeadLink',
  props: {
    link: Object,
    headerLinkTarget: String
  },
  methods: {
    linkAttrs: function linkAttrs(link) {
      var _link = HeadLinkvue_type_script_lang_js_extends({
        target: this.headerLinkTarget,
        'data-head-link': link.name
      }, link, {
        class: 'link-group' + (link.class ? " " + link.class : '')
      });
      if (link.url) {
        _link.href = link.url;
      }
      return _link;
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimHeader/HeadLink.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimHeader_HeadLinkvue_type_script_lang_js_ = (HeadLinkvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimHeader/HeadLink.vue?vue&type=style&index=0&id=c3ede230&prod&lang=scss&scoped=true&
var HeadLinkvue_type_style_index_0_id_c3ede230_prod_lang_scss_scoped_true_ = __webpack_require__("824e");

// CONCATENATED MODULE: ./src/components/core/bimHeader/HeadLink.vue






/* normalize component */

var HeadLink_component = normalizeComponent(
  bimHeader_HeadLinkvue_type_script_lang_js_,
  HeadLinkvue_type_template_id_c3ede230_scoped_true_render,
  HeadLinkvue_type_template_id_c3ede230_scoped_true_staticRenderFns,
  false,
  null,
  "c3ede230",
  null
  
)

/* harmony default export */ var HeadLink = (HeadLink_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimHeader/HeadLinks.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var HeadLinksvue_type_script_lang_js_ = ({
  name: 'HeadLinks',
  components: {
    HeadLink: HeadLink
  },
  props: {
    /**
     * link - String
     * name - String
     * links - links[]
     */
    links: Array,
    headerLinkTarget: String,
    logActionEvent: {
      type: Function,
      default: function _default() {}
    }
  },
  methods: {
    handlerCLick: function handlerCLick(link) {
      if (link.eventName) {
        this.logActionEvent(link.eventName);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimHeader/HeadLinks.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimHeader_HeadLinksvue_type_script_lang_js_ = (HeadLinksvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimHeader/HeadLinks.vue?vue&type=style&index=0&id=58b578b4&prod&lang=scss&scoped=true&
var HeadLinksvue_type_style_index_0_id_58b578b4_prod_lang_scss_scoped_true_ = __webpack_require__("460b");

// CONCATENATED MODULE: ./src/components/core/bimHeader/HeadLinks.vue






/* normalize component */

var HeadLinks_component = normalizeComponent(
  bimHeader_HeadLinksvue_type_script_lang_js_,
  HeadLinksvue_type_template_id_58b578b4_scoped_true_render,
  HeadLinksvue_type_template_id_58b578b4_scoped_true_staticRenderFns,
  false,
  null,
  "58b578b4",
  null
  
)

/* harmony default export */ var HeadLinks = (HeadLinks_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/grid/bimContainer/bimContainer.vue?vue&type=template&id=7f28c32a&scoped=true&
var bimContainervue_type_template_id_7f28c32a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"bim-container",class:{'bim-container--fluid': _vm.fluid},attrs:{"id":_vm.id}},[_vm._t("default")],2)}
var bimContainervue_type_template_id_7f28c32a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/grid/bimContainer/bimContainer.vue?vue&type=template&id=7f28c32a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/grid/bimContainer/bimContainer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimContainervue_type_script_lang_js_ = ({
  name: 'bimContainer',
  props: {
    /**
     * Делает контейнер шириной 100% на всех размерах
     */
    fluid: Boolean,
    /**
     * Добавляет контейнеру id
     */
    id: String,
    /**
     * Какой тег будет у контейнера
     */
    tag: {
      type: String,
      default: 'div'
    }
  }
});
// CONCATENATED MODULE: ./src/components/grid/bimContainer/bimContainer.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimContainer_bimContainervue_type_script_lang_js_ = (bimContainervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/grid/bimContainer/bimContainer.vue?vue&type=style&index=0&id=7f28c32a&prod&lang=scss&scoped=true&
var bimContainervue_type_style_index_0_id_7f28c32a_prod_lang_scss_scoped_true_ = __webpack_require__("4cb0");

// CONCATENATED MODULE: ./src/components/grid/bimContainer/bimContainer.vue






/* normalize component */

var bimContainer_component = normalizeComponent(
  bimContainer_bimContainervue_type_script_lang_js_,
  bimContainervue_type_template_id_7f28c32a_scoped_true_render,
  bimContainervue_type_template_id_7f28c32a_scoped_true_staticRenderFns,
  false,
  null,
  "7f28c32a",
  null
  
)

/* harmony default export */ var bimContainer = (bimContainer_component.exports);
// CONCATENATED MODULE: ./src/components/core/translate.plugin/enumLang.js
var enumLang = {
  ru: 'ru',
  eng: 'en'
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimNotices/bimNotices.vue?vue&type=template&id=3252723b&scoped=true&
var bimNoticesvue_type_template_id_3252723b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"notices",staticClass:"notices"},[_c('div',{staticClass:"notices__icon-wrapper",on:{"click":_vm.openNotificationsList}},[_c('div',{staticClass:"notices__icon-image",class:{ active: _vm.showList },domProps:{"innerHTML":_vm._s(__webpack_require__("ff67"))}}),(_vm.hasUnseenNotifications)?_c('div',{staticClass:"notices__icon-dot"}):_vm._e()]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList || _vm.forceShow),expression:"showList || forceShow"}],staticClass:"notices__list-wrapper list"},[_c('div',{staticClass:"notices__list-header"},[_c('bim-text',{staticClass:"list__count px-9",attrs:{"type":"medium","bold":""}},[_vm._v(" "+_vm._s(_vm.noticesCountText)+" ")]),_c('div',{staticClass:"management-buttons pt-6 px-9"},[_c('bim-checkbox',{staticClass:"management-buttons__checkbox mr-2",attrs:{"id":"checkAll"},on:{"input":_vm.setCheckToAllNotices},model:{value:(_vm.checkAll),callback:function ($$v) {_vm.checkAll=$$v},expression:"checkAll"}}),_c('bim-button',{staticClass:"management-buttons__button management-buttons__button--primary mr-6",attrs:{"label":"Пометить как прочитанное","outline":"","disabled":!_vm.countCheckedNotices},on:{"click":_vm.seeAllCheckedNotifications}}),_c('bim-button',{staticClass:"management-buttons__button management-buttons__button--gray",attrs:{"label":"Удалить","color":"gray","disabled":!_vm.countCheckedNotices},on:{"click":_vm.deleteAllCheckedNotifications}})],1)],1),(!_vm.noticesList.length)?_c('div',{staticClass:"py-6"}):_vm._e(),_c('div',{staticClass:"list__wrapper"},_vm._l((_vm.sortedNoticesList),function(notice){return _c('div',{key:notice.id,staticClass:"list__item",class:{ seen: notice.seenAt }},[_c('bimCheckbox',{staticClass:"pl-9",attrs:{"id":notice.id},on:{"click":function($event){$event.stopPropagation();},"input":_vm.checkForAllNotices},model:{value:(notice.check),callback:function ($$v) {_vm.$set(notice, "check", $$v)},expression:"notice.check"}}),_c(_vm.getNoticeComponent(notice).is,_vm._g(_vm._b({tag:"component",staticClass:"list__item-content pr-9"},'component',_vm.getNoticeComponent(notice).bind,false),_vm.getNoticeComponent(notice).listeners),[_c('bim-text',{staticClass:"list__item-title",attrs:{"type":"medium","bold":""}},[_vm._v(_vm._s(notice.title))]),(notice.text)?_c('bim-text',{staticClass:"list__item-description mt-2",attrs:{"type":"medium"}},[_vm._v(_vm._s(notice.text))]):_vm._e(),_c('div',{staticClass:"list__item-bottom mt-2"},[_c('bim-text',{staticClass:"list__item-time",attrs:{"type":"small"}},[_vm._v(_vm._s(_vm._f("noticeCorrectDate")(notice.createdAt)))])],1)],1),_c('div',{staticClass:"list__item-delete",domProps:{"innerHTML":_vm._s(__webpack_require__("7d47"))},on:{"click":function($event){return _vm.deleteNotice(notice)}}})],1)}),0)])])}
var bimNoticesvue_type_template_id_3252723b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/bimNotices/bimNotices.vue?vue&type=template&id=3252723b&scoped=true&

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("2ef0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimText/bimText.vue?vue&type=template&id=cf81baf6&scoped=true&lang=html&
var bimTextvue_type_template_id_cf81baf6_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.textComponent,{tag:"component",attrs:{"bold":_vm.bold,"adaptive":_vm.adaptive,"tag":_vm.tag}},[_vm._t("default")],2)}
var bimTextvue_type_template_id_cf81baf6_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimText/bimText.vue?vue&type=template&id=cf81baf6&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH1/bimTextH1.vue?vue&type=template&id=3d31d668&scoped=true&lang=html&
var bimTextH1vue_type_template_id_3d31d668_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text__title"},[_c(_vm.tag,{tag:"component",class:{ text__inner: true, bold: _vm.bold }},[_vm._t("default")],2)],1)}
var bimTextH1vue_type_template_id_3d31d668_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextH1/bimTextH1.vue?vue&type=template&id=3d31d668&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH1/bimTextH1.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimTextH1vue_type_script_lang_js_ = ({
  name: 'bimTextH1',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'h1'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextH1/bimTextH1.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextH1_bimTextH1vue_type_script_lang_js_ = (bimTextH1vue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextH1/bimTextH1.vue?vue&type=style&index=0&id=3d31d668&prod&lang=scss&scoped=true&
var bimTextH1vue_type_style_index_0_id_3d31d668_prod_lang_scss_scoped_true_ = __webpack_require__("43b2");

// CONCATENATED MODULE: ./src/components/text/bimTextH1/bimTextH1.vue






/* normalize component */

var bimTextH1_component = normalizeComponent(
  bimTextH1_bimTextH1vue_type_script_lang_js_,
  bimTextH1vue_type_template_id_3d31d668_scoped_true_lang_html_render,
  bimTextH1vue_type_template_id_3d31d668_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "3d31d668",
  null
  
)

/* harmony default export */ var bimTextH1 = (bimTextH1_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH2/bimTextH2.vue?vue&type=template&id=037e675e&scoped=true&lang=html&
var bimTextH2vue_type_template_id_037e675e_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text__title"},[_c(_vm.tag,{tag:"component",class:{ text__inner: true, bold: _vm.bold }},[_vm._t("default")],2)],1)}
var bimTextH2vue_type_template_id_037e675e_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextH2/bimTextH2.vue?vue&type=template&id=037e675e&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH2/bimTextH2.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimTextH2vue_type_script_lang_js_ = ({
  name: 'bimTextH2',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'h2'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextH2/bimTextH2.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextH2_bimTextH2vue_type_script_lang_js_ = (bimTextH2vue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextH2/bimTextH2.vue?vue&type=style&index=0&id=037e675e&prod&lang=scss&scoped=true&
var bimTextH2vue_type_style_index_0_id_037e675e_prod_lang_scss_scoped_true_ = __webpack_require__("f4d0");

// CONCATENATED MODULE: ./src/components/text/bimTextH2/bimTextH2.vue






/* normalize component */

var bimTextH2_component = normalizeComponent(
  bimTextH2_bimTextH2vue_type_script_lang_js_,
  bimTextH2vue_type_template_id_037e675e_scoped_true_lang_html_render,
  bimTextH2vue_type_template_id_037e675e_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "037e675e",
  null
  
)

/* harmony default export */ var bimTextH2 = (bimTextH2_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH3/bimTextH3.vue?vue&type=template&id=10e92476&scoped=true&lang=html&
var bimTextH3vue_type_template_id_10e92476_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text__title"},[_c(_vm.tag,{tag:"component",class:{ text__inner: true, bold: _vm.bold }},[_vm._t("default")],2)],1)}
var bimTextH3vue_type_template_id_10e92476_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextH3/bimTextH3.vue?vue&type=template&id=10e92476&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH3/bimTextH3.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimTextH3vue_type_script_lang_js_ = ({
  name: 'bimTextH3',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'h3'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextH3/bimTextH3.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextH3_bimTextH3vue_type_script_lang_js_ = (bimTextH3vue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextH3/bimTextH3.vue?vue&type=style&index=0&id=10e92476&prod&lang=scss&scoped=true&
var bimTextH3vue_type_style_index_0_id_10e92476_prod_lang_scss_scoped_true_ = __webpack_require__("3ad2");

// CONCATENATED MODULE: ./src/components/text/bimTextH3/bimTextH3.vue






/* normalize component */

var bimTextH3_component = normalizeComponent(
  bimTextH3_bimTextH3vue_type_script_lang_js_,
  bimTextH3vue_type_template_id_10e92476_scoped_true_lang_html_render,
  bimTextH3vue_type_template_id_10e92476_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "10e92476",
  null
  
)

/* harmony default export */ var bimTextH3 = (bimTextH3_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH4/bimTextH4.vue?vue&type=template&id=5505cf98&scoped=true&lang=html&
var bimTextH4vue_type_template_id_5505cf98_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text__title"},[_c(_vm.tag,{tag:"component",class:{ text__inner: true, bold: _vm.bold }},[_vm._t("default")],2)],1)}
var bimTextH4vue_type_template_id_5505cf98_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextH4/bimTextH4.vue?vue&type=template&id=5505cf98&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH4/bimTextH4.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimTextH4vue_type_script_lang_js_ = ({
  name: 'bimTextH4',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'h4'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextH4/bimTextH4.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextH4_bimTextH4vue_type_script_lang_js_ = (bimTextH4vue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextH4/bimTextH4.vue?vue&type=style&index=0&id=5505cf98&prod&lang=scss&scoped=true&
var bimTextH4vue_type_style_index_0_id_5505cf98_prod_lang_scss_scoped_true_ = __webpack_require__("20be");

// CONCATENATED MODULE: ./src/components/text/bimTextH4/bimTextH4.vue






/* normalize component */

var bimTextH4_component = normalizeComponent(
  bimTextH4_bimTextH4vue_type_script_lang_js_,
  bimTextH4vue_type_template_id_5505cf98_scoped_true_lang_html_render,
  bimTextH4vue_type_template_id_5505cf98_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "5505cf98",
  null
  
)

/* harmony default export */ var bimTextH4 = (bimTextH4_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH5/bimTextH5.vue?vue&type=template&id=4a4f2161&scoped=true&lang=html&
var bimTextH5vue_type_template_id_4a4f2161_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text__title"},[_c(_vm.tag,{tag:"component",class:{ text__inner: true, bold: _vm.bold, adaptive: _vm.adaptive }},[_vm._t("default")],2)],1)}
var bimTextH5vue_type_template_id_4a4f2161_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextH5/bimTextH5.vue?vue&type=template&id=4a4f2161&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextH5/bimTextH5.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimTextH5vue_type_script_lang_js_ = ({
  name: 'bimTextH5',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'h5'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextH5/bimTextH5.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextH5_bimTextH5vue_type_script_lang_js_ = (bimTextH5vue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextH5/bimTextH5.vue?vue&type=style&index=0&id=4a4f2161&prod&lang=scss&scoped=true&
var bimTextH5vue_type_style_index_0_id_4a4f2161_prod_lang_scss_scoped_true_ = __webpack_require__("2d7a");

// CONCATENATED MODULE: ./src/components/text/bimTextH5/bimTextH5.vue






/* normalize component */

var bimTextH5_component = normalizeComponent(
  bimTextH5_bimTextH5vue_type_script_lang_js_,
  bimTextH5vue_type_template_id_4a4f2161_scoped_true_lang_html_render,
  bimTextH5vue_type_template_id_4a4f2161_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "4a4f2161",
  null
  
)

/* harmony default export */ var bimTextH5 = (bimTextH5_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextAccent/bimTextAccent.vue?vue&type=template&id=5a5d6fc5&scoped=true&lang=html&
var bimTextAccentvue_type_template_id_5a5d6fc5_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__accent",class:{ bold: _vm.bold, adaptive: _vm.adaptive }},[_vm._t("default")],2)}
var bimTextAccentvue_type_template_id_5a5d6fc5_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextAccent/bimTextAccent.vue?vue&type=template&id=5a5d6fc5&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextAccent/bimTextAccent.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextAccentvue_type_script_lang_js_ = ({
  name: 'bimTextAccent',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextAccent/bimTextAccent.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextAccent_bimTextAccentvue_type_script_lang_js_ = (bimTextAccentvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextAccent/bimTextAccent.vue?vue&type=style&index=0&id=5a5d6fc5&prod&lang=scss&scoped=true&
var bimTextAccentvue_type_style_index_0_id_5a5d6fc5_prod_lang_scss_scoped_true_ = __webpack_require__("3905");

// CONCATENATED MODULE: ./src/components/text/bimTextAccent/bimTextAccent.vue






/* normalize component */

var bimTextAccent_component = normalizeComponent(
  bimTextAccent_bimTextAccentvue_type_script_lang_js_,
  bimTextAccentvue_type_template_id_5a5d6fc5_scoped_true_lang_html_render,
  bimTextAccentvue_type_template_id_5a5d6fc5_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "5a5d6fc5",
  null
  
)

/* harmony default export */ var bimTextAccent = (bimTextAccent_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMain/bimTextMain.vue?vue&type=template&id=7355df6c&scoped=true&lang=html&
var bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__main",class:{ bold: _vm.bold, adaptive: _vm.adaptive }},[_vm._t("default")],2)}
var bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextMain/bimTextMain.vue?vue&type=template&id=7355df6c&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMain/bimTextMain.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextMainvue_type_script_lang_js_ = ({
  name: 'bimTextMain',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextMain/bimTextMain.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextMain_bimTextMainvue_type_script_lang_js_ = (bimTextMainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextMain/bimTextMain.vue?vue&type=style&index=0&id=7355df6c&prod&lang=scss&scoped=true&
var bimTextMainvue_type_style_index_0_id_7355df6c_prod_lang_scss_scoped_true_ = __webpack_require__("93ff");

// CONCATENATED MODULE: ./src/components/text/bimTextMain/bimTextMain.vue






/* normalize component */

var bimTextMain_component = normalizeComponent(
  bimTextMain_bimTextMainvue_type_script_lang_js_,
  bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_render,
  bimTextMainvue_type_template_id_7355df6c_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "7355df6c",
  null
  
)

/* harmony default export */ var bimTextMain = (bimTextMain_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=template&id=0f65208b&scoped=true&lang=html&
var bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__medium",class:{ bold: _vm.bold }},[_vm._t("default")],2)}
var bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=template&id=0f65208b&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextMediumvue_type_script_lang_js_ = ({
  name: 'bimTextMedium',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextMedium_bimTextMediumvue_type_script_lang_js_ = (bimTextMediumvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue?vue&type=style&index=0&id=0f65208b&prod&lang=scss&scoped=true&
var bimTextMediumvue_type_style_index_0_id_0f65208b_prod_lang_scss_scoped_true_ = __webpack_require__("054a");

// CONCATENATED MODULE: ./src/components/text/bimTextMedium/bimTextMedium.vue






/* normalize component */

var bimTextMedium_component = normalizeComponent(
  bimTextMedium_bimTextMediumvue_type_script_lang_js_,
  bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_render,
  bimTextMediumvue_type_template_id_0f65208b_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "0f65208b",
  null
  
)

/* harmony default export */ var bimTextMedium = (bimTextMedium_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextDesc/bimTextDesc.vue?vue&type=template&id=521d930c&scoped=true&lang=html&
var bimTextDescvue_type_template_id_521d930c_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__desc",class:{ bold: _vm.bold }},[_vm._t("default")],2)}
var bimTextDescvue_type_template_id_521d930c_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextDesc/bimTextDesc.vue?vue&type=template&id=521d930c&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextDesc/bimTextDesc.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextDescvue_type_script_lang_js_ = ({
  name: 'bimTextDesc',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextDesc/bimTextDesc.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextDesc_bimTextDescvue_type_script_lang_js_ = (bimTextDescvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextDesc/bimTextDesc.vue?vue&type=style&index=0&id=521d930c&prod&lang=scss&scoped=true&
var bimTextDescvue_type_style_index_0_id_521d930c_prod_lang_scss_scoped_true_ = __webpack_require__("756c");

// CONCATENATED MODULE: ./src/components/text/bimTextDesc/bimTextDesc.vue






/* normalize component */

var bimTextDesc_component = normalizeComponent(
  bimTextDesc_bimTextDescvue_type_script_lang_js_,
  bimTextDescvue_type_template_id_521d930c_scoped_true_lang_html_render,
  bimTextDescvue_type_template_id_521d930c_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "521d930c",
  null
  
)

/* harmony default export */ var bimTextDesc = (bimTextDesc_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextHint/bimTextHint.vue?vue&type=template&id=46b016bf&scoped=true&lang=html&
var bimTextHintvue_type_template_id_46b016bf_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__hint",class:{ bold: _vm.bold }},[_vm._t("default")],2)}
var bimTextHintvue_type_template_id_46b016bf_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextHint/bimTextHint.vue?vue&type=template&id=46b016bf&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextHint/bimTextHint.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextHintvue_type_script_lang_js_ = ({
  name: 'bimTextHint',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextHint/bimTextHint.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextHint_bimTextHintvue_type_script_lang_js_ = (bimTextHintvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextHint/bimTextHint.vue?vue&type=style&index=0&id=46b016bf&prod&lang=scss&scoped=true&
var bimTextHintvue_type_style_index_0_id_46b016bf_prod_lang_scss_scoped_true_ = __webpack_require__("8b55");

// CONCATENATED MODULE: ./src/components/text/bimTextHint/bimTextHint.vue






/* normalize component */

var bimTextHint_component = normalizeComponent(
  bimTextHint_bimTextHintvue_type_script_lang_js_,
  bimTextHintvue_type_template_id_46b016bf_scoped_true_lang_html_render,
  bimTextHintvue_type_template_id_46b016bf_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "46b016bf",
  null
  
)

/* harmony default export */ var bimTextHint = (bimTextHint_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextSmall/bimTextSmall.vue?vue&type=template&id=438fb726&scoped=true&lang=html&
var bimTextSmallvue_type_template_id_438fb726_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"text__small",class:{ bold: _vm.bold }},[_vm._t("default")],2)}
var bimTextSmallvue_type_template_id_438fb726_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/text/bimTextSmall/bimTextSmall.vue?vue&type=template&id=438fb726&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimTextSmall/bimTextSmall.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var bimTextSmallvue_type_script_lang_js_ = ({
  name: 'bimTextSmall',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimTextSmall/bimTextSmall.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTextSmall_bimTextSmallvue_type_script_lang_js_ = (bimTextSmallvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/text/bimTextSmall/bimTextSmall.vue?vue&type=style&index=0&id=438fb726&prod&lang=scss&scoped=true&
var bimTextSmallvue_type_style_index_0_id_438fb726_prod_lang_scss_scoped_true_ = __webpack_require__("8dfd");

// CONCATENATED MODULE: ./src/components/text/bimTextSmall/bimTextSmall.vue






/* normalize component */

var bimTextSmall_component = normalizeComponent(
  bimTextSmall_bimTextSmallvue_type_script_lang_js_,
  bimTextSmallvue_type_template_id_438fb726_scoped_true_lang_html_render,
  bimTextSmallvue_type_template_id_438fb726_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "438fb726",
  null
  
)

/* harmony default export */ var bimTextSmall = (bimTextSmall_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/text/bimText/bimText.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//












/* harmony default export */ var bimTextvue_type_script_lang_js_ = ({
  name: 'bimText',
  props: {
    /**
     * Размерность шрифта
     * @values h1, h2, h3, h4, h5, accent, main, medium, desc, hint, small
     */
    type: {
      type: String,
      default: 'h1',
      validator: function validator(value) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'accent', 'main', 'medium', 'desc', 'hint', 'small'].indexOf(value) !== -1;
      }
    },
    /**
     * Добавить жирность
     * @values true, false
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     * @values div, h1, h2, h3, h4, h5, span
     */
    tag: {
      type: String
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    textComponent: function textComponent() {
      switch (this.type) {
        case 'h1':
          return bimTextH1;
        case 'h2':
          return bimTextH2;
        case 'h3':
          return bimTextH3;
        case 'h4':
          return bimTextH4;
        case 'h5':
          return bimTextH5;
        case 'accent':
          return bimTextAccent;
        case 'main':
          return bimTextMain;
        case 'medium':
          return bimTextMedium;
        case 'desc':
          return bimTextDesc;
        case 'hint':
          return bimTextHint;
        case 'small':
          return bimTextSmall;
        default:
          return null;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/text/bimText/bimText.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimText_bimTextvue_type_script_lang_js_ = (bimTextvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/text/bimText/bimText.vue





/* normalize component */

var bimText_component = normalizeComponent(
  bimText_bimTextvue_type_script_lang_js_,
  bimTextvue_type_template_id_cf81baf6_scoped_true_lang_html_render,
  bimTextvue_type_template_id_cf81baf6_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "cf81baf6",
  null
  
)

/* harmony default export */ var bimText = (bimText_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimCheckbox/bimCheckbox.vue?vue&type=template&id=67a9da71&scoped=true&
var bimCheckboxvue_type_template_id_67a9da71_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('input',{staticClass:"checkbox__input",attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('label',{staticClass:"checkbox__label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)}
var bimCheckboxvue_type_template_id_67a9da71_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/bimCheckbox/bimCheckbox.vue?vue&type=template&id=67a9da71&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimCheckbox/bimCheckbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimCheckboxvue_type_script_lang_js_ = ({
  name: 'bimCheckbox',
  props: {
    /**
     * Значение чекбокса
     * @model
     */
    value: Boolean,
    /**
     * Подпись (label) чек-бокса
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * id чекбокса. Прописывается для input и label одинаковый
     */
    id: {
      type: String,
      default: 'checkbox'
    },
    /**
     * Имя инпута
     */
    name: {
      type: String,
      default: 'checkbox'
    },
    /**
     * Отключение чек-бокса
     */
    disabled: Boolean
  }
});
// CONCATENATED MODULE: ./src/components/form/bimCheckbox/bimCheckbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimCheckbox_bimCheckboxvue_type_script_lang_js_ = (bimCheckboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form/bimCheckbox/bimCheckbox.vue?vue&type=style&index=0&id=67a9da71&prod&lang=scss&scoped=true&
var bimCheckboxvue_type_style_index_0_id_67a9da71_prod_lang_scss_scoped_true_ = __webpack_require__("bf3b");

// CONCATENATED MODULE: ./src/components/form/bimCheckbox/bimCheckbox.vue






/* normalize component */

var bimCheckbox_component = normalizeComponent(
  bimCheckbox_bimCheckboxvue_type_script_lang_js_,
  bimCheckboxvue_type_template_id_67a9da71_scoped_true_render,
  bimCheckboxvue_type_template_id_67a9da71_scoped_true_staticRenderFns,
  false,
  null,
  "67a9da71",
  null
  
)

/* harmony default export */ var bimCheckbox = (bimCheckbox_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimButton/bimButton.vue?vue&type=template&id=644bc4a4&scoped=true&
var bimButtonvue_type_template_id_644bc4a4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('a',{staticClass:"bim-btn",class:[_vm.classes, _vm.activeClass],style:(("\n    width: " + _vm.computedWidth + ";\n    height: " + _vm.computedHeight + ";\n   ")),attrs:{"href":_vm.href,"disabled":_vm.disabled}},[(_vm.icon)?_c('i',{class:_vm.icon,style:(("font-size: " + _vm.iconSize + "px; color: " + _vm.textColor + "; -webkit-text-fill-color: " + _vm.textColor))}):_vm._e(),(!this.$slots.default && !_vm.square && !_vm.rounded)?_c('span',{style:(_vm.textColor ? ("color: " + _vm.textColor + ";") : '')},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2):_c('button',{staticClass:"bim-btn",class:[_vm.classes, _vm.activeClass],style:(_vm.style),on:{"click":_vm.btnClicked}},[(_vm.icon)?_c('i',{class:_vm.icon,style:(("font-size: " + _vm.iconSize + "px; color: " + _vm.textColor + "; -webkit-text-fill-color: " + _vm.textColor))}):_vm._e(),(!this.$slots.default && !_vm.square && !_vm.rounded)?_c('span',{style:(_vm.textColor ? ("color: " + _vm.textColor + ";") : '')},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2)}
var bimButtonvue_type_template_id_644bc4a4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/bimButton/bimButton.vue?vue&type=template&id=644bc4a4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimButton/bimButton.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimButtonvue_type_script_lang_js_ = ({
  name: 'bimButton',
  props: {
    /**
     * Делает кнопку не активной
     */
    disabled: Boolean,
    /**
     * Делает кнопку не активной
     */
    makeClickOnDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Ширина кнопки. Если число без величины, будет px.
     */
    width: [String, Number],
    /**
     * Высота кнопки. Если число без величины, будет px.
     */
    height: [String, Number],
    /**
     * Ссылка кнопки
     */
    href: String,
    /**
     * Цвет кнопки
     * @values luxury, gray, darkgray, red, lightred, white
     */
    color: {
      type: String,
      default: 'primary'
    },
    /**
     * Цвет текста в любом формате. hex, rgba и т.д.
     */
    textColor: String,
    /**
     * Название класса активной ссылки/кнопки
     */
    activeClass: String,
    /**
     * Квадратная кнопка. Если включено, то label игнорируется
     */
    square: Boolean,
    /**
     * Круглая кнопка. Если включено, то label игнорируется
     */
    rounded: Boolean,
    /**
     * Кнопка с обводкой.
     * Адекватно работает только на ярких и темных кнопках.
     */
    outline: Boolean,
    /**
     * Отключение тени
     */
    noshadow: Boolean,
    /**
     * Текст кнопки
     */
    label: {
      type: String,
      default: 'Кнопка'
    },
    /**
     * Название класса иконки
     */
    icon: String,
    /**
     * Размер иконки в пикселях.
     */
    iconSize: {
      type: [String, Number],
      default: 16
    },
    /**
     * Размер кнопки.
     * @values s - маленькая кнопка, m - средняя кнопка, l - большая кнопка
     */
    size: {
      type: String,
      default: 'm',
      validator: function validator() {
        return ['s', 'm', 'l'];
      }
    },
    /**
     * Изменение фона кнопки в любом формате (hex, rgb и т.д.)
     */
    background: {
      type: String
    }
  },
  computed: {
    classes: function classes() {
      return {
        'bim-btn--big': this.size === 'l',
        'bim-btn--normal': this.size === 'm',
        'bim-btn--small': this.size === 's',
        'bim-btn--square': this.square,
        'bim-btn--rounded': this.rounded,
        'bim-btn--luxury': this.color === 'luxury',
        'bim-btn--white': this.color === 'white',
        'bim-btn--gray': this.color === 'gray',
        'bim-btn--darkgray': this.color === 'darkgray',
        'bim-btn--red': this.color === 'red',
        'bim-btn--lightred': this.color === 'lightred',
        'bim-btn--outline': this.outline,
        'bim-btn--noshadow': this.noshadow,
        'bim-custom-color': this.isCustomColor,
        disabled: this.disabled
      };
    },
    computedHeight: function computedHeight() {
      if (+this.height) {
        return this.height + 'px';
      } else {
        return this.height;
      }
    },
    computedWidth: function computedWidth() {
      if (+this.width) {
        return this.width + 'px';
      } else {
        return this.width;
      }
    },
    isCustomColor: function isCustomColor() {
      return !~['primary', 'luxury', 'gray', 'darkgray', 'red', 'lightred', 'white'].indexOf(this.color);
    },
    style: function style() {
      var style = {
        width: this.computedWidth,
        height: this.computedHeight,
        'background-color': this.background
      };
      if (this.isCustomColor) {
        style['--propscolor'] = this.color;
      }
      return style;
    }
  },
  methods: {
    btnClicked: function btnClicked(e) {
      if (this.disabled && !this.makeClickOnDisabled) {
        return;
      }
      this.$emit('click', e);
    }
  }
});
// CONCATENATED MODULE: ./src/components/form/bimButton/bimButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimButton_bimButtonvue_type_script_lang_js_ = (bimButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form/bimButton/bimButton.vue?vue&type=style&index=0&id=644bc4a4&prod&lang=scss&scoped=true&
var bimButtonvue_type_style_index_0_id_644bc4a4_prod_lang_scss_scoped_true_ = __webpack_require__("1e73");

// CONCATENATED MODULE: ./src/components/form/bimButton/bimButton.vue






/* normalize component */

var bimButton_component = normalizeComponent(
  bimButton_bimButtonvue_type_script_lang_js_,
  bimButtonvue_type_template_id_644bc4a4_scoped_true_render,
  bimButtonvue_type_template_id_644bc4a4_scoped_true_staticRenderFns,
  false,
  null,
  "644bc4a4",
  null
  
)

/* harmony default export */ var bimButton = (bimButton_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/formPhoneVerification/formPhoneVerification.vue?vue&type=template&id=54c42e66&scoped=true&
var formPhoneVerificationvue_type_template_id_54c42e66_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.step,class:{ 'p-9': !_vm.disablePadding }},[(_vm.step < 0)?_c('Loader'):_vm._e(),(_vm.step === 0)?[_c('bim-text',{staticClass:"mb-6",attrs:{"type":"main","bold":""},domProps:{"innerHTML":_vm._s(_vm.welcomeTitle || _vm.$bimTranslate('phoneValidate.step0.title', _vm.activeLang))}}),_c('bim-text',{staticClass:"mb-2",attrs:{"type":"medium"},domProps:{"innerHTML":_vm._s(_vm.welcomeDesc || _vm.$bimTranslate('phoneValidate.step0.desc', _vm.activeLang))}}),_c('bim-text',{staticClass:"mb-6",attrs:{"type":"medium"},domProps:{"innerHTML":_vm._s(
        _vm.welcomeWarn ||
        'Если у вас операторы Kcell, Beeline KZ или Беларусь, код верификации придет на вашу почту, указанную при регистрации.'
      )}}),_c('bim-input',{staticClass:"phone mb-6",attrs:{"mask":"phone","formKey":"phoneValue","formModel":_vm._self},model:{value:(_vm.phoneValue),callback:function ($$v) {_vm.phoneValue=$$v},expression:"phoneValue"}}),_c('vue-recaptcha',{ref:"recaptcha",attrs:{"size":"invisible","sitekey":_vm.sitekey,"loadRecaptchaScript":true},on:{"verify":_vm.sendSMS,"expired":_vm.onCaptchaExpired}}),_c('bimCheckbox',{staticClass:"agreement mb-6",model:{value:(_vm.agreement),callback:function ($$v) {_vm.agreement=$$v},expression:"agreement"}},[_c('span',[_vm._v(" Направляя свои персональные данные, я даю "),_c('a',{attrs:{"href":"https://bimlib.pro/agreement/","target":"_blank"}},[_vm._v(" согласие ")]),_vm._v(" на их обработку ")])]),_c('div',{staticStyle:{"text-align":"right"}},[_c('bim-button',{staticClass:"buttons__item",attrs:{"disabled":!_vm.$v2.validForm || _vm.lockButton || !_vm.agreement},on:{"click":_vm.validateCapcha}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.sendCode", _vm.activeLang)))])],1)]:_vm._e(),(_vm.step === 1)?[_c('bim-text',{staticClass:"mb-6",attrs:{"type":"main","bold":""}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.step1.title", _vm.activeLang)))]),_c('bim-text',{staticClass:"mb-6",attrs:{"type":"medium"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate("phoneValidate.step1.desc", _vm.activeLang))+" "),_c('br'),_vm._v(_vm._s(_vm.phoneValue)+". "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countdown > 0),expression:"countdown > 0"}]},[_vm._v(" "+_vm._s(_vm.$bimTranslate("phoneValidate.step1.descRefresh", _vm.activeLang))+" "+_vm._s(_vm.countdown)+" "+_vm._s(_vm.$bimTranslate("phoneValidate.step1.seconds", _vm.activeLang))+" ")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.countdown <= 0),expression:"countdown <= 0"}],staticClass:"refresh",on:{"click":_vm.validateSecondCapcha}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.step1.refreshSend", _vm.activeLang)))])]),_c('vue-recaptcha',{ref:"recaptcha2",attrs:{"size":"invisible","sitekey":_vm.sitekey,"loadRecaptchaScript":true},on:{"verify":_vm.sendSMS,"expired":_vm.onSecondCaptchaExpired}}),_c('bim-input',{staticClass:"phone mb-6",attrs:{"placeholder":"____","mask":"0000"},model:{value:(_vm.codeValue),callback:function ($$v) {_vm.codeValue=$$v},expression:"codeValue"}}),(_vm.errorText)?_c('bim-text',{staticClass:"mb-6",staticStyle:{"color":"red"},attrs:{"type":"desc"}},[_vm._v(_vm._s(_vm.errorText))]):_vm._e(),_c('div',{staticClass:"buttons"},[_c('bim-button',{staticClass:"buttons__item mr-6",attrs:{"disabled":_vm.timerButton,"color":"gray"},on:{"click":_vm.goBack}},[_c('span',[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.changeNumber", _vm.activeLang)))]),(_vm.step === 1 && _vm.timerButton)?_c('span',{staticClass:"timer"},[_vm._v("|"+_vm._s(_vm.formattedTimer))]):_vm._e()]),_c('bim-button',{staticClass:"buttons__item",attrs:{"disabled":_vm.codeValue.length !== 4},on:{"click":_vm.sendVerificationCode}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.sendCode", _vm.activeLang)))])],1)]:_vm._e(),(_vm.step === 2)?[_c('bim-text',{staticClass:"mb-6",attrs:{"type":"main","bold":""}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.step2.title", _vm.activeLang)))]),_c('bim-text',{staticClass:"mb-6",attrs:{"type":"medium"}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.step2.desc", _vm.activeLang)))])]:_vm._e(),(_vm.step === 3)?[_c('bim-text',{staticClass:"mb-6",attrs:{"type":"main","bold":""}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.step3.title", _vm.activeLang)))]),_c('bim-text',{staticClass:"mb-6",attrs:{"type":"medium"}},[_vm._v(_vm._s(_vm.$bimTranslate("phoneValidate.step3.desc", _vm.activeLang)))])]:_vm._e()],2)}
var formPhoneVerificationvue_type_template_id_54c42e66_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/formPhoneVerification/formPhoneVerification.vue?vue&type=template&id=54c42e66&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/loader.vue?vue&type=template&id=e1d9552c&scoped=true&lang=html&
var loadervue_type_template_id_e1d9552c_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var loadervue_type_template_id_e1d9552c_scoped_true_lang_html_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader__overlay"},[_c('div',{staticClass:"lds-hourglass"})])}]


// CONCATENATED MODULE: ./src/components/core/loader.vue?vue&type=template&id=e1d9552c&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/loader.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var loadervue_type_script_lang_js_ = ({
  name: 'Loader'
});
// CONCATENATED MODULE: ./src/components/core/loader.vue?vue&type=script&lang=js&
 /* harmony default export */ var core_loadervue_type_script_lang_js_ = (loadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/loader.vue?vue&type=style&index=0&id=e1d9552c&prod&lang=sass&scoped=true&
var loadervue_type_style_index_0_id_e1d9552c_prod_lang_sass_scoped_true_ = __webpack_require__("fb41");

// CONCATENATED MODULE: ./src/components/core/loader.vue






/* normalize component */

var loader_component = normalizeComponent(
  core_loadervue_type_script_lang_js_,
  loadervue_type_template_id_e1d9552c_scoped_true_lang_html_render,
  loadervue_type_template_id_e1d9552c_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "e1d9552c",
  null
  
)

/* harmony default export */ var loader = (loader_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimInput/bimInput.vue?vue&type=template&id=1d9ee204&scoped=true&
var bimInputvue_type_template_id_1d9ee204_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input__wrp"},[_c('div',{staticClass:"bim-input",class:{
    focus: _vm.focus,
    notEmpty: _vm.value,
    disabled: _vm.disabled,
    valid: _vm.valid,
    invalid: (_vm.valid === false || _vm.observableError)
  }},[_c('MaskedInput',_vm._g(_vm._b({ref:_vm.uniqRef,style:(("\n        background: " + _vm.background + ";\n        width: " + _vm.computedWidth + ";\n      ")),attrs:{"value":_vm.value,"name":_vm.name,"id":_vm.id,"type":_vm.type,"disabled":_vm.disabled,"mask":_vm.inputMask,"maskType":_vm.mask,"guide":false},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":_vm.onInput,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterInput($event)}}},'MaskedInput',_vm.$attrs,false),_vm.$listeners)),_c('label',{style:(("background: " + _vm.background))},[_vm._v(_vm._s(_vm.placeholder))]),_vm._t("default")],2),(_vm.dadataItems.length && _vm.focus)?_c('div',{staticClass:"suggestions__wrp"},_vm._l((_vm.dadataItems),function(item,index){return _c('div',{key:index,staticClass:"suggestion",on:{"click":function($event){return _vm.dadataItemClicked(item)}}},[_c('span',[_vm._v(" "+_vm._s(item.value)+" ")]),(item.hint)?_c('div',{staticClass:"suggestion__hint"},[_vm._v(" "+_vm._s(item.hint)+" ")]):_vm._e()])}),0):_vm._e(),(_vm.suggestionItems.length && _vm.focus && !_vm.edited)?_c('div',{staticClass:"suggestions__wrp"},_vm._l((_vm.suggestionItems),function(item,index){return _c('div',{key:index,staticClass:"suggestion",on:{"click":function($event){return _vm.updateValue(item)}}},[_vm._t("suggestion_item",[_vm._v(" "+_vm._s(item)+" ")],{"item":item})],2)}),0):_vm._e(),(!_vm.observableError && _vm.desc)?_c('div',{staticClass:"desc__block"},[_vm._v(_vm._s(_vm.desc))]):_vm._e(),_c('transition',{attrs:{"name":"error-slide"}},[(_vm.observableError)?_c('bimErrorField',{attrs:{"error":_vm.observableError}}):_vm._e()],1)],1)}
var bimInputvue_type_template_id_1d9ee204_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/bimInput/bimInput.vue?vue&type=template&id=1d9ee204&scoped=true&

// EXTERNAL MODULE: ./node_modules/text-mask-core/dist/textMaskCore.js
var textMaskCore = __webpack_require__("1693");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/masked-input/index.vue?vue&type=script&lang=js&
function masked_inputvue_type_script_lang_js_extends() { masked_inputvue_type_script_lang_js_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return masked_inputvue_type_script_lang_js_extends.apply(this, arguments); }

var punycode = __webpack_require__("1985");
var isPunycode = __webpack_require__("a863");
/* harmony default export */ var masked_inputvue_type_script_lang_js_ = ({
  render: function render(h) {
    var _this = this;
    return h('input', {
      ref: 'input',
      domProps: {
        value: this.value
      },
      attrs: this.$attrs,
      on: Object.assign(masked_inputvue_type_script_lang_js_extends({}, this.$listeners), {
        input: function input(event) {
          return _this.updateValue(event.target.value);
        }
      })
    });
  },
  name: 'MaskedInput',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    mask: {
      type: [Array, Function, Boolean, Object],
      required: true
    },
    guide: {
      type: Boolean,
      required: false
    },
    placeholderChar: {
      type: String,
      required: false
    },
    keepCharPositions: {
      type: Boolean,
      required: false
    },
    pipe: {
      type: Function,
      required: false
    },
    showMask: {
      type: Boolean,
      required: false
    },
    /**
    * Маска
    * @values inn, phone, site, date или своя версия (00-00-00-000)
    */
    maskType: {
      type: String,
      default: ''
    }
  },
  mounted: function mounted() {
    this.initMask();
  },
  methods: {
    createTextMaskInputElement: textMaskCore["createTextMaskInputElement"],
    setTextMaskInputElement: function setTextMaskInputElement() {
      this.textMaskInputElement = this.createTextMaskInputElement(masked_inputvue_type_script_lang_js_extends({
        inputElement: this.$refs.input
      }, this.$options.propsData));
    },
    initMask: function initMask() {
      this.setTextMaskInputElement();
      this.textMaskInputElement.update(this.value);
    },
    bind: function bind() {
      this.setTextMaskInputElement();
      this.updateValue(this.value);
    },
    sitePunicodeToUnicode: function sitePunicodeToUnicode(value) {
      if (value.charAt(value.length - 1) === '/') {
        value = value.slice(0, -1); // если последний символ === '/', удаляем его иначе значение пуникода будет неправильным
      }

      value = value.replace('https://', ''); // удаляем 'https://' из строки
      var res = 'https://' + punycode.toUnicode(value); // возвращаем результат с https на Unicode
      this.$refs.input.value = res;
      return res;
    },
    emailPunicodeToUnicode: function emailPunicodeToUnicode(value) {
      if (value.charAt(value.length - 1) === '/') {
        value = value.slice(0, -1); // если последний символ === '/', удаляем его иначе значение пуникода будет неправильным
      }

      var punycodeStrArr = value.split('@');
      if (punycodeStrArr[1] && isPunycode(punycodeStrArr[1])) {
        // только правую часть после "@" проверяем на punycode
        punycodeStrArr[1] = punycode.toUnicode(punycodeStrArr[1]);
      }
      var res = punycodeStrArr.join('@'); // возвращаем результат обьединив массив через @
      this.$refs.input.value = res;
      return res;
    },
    updateValue: function updateValue(value) {
      if (this.maskType === 'site' && isPunycode(value)) {
        value = this.sitePunicodeToUnicode(value);
      }
      if (this.$attrs.type === 'email' && isPunycode(value)) {
        value = this.emailPunicodeToUnicode(value);
      }
      this.textMaskInputElement.update(value);
      this.$emit('input', this.$refs.input.value);
    }
  },
  watch: {
    mask: function mask(newMask, oldMask) {
      // Check if the mask has changed (Vue cannot detect whether an array has changed)
      this.bind();
    },
    guide: function guide() {
      this.bind();
    },
    placeholderChar: function placeholderChar() {
      this.bind();
    },
    keepCharPositions: function keepCharPositions() {
      this.bind();
    },
    pipe: function pipe() {
      this.bind();
    },
    showMask: function showMask() {
      this.bind();
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/masked-input/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var core_masked_inputvue_type_script_lang_js_ = (masked_inputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/core/masked-input/index.vue
var masked_input_render, masked_input_staticRenderFns




/* normalize component */

var masked_input_component = normalizeComponent(
  core_masked_inputvue_type_script_lang_js_,
  masked_input_render,
  masked_input_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var masked_input = (masked_input_component.exports);
// CONCATENATED MODULE: ./src/utils/validate2/validation-form-mixin.js
/* harmony default export */ var validation_form_mixin = ({
  props: {
    formKey: String,
    formModel: Object
  },
  data: function data() {
    return {
      observableError: '',
      observableValue: '',
      blurredFormInput: false // поле если было затронуто - можно валидировать на каждый keyup
    };
  },
  mounted: function mounted() {
    this.$on('blur', this.blurValidateForm.bind(this));
    this.$on('change', this.blurValidateForm.bind(this));
    this.$on('input', this.lifeValidateForm.bind(this));
    this.lifeValidateForm();
    if (this.formModel) {
      this.formModel.$on('validateFields', this.updateFieldErrorText);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$off(['blur', 'input', 'change']);
    if (this.formModel) {
      this.formModel.$off(['validateFields']);
    }
  },
  methods: {
    blurValidateForm: function blurValidateForm() {
      this.blurredFormInput = true;
      return this.lifeValidateForm();
    },
    // живая валидация - по каждому нажатию
    lifeValidateForm: function lifeValidateForm() {
      var valid = true;
      var changeValid = function changeValid(validateResult) {
        if (!valid) {
          return;
        }
        valid = validateResult;
      };

      // новая валидация
      changeValid(this.validate2Form());
      return valid;
    },
    validate2Form: function validate2Form() {
      if (!this.formKey || !this.formModel) {
        return true;
      }
      if (!this.formModel.$v2) {
        return true;
      }
      var vObject = this.formModel._vuelidate2;

      // поле было затронуто
      if (this.blurredFormInput) {
        vObject.setBlurredField(this.formKey);
      }
      var fieldError = vObject.validateField(this.formKey);
      this.observableError = vObject.isBlurredField(this.formKey) && fieldError ? fieldError : '';
      return !this.observableError;
    },
    // обновить текст ошибки
    updateFieldErrorText: function updateFieldErrorText() {
      if (!this.formKey || !this.formModel) {
        return;
      }
      if (!this.formModel.$v2) {
        return;
      }
      var vObject = this.formModel._vuelidate2;
      var errors = this.formModel.$v2.errors;
      var errorObj = errors[this.formKey] || null;
      this.observableError = vObject.isBlurredField(this.formKey) && errorObj ? errorObj.fieldError : '';
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimErrorField/bimErrorField.vue?vue&type=template&id=6c076c8e&scoped=true&lang=html&
var bimErrorFieldvue_type_template_id_6c076c8e_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorText || !_vm.emptyHide)?_c('div',{staticClass:"error__text",class:{ check__error: _vm.checkError }},[_vm._v(" "+_vm._s(_vm.errorText || ' ')+" ")]):_vm._e()}
var bimErrorFieldvue_type_template_id_6c076c8e_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/bimErrorField/bimErrorField.vue?vue&type=template&id=6c076c8e&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimErrorField/bimErrorField.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bimErrorFieldvue_type_script_lang_js_ = ({
  name: 'bimErrorField',
  props: {
    /**
     * Текст ошибки
     */
    error: {
      type: [String, Boolean],
      default: null
    },
    /**
     * рисовать пустой блок ошибки если true
     */
    emptyHide: {
      type: [String, Boolean],
      default: true
    },
    /**
     * Отступ добавляется дополнительный справа
     */
    checkError: Boolean
  },
  computed: {
    errorText: function errorText() {
      if (this.error && typeof this.error !== 'boolean') {
        return this.error;
      }
      return '';
    }
  }
});
// CONCATENATED MODULE: ./src/components/form/bimErrorField/bimErrorField.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimErrorField_bimErrorFieldvue_type_script_lang_js_ = (bimErrorFieldvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form/bimErrorField/bimErrorField.vue?vue&type=style&index=0&id=6c076c8e&prod&lang=scss&scoped=true&
var bimErrorFieldvue_type_style_index_0_id_6c076c8e_prod_lang_scss_scoped_true_ = __webpack_require__("7e73");

// CONCATENATED MODULE: ./src/components/form/bimErrorField/bimErrorField.vue






/* normalize component */

var bimErrorField_component = normalizeComponent(
  bimErrorField_bimErrorFieldvue_type_script_lang_js_,
  bimErrorFieldvue_type_template_id_6c076c8e_scoped_true_lang_html_render,
  bimErrorFieldvue_type_template_id_6c076c8e_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "6c076c8e",
  null
  
)

/* harmony default export */ var bimErrorField = (bimErrorField_component.exports);
// CONCATENATED MODULE: ./src/components/core/dadata-mixin.js
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function dadata_mixin_extends() { dadata_mixin_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return dadata_mixin_extends.apply(this, arguments); }

var TOKEN = 'fbf3c898441e7b2522ad2656f328151207143c38';
var dadataTypes = {
  surname: 'SURNAME',
  // подсказка по фамилии
  name: 'NAME',
  // подсказка по имени
  patronymic: 'PATRONYMIC',
  // подсказка по отчеству
  email: 'EMAIL',
  // подсказка по email
  city: 'city',
  // подсказка по городу
  region: 'region',
  // подсказка по региону
  street: 'street',
  // подсказка только по улице
  address: 'address',
  // подсказка по всему адресу в строчку (город, улица, дом)
  party: 'party',
  // Поиск организаций
  inn: 'inn',
  // подсказка по ИНН
  house: 'house' // подсказка по дому
};

// какой справочник вызывать у dadata.ru в зависимости от ${props.dadataType}
var dadataDictionary = function dadataDictionary(type) {
  switch (type) {
    case 'surname':
    case 'name':
    case 'patronymic':
      return 'fio';
    case 'email':
      return 'email';
    case 'city':
    case 'street':
    case 'region':
    case 'address':
    case 'house':
      return 'address';
    case 'inn':
    case 'party':
      return 'party';
    default:
      return 'fio';
  }
};
function getInformationAboutIP() {
  return fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: 'Token ' + TOKEN
    }
  }).then(function (response) {
    return response.json();
  }).catch(function (error) {
    return console.error('getInformationAboutIP', error);
  });
}
/* harmony default export */ var dadata_mixin = ({
  props: {
    /**
     * тип подсказки
     */
    dadataType: {
      type: String,
      default: '',
      validator: function validator(value) {
        return [''].concat(Object.keys(dadataTypes)).includes(value);
      }
    },
    /**
     * поиск по кладр
     */
    dadataKladrId: {
      type: String
    },
    /**
     * функция фильтрации подсказок
     */
    dadataFilter: {
      type: Function
    }
  },
  data: function data() {
    return {
      dadataTimer: null,
      dadataItems: [],
      // подсказки от дадаты
      selectedDadataItem: false,
      // было выбрано из подсказок дадаты
      activeItemIndex: null,
      // index активного элемента
      stopRequestDadata: false // остановить запросы за данными
    };
  },
  mounted: function mounted() {
    this.$on('input', this.onChangeValueDadata);
  },
  beforeDestroy: function beforeDestroy() {
    this.$off('input', this.onChangeValueDadata);
  },
  methods: {
    onChangeValueDadata: function onChangeValueDadata(value) {
      var _this = this;
      if (this.stopRequestDadata) {
        return;
      }

      // подсказки не нужны
      if (!this.dadataType) {
        return;
      }
      clearTimeout(this.dadataTimer);
      this.dadataTimer = setTimeout(function () {
        _this.getSuggestions(value);
      }, 200);
    },
    dadataItemClicked: function dadataItemClicked(item) {
      var _this2 = this;
      // default
      var value = item.value;

      // city
      if (this.dadataType === 'city') {
        value = getValue(item, 'data.city_with_type') || getValue(item, 'data.city', value);
      }

      // region
      if (this.dadataType === 'region') {
        value = getValue(item, 'data.region_with_type') || getValue(item, 'data.region', value);
      }

      // street
      if (this.dadataType === 'street') {
        value = getValue(item, 'data.street_with_type') || getValue(item, 'data.street', value);
      }

      // inn
      if (this.dadataType === 'inn') {
        value = getValue(item, 'data.inn');
      }

      // party
      if (this.dadataType === 'party') {
        value = getValue(item, 'data.name.short') || value;
      }
      this.stopRequestDadata = true;
      this.updateValue(value);
      this.dadataItems = [];
      this.$nextTick(function () {
        setTimeout(function () {
          _this2.stopRequestDadata = false;
        }, 300);
      });
      this.$emit('suggestion', dadata_mixin_extends({}, item, {
        cleanValue: value
      }));
      var kladrId = getValue(item, 'data.kladr_id');
      if (kladrId) {
        this.$emit('kladrId', kladrId);
      }
      this.selectedDadataItem = true;
    },
    getSuggestions: function getSuggestions(query) {
      var _this3 = this;
      var url = "https://dadata.ru/api/v2/suggest/" + dadataDictionary(this.dadataType);
      var headers = {
        Accept: 'application/json',
        Authorization: 'Token ' + TOKEN
      };
      headers['Content-Type'] = 'application/json';
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(dadata_mixin_extends({
          count: 3,
          query: query
        }, this.formSuggestionsData()))
      }).then(function (r) {
        return r.json();
      }).then(function (res) {
        return res.suggestions;
      }).then(function (items) {
        if (typeof _this3.dadataFilter === 'function') {
          _this3.dadataItems = _this3.formDadataItems(_this3.dadataFilter(items));
        } else {
          _this3.dadataItems = _this3.formDadataItems(items);
        }
        return _this3.dadataItems;
      });
    },
    formDadataItems: function formDadataItems(items) {
      // party
      if (this.dadataType === 'party') {
        return items.map(function (item) {
          return dadata_mixin_extends({}, item, {
            hint: item.data.inn + " " + getValue(item, 'data.management.name')
          });
        });
      }

      // inn
      if (this.dadataType === 'inn') {
        return items.map(function (item) {
          return dadata_mixin_extends({}, item, {
            hint: item.data.inn + " " + getValue(item, 'data.address.value')
          });
        });
      }
      return items;
    },
    formSuggestionsData: function formSuggestionsData() {
      // address
      if (this.dadataType === 'address') {
        return {};
      }

      // address - city,region,street,house
      if (~['city', 'region', 'street', 'house'].indexOf(this.dadataType)) {
        return {
          from_bound: {
            value: this.dadataType
          },
          to_bound: {
            value: this.dadataType
          },
          locations: this.dadataKladrId ? [{
            kladr_id: this.dadataKladrId
          }] : [],
          restrict_value: this.dadataType === 'house'
        };
      }

      // default
      return {
        parts: [dadataTypes[this.dadataType]]
      };
    },
    listenDadataEvents: function listenDadataEvents() {
      document.addEventListener('keydown', this.onKeyDown);
    },
    unlistenDadataEvents: function unlistenDadataEvents() {
      this.activeItemIndex = null;
      document.removeEventListener('keydown', this.onKeyDown);
    },
    onKeyDown: function onKeyDown(e) {
      var lengthItems = this.dadataItems.length;

      // нет подсказок
      if (!lengthItems) {
        return;
      }
      var keyCode = e.keyCode;
      if (!~[38, 40, 13].indexOf(keyCode)) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();

      // up
      if (keyCode === 38) {
        if (this.activeItemIndex === null) {
          this.activeItemIndex = lengthItems - 1;
        } else {
          this.activeItemIndex = this.activeItemIndex - 1 >= 0 ? this.activeItemIndex - 1 : lengthItems - 1;
        }
      }

      // down
      if (keyCode === 40) {
        if (this.activeItemIndex === null) {
          this.activeItemIndex = 0;
        } else {
          this.activeItemIndex = this.activeItemIndex + 1 <= lengthItems - 1 ? this.activeItemIndex + 1 : 0;
        }
      }

      // enter
      var activeItem = this.dadataItems[this.activeItemIndex];
      if (keyCode === 13 && activeItem) {
        this.dadataItemClicked(activeItem);
      }
    },
    // если пользователь что то написал но не выбрал из подсказок дадаты - сделаем выбор за него
    findDadataItem: function findDadataItem() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dadataItems, observableValue, dadataItem, valueChunks, dadataItem2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dadataItems = _this4.dadataItems;
              if (dadataItems.length) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return _this4.getSuggestions(_this4.observableValue);
            case 4:
              dadataItems = _context.sent;
            case 5:
              observableValue = _this4.clearDadataValue(_this4.observableValue); // поиск строгого соответствия
              dadataItem = dadataItems.find(function (item) {
                return _this4.clearDadataValue(item.value) === observableValue;
              });
              if (!dadataItem) {
                _context.next = 10;
                break;
              }
              _this4.dadataItemClicked(dadataItem);
              return _context.abrupt("return");
            case 10:
              if (!~['surname', 'name', 'patronymic', 'email', 'inn', 'party', 'house'].indexOf(_this4.dadataType)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              // поиск вхождения строк
              valueChunks = observableValue.split(' ');
              dadataItem2 = dadataItems.find(function (item) {
                var value = _this4.clearDadataValue(item.value);
                var finded = true;
                forEach(valueChunks, function (chunk) {
                  if (!~value.indexOf(chunk)) {
                    finded = false;
                    return false;
                  }
                });
                return finded;
              });
              if (dadataItem2) {
                _this4.dadataItemClicked(dadataItem2);
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    clearDadataValue: function clearDadataValue(value) {
      value = String(value);
      value = value.replace(/(,|\.)/g, ' ');
      value = value.replace(/(г |ул |д |с\/с |поселок |респ |село | р-н|тер )/g, ' ');
      value = value.replace(/( )+/g, ' ');
      return value.toLowerCase();
    }
  },
  watch: {
    inFocus: function inFocus(_inFocus) {
      // подсказки не нужны
      if (!this.dadataType) {
        return;
      }
      if (_inFocus) {
        this.listenDadataEvents();
      } else {
        this.unlistenDadataEvents();
      }

      // пользователь попал в поле ввода - запросим подсказки
      if (_inFocus && this.observableValue && !this.dadataItems.length) {
        this.getSuggestions(this.observableValue);
      }

      // если пользователь что то написал но не выбрал из подсказок дадаты - сделаем выбор за него
      if (!_inFocus && this.observableValue && !this.selectedDadataItem) {
        this.findDadataItem();
      }
    },
    edited: function edited(_edited) {
      // подсказки не нужны
      if (!this.dadataType) {
        return;
      }
      if (_edited) {
        this.selectedDadataItem = false;
      }
    },
    dadataKladrId: function dadataKladrId() {
      this.dadataItems = [];
      this.selectedDadataItem = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimInput/bimInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var ruGlobalPhoneMask = ['+', /\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/];
var ruLocalPhoneMask = [/\d/, ' ', '(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/];
var defaultPhoneMask = ['+', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
/* harmony default export */ var bimInputvue_type_script_lang_js_ = ({
  name: 'bimInput',
  mixins: [validation_form_mixin, dadata_mixin],
  components: {
    MaskedInput: masked_input,
    bimErrorField: bimErrorField
  },
  model: {
    event: 'inputValue'
  },
  props: {
    /**
     * Поясняющая подсказка снизу
     */
    desc: String,
    /**
     * Значение инпута
     * @model
     */
    value: {
      type: [String, Number]
    },
    /**
     * Имя поля
     */
    name: {
      type: String
    },
    /**
     * ID поля
     */
    id: {
      type: String
    },
    /**
     * Значение placeholder
     */
    placeholder: {
      type: [String, Number],
      default: 'Введите текст'
    },
    /**
     * Тип инпута
     */
    type: {
      type: String,
      default: 'text'
    },
    /**
     * Отключает инпут
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * При необходимости передаёт валидно ли поле
     */
    valid: {
      type: Boolean,
      default: null
    },
    /**
     * Маска
     * @values inn, phone, site, date или своя версия (00-00-00-000)
     */
    mask: {
      type: String,
      default: ''
    },
    /**
     * Автоматически ставит фокус на инпут. Работает только на одном инпуте. Если таких инпутов несколько, фокус будет на последнем из них
     */
    autofocus: {
      type: Boolean,
      default: false
    },
    /**
     * Заменяет фон инпута (transparent не прадлагать)
     */
    background: {
      type: String,
      default: '#ffffff'
    },
    /**
     * Ширина
     */
    width: [String, Number],
    /**
     * список кастомных подсказок
     */
    suggestionItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      focus: false,
      edited: false,
      phoneMask: false
    };
  },
  watch: {
    value: function value(_value) {
      this.edited = true;
      this.$nextTick(this.calculateInputMask);
    }
  },
  mounted: function mounted() {
    if (this.autofocus) this.onAutofocus();
    this.calculateInputMask();
  },
  computed: {
    computedWidth: function computedWidth() {
      if (+this.width) {
        return this.width + 'px';
      } else {
        return this.width;
      }
    },
    uniqRef: function uniqRef() {
      return 'input' + Date.now();
      // return `input${Date.now()}`
    },
    inputMask: function inputMask() {
      if (this.mask) {
        switch (this.mask) {
          case 'inn':
            return [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
          case 'date':
            return [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
          case 'site':
            return [].concat('https://'.split(''), new Array(30).fill(/./));
          // название сайта максимум 30 символов
          case 'phone':
            return this.phoneMask;
        }
        var inputMask = this.mask.split('');
        inputMask = inputMask.map(function (char) {
          switch (char) {
            case '0':
              return /\d/;
            // только цифры
            case 'X':
              return /./;
            // любой символ
            default:
              return char;
          }
        });
        return inputMask;
      }
      return false;
    }
  },
  methods: {
    onInput: function onInput(value) {
      /* корректное удаление маски телефона */
      if (this.mask === 'phone' && value && value.length < this.value.length && this.value.slice(-1).match(/\D/)) {
        var numbers = value.match(/\d/g) || [];
        value = numbers.slice(0, -1).join('');
      }
      this.$emit('inputValue', value);
      this.$emit('input', value);
    },
    onEnterInput: function onEnterInput() {
      /**
       * событие нажатия на enter
       */
      this.$emit('enter');
    },
    calculateInputMask: function calculateInputMask() {
      if (this.mask !== 'phone') return;
      var emitValue,
        newPhoneMask,
        phoneNumber = this.value || '';
      try {
        phoneNumber = phoneNumber.match(/\d/g).join('');
      } catch (e) {}
      if (phoneNumber.length <= 11) {
        if (phoneNumber.slice(0, 3) === '800' || phoneNumber.slice(0, 4) === '8800' || phoneNumber.slice(0, 4) === '7800') {
          /* номера с кодом 800 */

          if (phoneNumber.slice(0, 3) === '800') {
            emitValue = '8' + phoneNumber;
          }
          if (phoneNumber.slice(0, 4) === '7800') {
            emitValue = '8' + phoneNumber.slice(1);
          }
          newPhoneMask = ruLocalPhoneMask;
        } else if (phoneNumber.slice(0, 1) === '7') {
          /* начинается на 7 */
          newPhoneMask = ruGlobalPhoneMask;
        } else if ( /* российские номера начинающиеся с 8 */
        phoneNumber.slice(0, 1) === '8' && phoneNumber.length === 11) {
          emitValue = '7' + phoneNumber.slice(1);
          newPhoneMask = ruGlobalPhoneMask;
        } else if ( /* российские номера с кодом 9.x.x */
        phoneNumber.slice(0, 1) === '9' && phoneNumber.length === 10) {
          emitValue = '7' + phoneNumber;
          newPhoneMask = ruGlobalPhoneMask;
        }
      } else {
        if (phoneNumber.slice(0, 1) === '7') {
          emitValue = phoneNumber.slice(1);
        }
      }
      if (emitValue && emitValue !== this.value) this.$emit('inputValue', emitValue);
      if (newPhoneMask) {
        this.phoneMask = [].concat(newPhoneMask);
      } else {
        this.phoneMask = defaultPhoneMask;
      }
    },
    onFocus: function onFocus() {
      this.focus = true;
      /**
       * Событие срабатывает при фокусе на поле
       */
      this.$emit('focus');
    },
    onBlur: function onBlur() {
      var _this = this;
      setTimeout(function () {
        _this.edited = false;
        _this.focus = false;
      }, 400);

      /**
       * Событие срабатывает при потере фокуса с поля
       */
      this.$emit('blur');
    },
    onAutofocus: function onAutofocus() {
      this.$refs[this.uniqRef].$el.focus();
    },
    updateValue: function updateValue(value) {
      this.$emit('input', value);
      this.$emit('inputValue', value);
      this.edited = true;
    }
  }
});
// CONCATENATED MODULE: ./src/components/form/bimInput/bimInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimInput_bimInputvue_type_script_lang_js_ = (bimInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form/bimInput/bimInput.vue?vue&type=style&index=0&id=1d9ee204&prod&lang=scss&scoped=true&
var bimInputvue_type_style_index_0_id_1d9ee204_prod_lang_scss_scoped_true_ = __webpack_require__("352f");

// CONCATENATED MODULE: ./src/components/form/bimInput/bimInput.vue






/* normalize component */

var bimInput_component = normalizeComponent(
  bimInput_bimInputvue_type_script_lang_js_,
  bimInputvue_type_template_id_1d9ee204_scoped_true_render,
  bimInputvue_type_template_id_1d9ee204_scoped_true_staticRenderFns,
  false,
  null,
  "1d9ee204",
  null
  
)

/* harmony default export */ var bimInput = (bimInput_component.exports);
// CONCATENATED MODULE: ./node_modules/vue-recaptcha/dist/vue-recaptcha.es.js
function vue_recaptcha_es_extends() {
  vue_recaptcha_es_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return vue_recaptcha_es_extends.apply(this, arguments);
}

var defer = function defer() {
  var state = false; // Resolved or not

  var callbacks = [];

  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;

    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }

    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },
    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

var ownProp = Object.prototype.hasOwnProperty;
function createRecaptcha() {
  var deferred = defer();
  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}
var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var VueRecaptcha = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    },
    loadRecaptchaScript: {
      type: Boolean,
      "default": false
    },
    recaptchaScriptId: {
      type: String,
      "default": '__RECAPTCHA_SCRIPT'
    },
    recaptchaHost: {
      type: String,
      "default": 'www.google.com'
    },
    language: {
      type: String,
      "default": ''
    }
  },
  beforeMount: function beforeMount() {
    if (this.loadRecaptchaScript) {
      if (!document.getElementById(this.recaptchaScriptId)) {
        // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
        var script = document.createElement('script');
        script.id = this.recaptchaScriptId;
        script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();

    var opts = vue_recaptcha_es_extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
      'error-callback': this.emitError
    });

    var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;

      _this.$emit('render', id);
    });
  },
  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    },
    emitError: function emitError() {
      this.$emit('error');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots["default"]);
  }
};

/* harmony default export */ var vue_recaptcha_es = (VueRecaptcha);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/formPhoneVerification/formPhoneVerification.vue?vue&type=script&lang=js&
function formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function formPhoneVerificationvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function formPhoneVerificationvue_type_script_lang_js_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { formPhoneVerificationvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { formPhoneVerificationvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var formPhoneVerificationvue_type_script_lang_js_ = ({
  name: 'formPhoneVerification',
  components: {
    bimText: bimText,
    bimInput: bimInput,
    bimButton: bimButton,
    Loader: loader,
    VueRecaptcha: vue_recaptcha_es,
    bimCheckbox: bimCheckbox
  },
  props: {
    /**
     * Логирующая функция для /log/event/
     */
    logActionEvent: {
      type: Function,
      default: function _default() {}
    },
    /**
     * объект контекста пользователя
     */
    user: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /**
     * текущий язык
     */
    activeLang: {
      type: String,
      default: 'ru',
      validator: function validator(value) {
        return ['ru', 'en'].indexOf(value) !== -1;
      }
    },
    /**
     * отключить отступы
     */
    disablePadding: Boolean,
    /**
     * Приветственный заголовок (на первом этапе)
     * */
    welcomeTitle: {
      type: String,
      default: ''
    },
    /**
     * Приветственное описение (на первом этапе)
     * */
    welcomeDesc: {
      type: String,
      default: ''
    },
    welcomeWarn: {
      type: String,
      default: ''
    },
    /**
     * captcha siteKey
     */
    sitekey: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      step: -1,
      phoneValue: '7',
      codeValue: '',
      countdown: 0,
      countdownTimer: null,
      errorText: '',
      lockButton: false,
      showCaptcha: false,
      timerButton: false,
      timer: 90,
      timerInterval: null,
      agreement: false
    };
  },
  computed: {
    formValidation: function formValidation() {
      return {
        phoneValue: ['required', 'phone']
      };
    },
    toastSettings: function toastSettings() {
      return {
        duration: 0
      };
    },
    formattedTimer: function formattedTimer() {
      var minutes = Math.floor(this.timer / 60);
      var seconds = this.timer % 60;
      return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    }
  },
  mounted: function mounted() {
    var _this = this;
    return formPhoneVerificationvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime().mark(function _callee() {
      var resp;
      return formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.$user.getPhone();
          case 2:
            resp = _context.sent;
            if (resp.phone) {
              _this.phoneValue = resp.phone;
            }
            if (resp.validated) {
              _this.step = 3;
            } else {
              setTimeout(function () {
                _this.step = 0;
                _this.$forceUpdate();
                _this.$emit('loaded', true);
              }, 500);
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    if (this.countdownTimer) {
      this.clearCountdownTimer();
    }
  },
  watch: {
    countdown: function countdown(time) {
      if (time <= 0) {
        this.clearCountdownTimer();
      }
    },
    step: function step(newStep) {
      if (newStep === 1) {
        this.timerButton = true;
        this.startTimer();
      }
    }
  },
  methods: {
    goBack: function goBack() {
      if (!this.timerButton) {
        this.step = 0;
        this.lockButton = false;
        this.timerButton = false;
        this.onCaptchaExpired();
        this.onSecondCaptchaExpired();
        clearInterval(this.timerInterval);
      }
    },
    startTimer: function startTimer() {
      var _this2 = this;
      this.timer = 90;
      this.timerInterval = setInterval(function () {
        if (_this2.timer > 0) {
          _this2.timer--;
        } else {
          _this2.timerButton = false;
          clearInterval(_this2.timerInterval);
        }
      }, 1000);
    },
    clearCountdownTimer: function clearCountdownTimer() {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    },
    // Вызов капчи
    validateCapcha: function validateCapcha() {
      this.$refs.recaptcha.execute();
    },
    validateSecondCapcha: function validateSecondCapcha() {
      this.$refs.recaptcha2.execute();
    },
    onCaptchaExpired: function onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    onSecondCaptchaExpired: function onSecondCaptchaExpired() {
      this.$refs.recaptcha2.reset();
    },
    sendSMS: function sendSMS(recaptchaToken) {
      var _this3 = this;
      return formPhoneVerificationvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime().mark(function _callee2() {
        var phoneItem, mobileOperator, prefix, params, url, resp;
        return formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _this3.lockButton = true;
              _this3.clearCountdownTimer();
              _context2.next = 5;
              return _this3.$user.updatePhone(_this3.phoneValue);
            case 5:
              phoneItem = _context2.sent;
              // Determine the mobile operator based on the phone number
              mobileOperator = 'other'; // Default value for other operators
              // Check if the phone number belongs to Kcell, Beeline KZ, or Beeline Belarus
              prefix = phoneItem.phone.substring(0, 3); // Extract the prefix
              console.log(prefix);
              if (prefix === '770' || prefix === '770' || prefix === '770') {
                mobileOperator = 'Kcell';
              } else if (prefix === '770' || prefix === '770' || prefix === '770') {
                mobileOperator = 'Beeline KZ';
              } else if (prefix === '375') {
                mobileOperator = 'Beeline Belarus';
              }
              if (!(mobileOperator === 'Kcell' || mobileOperator === 'Beeline KZ' || mobileOperator === 'Beeline Belarus')) {
                _context2.next = 25;
                break;
              }
              params = new URLSearchParams();
              params.append('phone', phoneItem.phone);
              params.append('email', _this3.user.email);
              url = '/resend_code?' + params.toString();
              _context2.prev = 15;
              _context2.next = 18;
              return _this3.$emit('resend-code', url);
            case 18:
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](15);
              console.log(123215);
            case 23:
              _context2.next = 31;
              break;
            case 25:
              _context2.next = 27;
              return _this3.$user.validatePhoneRequest(recaptchaToken);
            case 27:
              resp = _context2.sent;
              if (!(resp.code === 'Token assessment has been failed for the reason: invalid-keys')) {
                _context2.next = 31;
                break;
              }
              _this3.$toast.error('Произошла ошибка при верификации номера. Пожалуйста, попробуйте еще раз.');
              throw new Error(resp.code);
            case 31:
              _this3.step = 1;
              _this3.countdown = 120;
              _this3.countdownTimer = setInterval(function () {
                _this3.countdown--;
              }, 1000);
              _context2.next = 41;
              break;
            case 36:
              _context2.prev = 36;
              _context2.t1 = _context2["catch"](0);
              console.log(_context2.t1.toString());
              console.log(_context2.t1);
              console.error(_context2.t1);
            case 41:
              _this3.logActionEvent('sms_fetch_code');
            case 42:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 36], [15, 20]]);
      }))();
    },
    sendVerificationCode: function sendVerificationCode() {
      var _this4 = this;
      return formPhoneVerificationvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime().mark(function _callee3() {
        var resp, result;
        return formPhoneVerificationvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              resp = {};
              _context3.prev = 1;
              _context3.next = 4;
              return _this4.$user.validatePhone(_this4.codeValue);
            case 4:
              resp = _context3.sent;
              if (resp.ok) {
                _context3.next = 19;
                break;
              }
              _context3.next = 8;
              return resp.json();
            case 8:
              result = _context3.sent;
              _context3.t0 = result.code;
              _context3.next = _context3.t0 === 'phone.validation.code.is.already.expired' ? 12 : _context3.t0 === 'phone.validation.code.is.incorrect' ? 14 : _context3.t0 === 'phone.is.already.validated' ? 16 : 18;
              break;
            case 12:
              _this4.errorText = _this4.$bimTranslate('phoneValidate.error.codeIsAlreadyExpired', _this4.activeLang);
              return _context3.abrupt("break", 19);
            case 14:
              _this4.errorText = _this4.$bimTranslate('phoneValidate.error.codeIsIncorrect', _this4.activeLang);
              return _context3.abrupt("break", 19);
            case 16:
              _this4.errorText = _this4.$bimTranslate('phoneValidate.error.alreadyValidated', _this4.activeLang);
              return _context3.abrupt("break", 19);
            case 18:
              _this4.errorText = _this4.$bimTranslate('phoneValidate.error.unknownError', _this4.activeLang);
            case 19:
              _context3.next = 24;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t1 = _context3["catch"](1);
              console.error(_context3.t1);
            case 24:
              if (resp.ok) {
                _this4.errorText = '';
                _this4.step = 2;
                /**
                 * успешное подтверждение телефона
                 */
                _this4.$emit('success');
                _this4.logActionEvent('sms_send_code');
              }
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 21]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./src/components/ui/formPhoneVerification/formPhoneVerification.vue?vue&type=script&lang=js&
 /* harmony default export */ var formPhoneVerification_formPhoneVerificationvue_type_script_lang_js_ = (formPhoneVerificationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ui/formPhoneVerification/formPhoneVerification.vue?vue&type=style&index=0&id=54c42e66&prod&lang=scss&scoped=true&
var formPhoneVerificationvue_type_style_index_0_id_54c42e66_prod_lang_scss_scoped_true_ = __webpack_require__("c470");

// CONCATENATED MODULE: ./src/components/ui/formPhoneVerification/formPhoneVerification.vue






/* normalize component */

var formPhoneVerification_component = normalizeComponent(
  formPhoneVerification_formPhoneVerificationvue_type_script_lang_js_,
  formPhoneVerificationvue_type_template_id_54c42e66_scoped_true_render,
  formPhoneVerificationvue_type_template_id_54c42e66_scoped_true_staticRenderFns,
  false,
  null,
  "54c42e66",
  null
  
)

/* harmony default export */ var formPhoneVerification = (formPhoneVerification_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/notice-region.vue?vue&type=template&id=d596974c&scoped=true&
var notice_regionvue_type_template_id_d596974c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('Loader'):_c('div',{staticClass:"p-9 region-notice"},[_c('bim-text',{staticClass:"mb-6",attrs:{"type":"main","bold":""}},[_vm._v("Укажите ваше местоположение")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.slide === 0),expression:"slide === 0"}]},[_c('bim-text',{attrs:{"type":"medium"}},[_vm._v("Ваш регион "+_vm._s(_vm.regionSuggest)+"?")]),_c('div',{staticClass:"mt-6 region-notice__button-wrapper"},[_c('bim-button',{staticClass:"mr-9",attrs:{"label":"Нет","color":"gray"},on:{"click":_vm.onAnswerNegative}}),_c('bim-button',{attrs:{"label":"Да"},on:{"click":_vm.onAnswerPositive}})],1)],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.slide === 1),expression:"slide === 1"}]},[_c('bim-select',{attrs:{"placeholder":"Выберите регион","options":_vm.regionsList,"valueName":"id","labelName":"name","listPosition":"top","width":"100%"},model:{value:(_vm.region),callback:function ($$v) {_vm.region=$$v},expression:"region"}}),_c('bim-button',{staticClass:"region-notice__save-button mt-6",attrs:{"disabled":!_vm.region,"label":"Сохранить"},on:{"click":_vm.saveRegion}})],1)],1)}
var notice_regionvue_type_template_id_d596974c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-region.vue?vue&type=template&id=d596974c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimSelect/bimSelect.vue?vue&type=template&id=d87d93f8&scoped=true&lang=html&
var bimSelectvue_type_template_id_d87d93f8_scoped_true_lang_html_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select__form__wrp",class:{disabled: _vm.disabled},style:(("\n    width: " + _vm.computedWidth + ";\n  ")),on:{"click":_vm.onSelectWrpClick}},[_c('div',{staticClass:"select__cnt",on:{"click":_vm.onFocus}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterText),expression:"filterText"}],ref:"search",staticClass:"input__form",class:{
        error__form: _vm.observableError,
        infocus: _vm.inFocus || _vm.optionsPressed,
        disabled: _vm.disabled
      },attrs:{"placeholder":_vm.currentLabel && !_vm.inFocus ? '' : _vm.placeholder,"autocomplete":"off","type":"text","disabled":_vm.inFocus && !_vm.searchable},domProps:{"value":(_vm.filterText)},on:{"focus":_vm.onFocus,"input":[function($event){if($event.target.composing){ return; }_vm.filterText=$event.target.value},function($event){return _vm.$emit('filter', $event.target.value)}],"blur":_vm.onBlurInput}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentLabel && !_vm.inFocus),expression:"currentLabel && !inFocus"}],staticClass:"select__label"},[_vm._v(_vm._s(_vm.currentLabel))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"arrow__icon__wrp",class:{disabled: _vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.onIconClicked($event)}}},[_c('div',{staticClass:"arrow__icon",class:{ up__icon: _vm.inFocus },domProps:{"innerHTML":_vm._s(__webpack_require__("37be"))}})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"load__icon"},[_c('div'),_c('div'),_c('div')])]),(_vm.showReset && _vm.value)?_c('div',{staticClass:"reset__icon__wrp",on:{"click":function($event){return _vm.optionClicked('')}}},[_c('div',{staticClass:"reset__icon",domProps:{"innerHTML":_vm._s(__webpack_require__("ffed"))}})]):_vm._e(),(_vm.filteredOptions.length)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.inFocus),expression:"inFocus"}],key:_vm.getListKey(),staticClass:"options__items",class:_vm.listPosition,style:({ maxHeight: _vm.maxHeight }),on:{"mousedown":function($event){_vm.optionsPressed = true}}},[_vm._l((_vm.filteredOptions),function(option,index){return _c('li',{key:("" + (option[_vm.valueName]) + index),staticClass:"option__item",class:{ selected: option[_vm.valueName] === _vm.observableValue },on:{"click":function($event){$event.stopPropagation();return _vm.optionClicked(option[_vm.valueName])}}},[_vm._v(" "+_vm._s(option[_vm.labelName])+" ")])}),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filteredOptions.length && _vm.filterText),expression:"!filteredOptions.length && filterText"}],staticClass:"empty__item"},[_vm._v(" Ничего не найдено ")])],2):_vm._e(),_vm._t("default"),(!_vm.observableError && _vm.desc)?_c('div',{staticClass:"desc__block"},[_vm._v(_vm._s(_vm.desc))]):_vm._e(),_c('bimErrorField',{attrs:{"error":_vm.observableError}})],2)}
var bimSelectvue_type_template_id_d87d93f8_scoped_true_lang_html_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/form/bimSelect/bimSelect.vue?vue&type=template&id=d87d93f8&scoped=true&lang=html&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/form/bimSelect/bimSelect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var bimSelectvue_type_script_lang_js_ = ({
  name: 'bimSelect',
  mixins: [validation_form_mixin],
  components: {
    bimErrorField: bimErrorField
  },
  props: {
    /**
     * Возможность очистить селект
     */
    showReset: Boolean,
    /**
     * Поясняющая подсказка снизу
     */
    desc: String,
    /**
     * Делает селект не активный
     */
    disabled: Boolean,
    /**
     * Возможность поиска
     */
    searchable: {
      type: Boolean,
      default: true
    },
    /**
     * Значение селекта (берется из v-model)
     */
    value: {
      type: [String, Number]
    },
    /**
     * Текст селекта
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Массив options
     */
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /*
    * Показываем иконку что идет загрузка списка
    */
    isLoading: {
      type: Boolean,
      default: false
    },
    /**
     * Какое поле прописывать в option в качестве текста
     */
    labelName: {
      type: String,
      default: 'label'
    },
    /**
     * Какое поле возвращать в v-model из текущего объекта
     */
    valueName: {
      type: String,
      default: 'value'
    },
    /**
     * Ширина
     */
    width: {
      type: [String, Number],
      default: '300'
    },
    /**
     * Максимальная высота списка
     */
    maxHeight: {
      type: String,
      default: '175px'
    },
    /**
     * Позиционирование списка<br/>
     * top/bottom
     */
    listPosition: {
      type: String,
      default: 'bottom'
    }
  },
  data: function data() {
    return {
      filterText: '',
      // поиск в списке
      currentLabel: '',
      // label выбранного элемента
      observableValue: this.value,
      // value выбранного элемента
      inFocus: false,
      optionsPressed: false,
      // зажали мышкой на блоке options
      blurTime: null
    };
  },
  mounted: function mounted() {
    if (this.observableValue && this.options.length) {
      this.selectOption(this.observableValue);
    }
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  computed: {
    filteredOptions: function filteredOptions() {
      var _this = this;
      if (!this.filterText) {
        return this.options;
      }
      var filter = String(this.filterText).toLowerCase();
      return this.options.filter(function (option) {
        var label = String(option[_this.labelName]).toLowerCase();
        return ~label.indexOf(filter);
      });
    },
    computedWidth: function computedWidth() {
      if (+this.width) {
        return this.width + 'px';
      } else {
        return this.width;
      }
    },
    selectId: function selectId() {
      var randomNumber = function randomNumber(min, max) {
        var rand = min - 0.5 + Math.random() * (max - min + 1);
        return Math.round(rand);
      };
      return randomNumber(1234, 9786432);
    }
  },
  methods: {
    onIconClicked: function onIconClicked(e) {
      e.stopPropagation();
      this.optionsPressed = false;
      if (this.inFocus) {
        this.onBlurInput();
      } else {
        this.onFocus();
      }
    },
    onFocus: function onFocus(e) {
      this.inFocus = true;
      if (e && e.target.value) {
        this.$emit('filter', e.target.value);
      }
    },
    onDocumentClick: function onDocumentClick(e) {
      if (!this.inFocus) {
        return;
      }
      if (e.selectId !== this.selectId) {
        this.onBlurInput();
      }
    },
    onSelectWrpClick: function onSelectWrpClick(e) {
      e.selectId = this.selectId;
    },
    onBlurInput: function onBlurInput() {
      if (this.optionsPressed) {
        return;
      }
      this.inFocus = false;
      if (this.filterText) {
        this.$emit('filter', '');
      }
      this.filterText = '';
      this.selectOption(this.observableValue);
      this.blurTime = new Date().getTime();
    },
    optionClicked: function optionClicked(value) {
      this.filterText = '';
      this.selectOption(value);
      this.inFocus = false;
      this.optionsPressed = false;
    },
    selectOption: function selectOption(value, emitValue) {
      if (emitValue === void 0) {
        emitValue = true;
      }
      var currentLabel = this.getCurrentLabel(value);
      var oldValue = this.observableValue;
      if (currentLabel) {
        this.observableValue = value;
        this.currentLabel = currentLabel;
      } else {
        this.observableValue = '';
        this.currentLabel = '';
      }
      if (emitValue) {
        /**
         * Событие срабатывает при любом выборе, даже того же значения
         * @property value
         */
        this.$emit('input', value);
        if (value !== oldValue) {
          /**
           * Событие срабатывает только когда изменяется значение у селекта
           * @property value
           */
          this.$emit('change', value);
        }
      }
      if (this.$refs.search) {
        this.$refs.search.value = '';
      }
    },
    getCurrentLabel: function getCurrentLabel(value, options) {
      var _this2 = this;
      if (options === void 0) {
        options = [];
      }
      options = options.length ? options : this.options.slice();
      var option = options.find(function (option) {
        return option[_this2.valueName] === value;
      });
      return option ? option[this.labelName] : '';
    },
    getListKey: function getListKey() {
      return String(Math.random());
    }
  },
  watch: {
    inFocus: function inFocus(val) {
      if (!val) this.$emit('blur');
    },
    value: function value(_value) {
      var currentLabel = this.getCurrentLabel(_value);
      if (!currentLabel && this.options.length) {
        this.selectOption(null, true);
      }
      if (currentLabel) {
        this.selectOption(_value, false);
      }
    },
    options: function options(_options) {
      if (!this.getCurrentLabel(this.observableValue, _options)) {
        return;
      }
      this.selectOption(this.observableValue);
    }
  }
});
// CONCATENATED MODULE: ./src/components/form/bimSelect/bimSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimSelect_bimSelectvue_type_script_lang_js_ = (bimSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/form/bimSelect/bimSelect.vue?vue&type=style&index=0&id=d87d93f8&prod&lang=scss&scoped=true&
var bimSelectvue_type_style_index_0_id_d87d93f8_prod_lang_scss_scoped_true_ = __webpack_require__("67a6");

// CONCATENATED MODULE: ./src/components/form/bimSelect/bimSelect.vue






/* normalize component */

var bimSelect_component = normalizeComponent(
  bimSelect_bimSelectvue_type_script_lang_js_,
  bimSelectvue_type_template_id_d87d93f8_scoped_true_lang_html_render,
  bimSelectvue_type_template_id_d87d93f8_scoped_true_lang_html_staticRenderFns,
  false,
  null,
  "d87d93f8",
  null
  
)

/* harmony default export */ var bimSelect = (bimSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/notice-region.vue?vue&type=script&lang=js&
function notice_regionvue_type_script_lang_js_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ notice_regionvue_type_script_lang_js_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function notice_regionvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function notice_regionvue_type_script_lang_js_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { notice_regionvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { notice_regionvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var notice_regionvue_type_script_lang_js_ = ({
  name: 'NoticeRegion',
  components: {
    bimButton: bimButton,
    bimSelect: bimSelect,
    bimText: bimText,
    Loader: loader
  },
  props: {
    apiHost: String
  },
  data: function data() {
    return {
      slide: 0,
      region: '',
      regionsList: [],
      isLoading: false,
      regionSuggest: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    return notice_regionvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/notice_regionvue_type_script_lang_js_regeneratorRuntime().mark(function _callee() {
      var info;
      return notice_regionvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.isLoading = true;
            _context.prev = 1;
            _context.next = 4;
            return getInformationAboutIP();
          case 4:
            info = _context.sent;
            _this.regionSuggest = info.location.data.region;
            _context.next = 8;
            return _this.fetchRegions();
          case 8:
            _this.regionsList = _context.sent;
            _this.region = _this.regionsList.find(function (region) {
              return region.name === _this.regionSuggest;
            }).id;
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            _this.slide++;
          case 15:
            _this.isLoading = false;
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12]]);
    }))();
  },
  methods: {
    onAnswerNegative: function onAnswerNegative() {
      this.slide++;
    },
    fetchRegions: function fetchRegions() {
      var _this2 = this;
      return notice_regionvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/notice_regionvue_type_script_lang_js_regeneratorRuntime().mark(function _callee2() {
        var resp, result;
        return notice_regionvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch(_this2.apiHost + "/dictionary/federalSubjects", {
                headers: {
                  Accept: 'application/json'
                }
              });
            case 2:
              resp = _context2.sent;
              if (!resp.ok) {
                _context2.next = 9;
                break;
              }
              _context2.next = 6;
              return resp.json();
            case 6:
              _context2.t0 = _context2.sent;
              _context2.next = 10;
              break;
            case 9:
              _context2.t0 = [];
            case 10:
              result = _context2.t0;
              return _context2.abrupt("return", result.sort(function (a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              }));
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onAnswerPositive: function onAnswerPositive() {
      this.emitSave(this.region);
    },
    saveRegion: function saveRegion() {
      this.emitSave(this.region);
    },
    emitSave: function emitSave(location) {
      var _this3 = this;
      this.isLoading = true;
      this.$emit('save', {
        type: 'user',
        payload: {
          location: location
        },
        onFinish: function onFinish() {
          _this3.isLoading = false;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-region.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimNotices_notice_regionvue_type_script_lang_js_ = (notice_regionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimNotices/notice-region.vue?vue&type=style&index=0&id=d596974c&prod&lang=scss&scoped=true&
var notice_regionvue_type_style_index_0_id_d596974c_prod_lang_scss_scoped_true_ = __webpack_require__("ca54");

// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-region.vue






/* normalize component */

var notice_region_component = normalizeComponent(
  bimNotices_notice_regionvue_type_script_lang_js_,
  notice_regionvue_type_template_id_d596974c_scoped_true_render,
  notice_regionvue_type_template_id_d596974c_scoped_true_staticRenderFns,
  false,
  null,
  "d596974c",
  null
  
)

/* harmony default export */ var notice_region = (notice_region_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/notice-occupation.vue?vue&type=template&id=24d62e3c&scoped=true&
var notice_occupationvue_type_template_id_24d62e3c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-9 region-notice"},[(_vm.isLoading)?_c('Loader'):_vm._e(),_c('bim-text',{staticClass:"mb-6",attrs:{"type":"main","bold":""}},[_vm._v("Расскажите нам, где вы работаете?")]),_c('bim-text',{attrs:{"type":"medium"}},[_vm._v("Если вы укажете сферу деятельности и компанию, мы сможем оптимизировать для вас показы моделей")]),_c('bim-input',{staticClass:"mt-6",attrs:{"placeholder":"Компания"},model:{value:(_vm.form.companyName),callback:function ($$v) {_vm.$set(_vm.form, "companyName", $$v)},expression:"form.companyName"}}),_c('bim-select',{staticClass:"mt-6",attrs:{"placeholder":"Сфера деятельности","options":_vm.listRoles,"listPosition":"top","width":"100%","formModel":_vm._self,"formKey":"form.role"},model:{value:(_vm.form.role),callback:function ($$v) {_vm.$set(_vm.form, "role", $$v)},expression:"form.role"}}),_c('bim-select',{staticClass:"mt-6",attrs:{"placeholder":"Специализация","options":_vm.listSpecialisations,"disabled":_vm.form.role !== 'designer',"listPosition":"top","width":"100%"},model:{value:(_vm.form.specialisation),callback:function ($$v) {_vm.$set(_vm.form, "specialisation", $$v)},expression:"form.specialisation"}}),_c('div',{staticClass:"mt-6 toast__button-wrapper"},[_c('bim-button',{staticClass:"mr-9 toast__button",attrs:{"label":"Отмена","color":"gray"},on:{"click":_vm.onAnswerNegative}}),_c('bim-button',{staticClass:"toast__button",attrs:{"label":"Отправить"},on:{"click":_vm.onAnswerPositive}})],1)],1)}
var notice_occupationvue_type_template_id_24d62e3c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-occupation.vue?vue&type=template&id=24d62e3c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/notice-occupation.vue?vue&type=script&lang=js&
function notice_occupationvue_type_script_lang_js_extends() { notice_occupationvue_type_script_lang_js_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return notice_occupationvue_type_script_lang_js_extends.apply(this, arguments); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var notice_occupationvue_type_script_lang_js_ = ({
  name: 'NoticeRegion',
  components: {
    bimInput: bimInput,
    bimButton: bimButton,
    bimSelect: bimSelect,
    bimText: bimText,
    Loader: loader
  },
  props: {
    user: Object
  },
  data: function data() {
    return {
      isLoading: false,
      form: notice_occupationvue_type_script_lang_js_extends({
        role: '',
        specialisation: '',
        companyName: ''
      }, this.user.context || {})
    };
  },
  watch: {
    'form.role': function formRole(role) {
      if (role !== 'designer') {
        this.form.specialisation = '';
      }
    }
  },
  mounted: function mounted() {
    if (this.form.role !== 'designer') {
      this.form.specialisation = '';
    }
  },
  methods: {
    onAnswerNegative: function onAnswerNegative() {
      this.emitCancel();
    },
    onAnswerPositive: function onAnswerPositive() {
      if (!this.$v2.forceValidateForm()) return;
      this.emitSave(this.form);
    },
    emitSave: function emitSave(payload) {
      var _this = this;
      this.isLoading = true;
      this.$emit('save', {
        type: 'context',
        payload: payload,
        onFinish: function onFinish() {
          _this.isLoading = false;
        }
      });
    },
    emitCancel: function emitCancel() {
      this.$emit('close');
    }
  },
  computed: {
    listSpecialisations: function listSpecialisations() {
      return this.$bimTranslate('signUp.specialisations', 'ru').map(function (label) {
        return {
          label: label,
          value: label
        };
      });
    },
    listRoles: function listRoles() {
      return Object.entries(this.$bimTranslate('signUp.roles', 'ru')).map(function (_ref) {
        var value = _ref[0],
          label = _ref[1];
        return {
          value: value,
          label: label
        };
      });
    },
    formValidation: function formValidation() {
      return {
        'form.role': ['required']
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-occupation.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimNotices_notice_occupationvue_type_script_lang_js_ = (notice_occupationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimNotices/notice-occupation.vue?vue&type=style&index=0&id=24d62e3c&prod&lang=scss&scoped=true&
var notice_occupationvue_type_style_index_0_id_24d62e3c_prod_lang_scss_scoped_true_ = __webpack_require__("d240");

// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-occupation.vue






/* normalize component */

var notice_occupation_component = normalizeComponent(
  bimNotices_notice_occupationvue_type_script_lang_js_,
  notice_occupationvue_type_template_id_24d62e3c_scoped_true_render,
  notice_occupationvue_type_template_id_24d62e3c_scoped_true_staticRenderFns,
  false,
  null,
  "24d62e3c",
  null
  
)

/* harmony default export */ var notice_occupation = (notice_occupation_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/notice-default.vue?vue&type=template&id=162ff93b&scoped=true&
var notice_defaultvue_type_template_id_162ff93b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentContext.is,_vm._b({tag:"component",staticClass:"p-9 notice-default",on:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.componentContext.bind,false),[_c('bim-text',{staticClass:"notice-default__title",attrs:{"type":"main","bold":""}},[_vm._v(" "+_vm._s(_vm.notice.title)+" ")]),(_vm.notice.text)?_c('bim-text',{staticClass:"mt-6 notice-default__text",attrs:{"type":"medium"}},[_vm._v(" "+_vm._s(_vm.notice.text)+" ")]):_vm._e()],1)}
var notice_defaultvue_type_template_id_162ff93b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-default.vue?vue&type=template&id=162ff93b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/notice-default.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var notice_defaultvue_type_script_lang_js_ = ({
  name: 'NoticeRegion',
  components: {
    bimText: bimText
  },
  props: {
    /**
     * Объект уведомления
     */
    notice: Object
  },
  computed: {
    componentContext: function componentContext() {
      var urlTransition = Object(lodash["get"])(this.notice, 'parameters.urlTransition');
      var urlTarget = Object(lodash["get"])(this.notice, 'parameters.urlTarget');
      var urlRel = Object(lodash["get"])(this.notice, 'parameters.urlRel');
      var type = Object(lodash["get"])(this.notice, 'parameters.type');
      if (type === 'transition' && urlTransition) {
        return {
          is: 'a',
          bind: {
            href: urlTransition,
            target: urlTarget || '_blank',
            rel: Object.entries(urlRel || {
              nofollow: true
            }).map(function (_ref) {
              var label = _ref[0],
                value = _ref[1];
              return value ? label : null;
            }).filter(Boolean).join(' ')
          }
        };
      }
      return {
        is: 'div',
        bind: {}
      };
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-default.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimNotices_notice_defaultvue_type_script_lang_js_ = (notice_defaultvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/core/bimNotices/notice-default.vue?vue&type=style&index=0&id=162ff93b&prod&lang=scss&scoped=true&
var notice_defaultvue_type_style_index_0_id_162ff93b_prod_lang_scss_scoped_true_ = __webpack_require__("5c75");

// CONCATENATED MODULE: ./src/components/core/bimNotices/notice-default.vue






/* normalize component */

var notice_default_component = normalizeComponent(
  bimNotices_notice_defaultvue_type_script_lang_js_,
  notice_defaultvue_type_template_id_162ff93b_scoped_true_render,
  notice_defaultvue_type_template_id_162ff93b_scoped_true_staticRenderFns,
  false,
  null,
  "162ff93b",
  null
  
)

/* harmony default export */ var notice_default = (notice_default_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/NoticeTrialHasExpired.vue?vue&type=template&id=6ea81d7a&
var NoticeTrialHasExpiredvue_type_template_id_6ea81d7a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-9"},[_c('bim-text',{staticClass:"mb-4",attrs:{"type":"main"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('noticeTrialHasExpired.title', _vm.activeLang))+" ")]),_c('bim-text',{staticClass:"mb-6",attrs:{"type":"medium"}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('noticeTrialHasExpired.body', _vm.activeLang))+" ")]),_c('div',{staticClass:"d-flex"},[_c('bim-button',{staticClass:"mr-1",attrs:{"size":"s"},on:{"click":_vm.getATariff}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('noticeTrialHasExpired.ok', _vm.activeLang))+" ")]),_c('bim-button',{staticClass:"ml-auto",attrs:{"size":"s"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" "+_vm._s(_vm.$bimTranslate('noticeTrialHasExpired.cancel', _vm.activeLang))+" ")])],1)],1)}
var NoticeTrialHasExpiredvue_type_template_id_6ea81d7a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/core/bimNotices/NoticeTrialHasExpired.vue?vue&type=template&id=6ea81d7a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/core/bimNotices/NoticeTrialHasExpired.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NoticeTrialHasExpiredvue_type_script_lang_js_ = ({
  name: 'NoticeTrialHasExpired',
  components: {
    bimText: bimText,
    bimButton: bimButton
  },
  props: {
    activeLang: {
      type: String,
      default: 'ru',
      validator: function validator(value) {
        return ['ru', 'en'].indexOf(value) !== -1;
      }
    }
  },
  methods: {
    getATariff: function getATariff() {
      this.$emit('open-request-popup');
      this.$emit('close');
    }
  }
});
// CONCATENATED MODULE: ./src/components/core/bimNotices/NoticeTrialHasExpired.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimNotices_NoticeTrialHasExpiredvue_type_script_lang_js_ = (NoticeTrialHasExpiredvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/core/bimNotices/NoticeTrialHasExpired.vue





/* normalize component */

var NoticeTrialHasExpired_component = normalizeComponent(
  bimNotices_NoticeTrialHasExpiredvue_type_script_lang_js_,
  NoticeTrialHasExpiredvue_type_template_id_6ea81d7a_render,
  NoticeTrialHasExpiredvue_type_template_id_6ea81d7a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NoticeTrialHasExpired = (NoticeTrialHasExpired_component.exports);
// CONCATENATED MODULE: ./src/utils/polyfills.js
function closest(el, selector) {
  var matchesFn;

  // find vendor prefix
  ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
    if (typeof document.body[fn] === 'function') {
      matchesFn = fn;
      return true;
    }
    return false;
  });
  var parent;

  // traverse parents
  while (el) {
    parent = el.parentElement;
    if (parent && parent[matchesFn](selector)) {
      return parent;
    }
    el = parent;
  }
  return null;
}

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimNotices/bimNotices.vue?vue&type=script&lang=js&
function bimNoticesvue_type_script_lang_js_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ bimNoticesvue_type_script_lang_js_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function bimNoticesvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function bimNoticesvue_type_script_lang_js_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { bimNoticesvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { bimNoticesvue_type_script_lang_js_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function bimNoticesvue_type_script_lang_js_extends() { bimNoticesvue_type_script_lang_js_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bimNoticesvue_type_script_lang_js_extends.apply(this, arguments); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var lsKeyAutoShow = 'lsNoticesAutoShow';
/* harmony default export */ var bimNoticesvue_type_script_lang_js_ = ({
  name: 'bimNotices',
  components: {
    bimText: bimText,
    bimCheckbox: bimCheckbox,
    bimButton: bimButton
  },
  props: {
    /**
     * passport-service api url
     */
    apiHost: String,
    /**
     * Объект пользователя
     */
    user: Object,
    /**
     * Логирующая функция /log/event
     */
    logActionEvent: {
      type: Function,
      default: function _default() {}
    },
    /**
     * Свой массив уведомлений
     */
    customNoticesList: {
      type: Array,
      default: null
    },
    /**
     * Насильно показать список
     */
    forceShow: {
      type: Boolean,
      default: null
    },
    /**
     * Делать проверку на новые уведомления
     */
    checkNewNotices: {
      type: Boolean,
      default: true
    },
    /**
     * Timeout для запроса информации
     * о новых нотисах в мс
     */
    checkNewNoticesPeriod: {
      type: Number,
      default: 60000
    }
  },
  data: function data() {
    return {
      checkAll: false,
      showList: false,
      noticesList: [],
      hasNewNotices: false,
      activeNotices: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.fetchNotices().then(function (notices) {
      if (!notices) return;
      var href = window.location.href;
      var noticesWithAutoShowParam = notices.filter(function (notice) {
        return (notice.parameters || {}).urlAutoShow;
      });
      noticesWithAutoShowParam.filter(function (notice) {
        if (notice.seenAt) return false;
        return href.includes(Object(lodash["get"])(notice, 'parameters.urlAutoShow'));
      }).forEach(_this.handleAutoShowNotice);
      _this.localStorageLeaveActualNotices(noticesWithAutoShowParam);
    });
    if (this.customNoticesList) {
      this.noticesList = this.customNoticesList;
    }
    this.hideListOnClickOutside = this.hideListOnClickOutside.bind(this);
    this.closeToast = this.closeToast.bind(this);

    /* постоянная проверка на наличие новых нотисов */
    this.checkForNewNotices();
  },
  computed: {
    /**
     * есть ли непросмотренные нотисы
     */
    hasUnseenNotifications: function hasUnseenNotifications() {
      return this.hasNewNotices || this.noticesList.filter(function (notice) {
        return !notice.seenAt;
      }).length > 0;
    },
    /**
     * количество нотисов
     */
    noticesCountText: function noticesCountText() {
      var count = this.noticesList.length;
      if (!count) return 'Нет уведомлений';
      var translations = ['уведомление', 'уведомления', 'уведомлений'];
      return count + " " + declOfNum(count, translations);
    },
    /**
     * отсортированный список нотисов по просмотрам
     */
    sortedNoticesList: function sortedNoticesList() {
      return [].concat(this.noticesList).sort(function (a, b) {
        if (!a.seenAt) return -1;
        if (!b.seenAt) return 0;
        return b.seenAt - a.seenAt;
      });
    },
    /**
     * Количество отмеченных уведомлений
     */
    countCheckedNotices: function countCheckedNotices() {
      return this.noticesList.filter(function (n) {
        return n.check;
      }).length;
    }
  },
  watch: {
    customNoticesList: function customNoticesList(list) {
      this.noticesList = list;
    },
    /**
     * при показе запрашивает список нотисов
     *
     * также добавляет/удаляет обработчик по клику вне списка
     * для его скрытия
     */
    showList: function showList(show) {
      var _this2 = this;
      try {
        if (show) {
          this.fetchNotices();
          setTimeout(function () {
            window.addEventListener('click', _this2.hideListOnClickOutside);
          });
        } else {
          window.removeEventListener('click', this.hideListOnClickOutside);
        }
      } catch (e) {}
    }
  },
  methods: {
    /**
     * Оставляет в localStorage только
     * актуальные нотисы которые есть
     * у пользователя, сделано чтобы
     * не переполнять хранилище
     */
    localStorageLeaveActualNotices: function localStorageLeaveActualNotices(notices) {
      try {
        localStorage.setItem(lsKeyAutoShow, pick(JSON.parse(localStorage.getItem(lsKeyAutoShow)), notices.map(function (n) {
          return n.code;
        })));
      } catch (e) {}
    },
    /**
     * определяет каким будет
     * элемент списка нотисов
     * в зависимости от типа
     */
    getNoticeComponent: function getNoticeComponent(notice) {
      var _this3 = this;
      var urlTransition = Object(lodash["get"])(notice, 'parameters.urlTransition');
      var urlTarget = Object(lodash["get"])(notice, 'parameters.urlTransition');
      var type = Object(lodash["get"])(notice, 'parameters.type');
      if (type === 'transition' && urlTransition) {
        /* rel для ссылок на другие сайты */
        var rel = !urlTransition.match(/\.?bimlib\..*\/?/) && !!urlTransition.indexOf('/') && 'nofollow';
        return {
          is: 'a',
          bind: {
            href: urlTransition,
            target: urlTarget || '_blank',
            rel: rel
          },
          listeners: {
            click: function click(e) {
              e.stopPropagation();
              if (!notice.seenAt && !_this3.customNoticesList) {
                _this3.seeNotice(notice);
              }
            }
          }
        };
      }
      return {
        is: 'div',
        bind: {},
        listeners: {
          click: function click() {
            return _this3.showNotice(notice);
          }
        }
      };
    },
    /**
     * Удаление всех отмеченных уведомлений
     */
    deleteAllCheckedNotifications: function deleteAllCheckedNotifications() {
      var _this4 = this;
      this.checkAll = false;
      this.noticesList.forEach(function (notice, index, noticesList) {
        if (!notice.check) return;
        _this4.deleteNotice(notice);
        _this4.$set(noticesList, index, bimNoticesvue_type_script_lang_js_extends({}, notice, {
          check: false
        }));
      });
    },
    /**
     * Выставление всем нотисам одного значения
     * @param {Boolean} value
     */
    setCheckToAllNotices: function setCheckToAllNotices(value) {
      var _this5 = this;
      this.noticesList.forEach(function (notice, index, list) {
        _this5.$set(list, index, bimNoticesvue_type_script_lang_js_extends({}, notice, {
          check: value
        }));
      });
    },
    /**
     * Проверка что все галки выставлены
     *
     * если да - отмечаем чекбокс 'выбрать все'
     * иначе его убираем
     */
    checkForAllNotices: function checkForAllNotices() {
      var _this6 = this;
      return bimNoticesvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/bimNoticesvue_type_script_lang_js_regeneratorRuntime().mark(function _callee() {
        return bimNoticesvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this6.$nextTick();
            case 2:
              if (_this6.countCheckedNotices < _this6.noticesList.length) {
                _this6.checkAll = false;
              }
              if (_this6.countCheckedNotices === _this6.noticesList.length) {
                _this6.checkAll = true;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * Просмотр всех отмеченных нотисов
     */
    seeAllCheckedNotifications: function seeAllCheckedNotifications() {
      var _this7 = this;
      this.checkAll = false;
      this.noticesList.forEach(function (notice, index, noticesList) {
        if (!notice.check) return;
        _this7.$set(noticesList, index, bimNoticesvue_type_script_lang_js_extends({}, notice, {
          check: false
        }));
        if (!notice.seenAt) _this7.seeNotice(notice);
      });
    },
    /**
     * Закрытие тоста нотиса
     */
    closeToast: function closeToast(toast, notice) {
      this.activeNotices.splice(this.activeNotices.indexOf(notice.code + Object(lodash["get"])(notice, 'parameters.position')), 1);
      if (toast.$el.parentNode) {
        toast.$el.parentNode.removeChild(toast.$el.parentNode.childNodes[0]);
      }
    },
    /**
     * Проверка но новые нотисы
     */
    checkForNewNotices: function checkForNewNotices() {
      var _this8 = this;
      if (!this.checkNewNotices) return;
      setTimeout(function () {
        _this8.checkForNewNotices();
      }, this.checkNewNoticesPeriod);
      if (this.hasUnseenNotifications) return;
      return fetch(this.apiHost + "/passport/users/me/notifications/unseen").then(function (r) {
        return r.json();
      }).then(function (hasNewNotices) {
        _this8.hasNewNotices = hasNewNotices;
      }).catch(function (e) {
        if (e.status) {
          console.error("checkForNewNotices [" + e.status + "] " + e.statusText);
        } else {
          console.error("checkForNewNotices " + e);
        }
      });
    },
    /**
     * Открытие списка нотисов с логированием
     */
    openNotificationsList: function openNotificationsList() {
      this.showList = true;
      this.logActionEvent('open notice list');
    },
    /**
     * ренден уникального нотиса
     *
     * @param {Object} component - компонент нотиса,
     * который может вызывать события:
     *
     * * close - для скрытия нотиса
     * * save - для сохранения данных
     * * * функция save принимает следующие аргументы -
     * * * @param {String} type [context, user] - что сохранять (поле context или объект пользователя)
     * * * @param {Object} payload - сохраняемый объект
     * * * @param {Function} onFinish - вызывается после завершения сохранения с любым исходом
     *
     * @param {Object} notice - объект нотиса
     *
     * @param {Object} props - дополнительные пропсы для компонента
     */
    renderNotice: function renderNotice(component, notice, props, on) {
      var _component$computed;
      if (props === void 0) {
        props = {};
      }
      if (on === void 0) {
        on = {};
      }
      var deleteNotice = this.deleteNotice.bind(this);
      var closeToast = this.closeToast,
        $user = this.$user;
      var toast = this.$toast({
        render: function render(h) {
          return h(component, {
            props: props,
            on: bimNoticesvue_type_script_lang_js_extends({}, on, {
              close: function close() {
                closeToast(toast, notice);
              },
              save: function save(_ref) {
                return bimNoticesvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/bimNoticesvue_type_script_lang_js_regeneratorRuntime().mark(function _callee2() {
                  var type, payload, _ref$onFinish, onFinish;
                  return bimNoticesvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        type = _ref.type, payload = _ref.payload, _ref$onFinish = _ref.onFinish, onFinish = _ref$onFinish === void 0 ? function () {} : _ref$onFinish;
                        _context2.prev = 1;
                        _context2.t0 = type;
                        _context2.next = _context2.t0 === 'context' ? 5 : _context2.t0 === 'user' ? 8 : 11;
                        break;
                      case 5:
                        _context2.next = 7;
                        return $user.setParams(payload);
                      case 7:
                        return _context2.abrupt("break", 12);
                      case 8:
                        _context2.next = 10;
                        return $user.updateContext(payload, 'PATCH');
                      case 10:
                        return _context2.abrupt("break", 12);
                      case 11:
                        throw new Error("renderNotice.save unknow type: " + type);
                      case 12:
                        deleteNotice(notice);
                        _context2.next = 18;
                        break;
                      case 15:
                        _context2.prev = 15;
                        _context2.t1 = _context2["catch"](1);
                        console.error(_context2.t1);
                      case 18:
                        _context2.prev = 18;
                        onFinish();
                        closeToast(toast, notice);
                        return _context2.finish(18);
                      case 22:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[1, 15, 18, 22]]);
                }))();
              }
            })
          });
        }
      }, bimNoticesvue_type_script_lang_js_extends({
        duration: 15000,
        position: Object(lodash["get"])(notice, 'parameters.position', 'bottomEnd'),
        onClose: function onClose() {
          return closeToast(toast, notice);
        }
      }, (_component$computed = component.computed) != null && _component$computed.toastSettings ? component.computed.toastSettings() : {}));
      return toast;
    },
    /**
     * вызывает события обновления контекста пользователя
     */
    emitUpdateContext: function emitUpdateContext(context) {
      this.$emit('updateContext', context);
    },
    /**
     * Обработка просмотра нотиса
     *
     * если он еще не просматривался (нет поля seenAt)
     * отправится запрос на просмотр
     *
     * в зависимости от кода (code) нотиса показывает
     * либо уникальный нотис, либо обычный с текстом
     */
    showNotice: function showNotice(notice, _temp) {
      var _this9 = this;
      return bimNoticesvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/bimNoticesvue_type_script_lang_js_regeneratorRuntime().mark(function _callee3() {
        var _ref2, _ref2$seeNotice, seeNotice, seenAt, code, toast, close;
        return bimNoticesvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref2 = _temp === void 0 ? {} : _temp, _ref2$seeNotice = _ref2.seeNotice, seeNotice = _ref2$seeNotice === void 0 ? true : _ref2$seeNotice;
              seenAt = notice.seenAt, code = notice.code;
              if (!_this9.activeNotices.includes(code)) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              _this9.activeNotices.push(code + Object(lodash["get"])(notice, 'parameters.position'));
              if (seeNotice && !_this9.customNoticesList && !seenAt) {
                _this9.seeNotice(notice);
              }
              close = function close(_ref3) {
                var target = _ref3.target;
                if (!toast) return;
                if (!closest(target, '.bim-toast')) {
                  window.removeEventListener('click', close);
                  _this9.closeToast(toast, notice);
                }
              };
              if (code === 'region') {
                toast = _this9.renderNotice(notice_region, notice, {
                  apiHost: _this9.apiHost
                });
              } else if (code === 'occupation') {
                toast = _this9.renderNotice(notice_occupation, notice, {
                  user: _this9.user
                });
              } else if (code === 'phone') {
                toast = _this9.renderNotice(formPhoneVerification, notice, {
                  user: _this9.user
                });
              } else if (code === 'library.demo.access') {
                toast = _this9.renderNotice(NoticeTrialHasExpired, notice, {
                  user: _this9.user
                }, {
                  'open-request-popup': function openRequestPopup() {
                    return _this9.$emit('open-request-popup');
                  }
                });
              } else {
                toast = _this9.renderNotice(notice_default, notice, {
                  notice: notice
                }, {
                  click: function click() {
                    var _ref4 = notice.parameters || {},
                      urlTransition = _ref4.urlTransition,
                      type = _ref4.type;
                    if (type === 'transition' && urlTransition) {
                      _this9.seeNotice(notice);
                      _this9.closeToast(toast, notice);
                    }
                  }
                });
              }
              setTimeout(function () {
                window.addEventListener('click', close);
              });
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    /**
     * Прячет список уведомлений по клику вне списка
     */
    hideListOnClickOutside: function hideListOnClickOutside(_ref5) {
      var target = _ref5.target;
      if (!closest(target, '.notices__list-wrapper')) {
        this.showList = false;
      }
    },
    /**
     * Запрос списка нотисов
     */
    fetchNotices: function fetchNotices() {
      var _this10 = this;
      return bimNoticesvue_type_script_lang_js_asyncToGenerator( /*#__PURE__*/bimNoticesvue_type_script_lang_js_regeneratorRuntime().mark(function _callee4() {
        var notices;
        return bimNoticesvue_type_script_lang_js_regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this10.hasNewNotices = false;
              if (!_this10.customNoticesList) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", _this10.customNoticesList);
            case 3:
              _context4.prev = 3;
              _context4.next = 6;
              return fetch(_this10.apiHost + "/passport/users/me/notifications?size=999", {
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(function (r) {
                return r.json();
              }).then(function (r) {
                return r.items;
              });
            case 6:
              notices = _context4.sent;
              _this10.noticesList = notices.map(function (notice) {
                notice.seenAt = +new Date(notice.seenAt);
                return notice;
              });
              return _context4.abrupt("return", notices);
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](3);
              if (_context4.t0.status) {
                console.error("fetchNotices [" + _context4.t0.status + "] " + _context4.t0.statusText);
              } else {
                console.error('fetchNotices', _context4.t0);
              }
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 11]]);
      }))();
    },
    /**
     * Просмотр нотиса
     */
    seeNotice: function seeNotice(notice) {
      var _this11 = this;
      var id = notice.id,
        code = notice.code;
      this.logActionEvent("see notice with code " + (code || 'empty'), {
        item: notice
      });
      return fetch(this.apiHost + "/passport/users/me/notifications/" + id + "/see", {
        method: 'POST'
      }).then(function (_ref6) {
        var status = _ref6.status,
          statusText = _ref6.statusText;
        if (status >= 300) {
          _this11.$toast("\u0427\u0442\u043E \u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 [" + status + "] " + statusText, {
            title: 'Ошибка'
          });
        } else {
          var index = _this11.noticesList.findIndex(function (notice) {
            return notice.id === id;
          });
          _this11.$set(_this11.noticesList, index, bimNoticesvue_type_script_lang_js_extends({}, notice, {
            check: false,
            seenAt: +new Date()
          }));
        }
      }).catch(console.error);
    },
    /**
     * Удаление нотиса
     */
    deleteNotice: function deleteNotice(notice) {
      var _this12 = this;
      var id = notice.id,
        seenAt = notice.seenAt;
      this.logActionEvent('delete notice', {
        item: notice
      });
      if (!seenAt) this.logActionEvent('delete unseen notice', {
        item: notice
      });
      return fetch(this.apiHost + "/passport/users/me/notifications/" + id + "/", {
        method: 'DELETE'
      }).then(function (_ref7) {
        var status = _ref7.status,
          statusText = _ref7.statusText;
        if (status >= 300) {
          _this12.$toast("\u0427\u0442\u043E \u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0435\u0449\u0435 \u0440\u0430\u0437 [" + status + "] " + statusText, {
            title: 'Ошибка'
          });
        } else {
          var index = _this12.noticesList.findIndex(function (notice) {
            return notice.id === id;
          });
          _this12.noticesList.splice(index, 1);
        }
      }).catch(console.error);
    },
    handleAutoShowNotice: function handleAutoShowNotice(notice) {
      var countViews = notice.parameters.countViews,
        code = notice.code;
      var lsNotices;
      try {
        lsNotices = JSON.parse(localStorage.getItem(lsKeyAutoShow));
      } catch (e) {}
      if (!lsNotices) lsNotices = {};
      if (!lsNotices[code]) {
        lsNotices[code] = {
          lastSeen: Date.now(),
          count: 0
        };
      }
      var lastSeen = new Date(lsNotices[code].lastSeen);
      var timeToEndOfDay = Date.now() - lastSeen;

      /**
       * последний показ был больше
       * суток назад, все сбрасываем
       */
      if (timeToEndOfDay >= 86400000) {
        lsNotices[code].lastSeen = new Date();
        lsNotices[code].count = 0;
      }

      /* превышен лимит показов */
      if (lsNotices[code].count >= countViews) return;else ++lsNotices[code].count;
      this.showNotice(notice, {
        seeNotice: false
      });
      localStorage.setItem(lsKeyAutoShow, JSON.stringify(lsNotices));
    }
  },
  filters: {
    /**
     * кастомное отображение даты нотиса
     */
    noticeCorrectDate: function noticeCorrectDate(date) {
      if (!date) return date;
      var publishDate = new Date(date);
      var today = new Date();

      /* разница во времени публикации в минутах */
      var diffPublishedMinutes = (today - publishDate) / 1000 / 60;
      var startOfCurrenttDay = new Date();
      startOfCurrenttDay.setHours(0, 0, 0, 0);

      /* кол-во часов от создания уведомления до текущего дня */
      var hoursToStartDay = (today - startOfCurrenttDay) / 1000 / 60 / 60;

      /* разница во времени публикации в часах */
      var diffPublishedHours = (today - publishDate) / 1000 / 60 / 60;
      if (diffPublishedMinutes < 60) {
        return parseInt(diffPublishedMinutes) + " \u043C\u0438\u043D. \u043D\u0430\u0437\u0430\u0434";
      } else if (diffPublishedHours < hoursToStartDay) {
        return parseInt(diffPublishedHours) + " \u0447. \u043D\u0430\u0437\u0430\u0434";
      } else {
        var addZero = function addZero(num) {
          return parseInt(num) <= 9 ? '0' + num : num;
        };
        return addZero(publishDate.getDate()) + "." + addZero(publishDate.getMonth() + 1) + "." + publishDate.getFullYear();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/ui/bimNotices/bimNotices.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimNotices_bimNoticesvue_type_script_lang_js_ = (bimNoticesvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ui/bimNotices/bimNotices.vue?vue&type=style&index=0&id=3252723b&prod&lang=scss&scoped=true&
var bimNoticesvue_type_style_index_0_id_3252723b_prod_lang_scss_scoped_true_ = __webpack_require__("6144");

// CONCATENATED MODULE: ./src/components/ui/bimNotices/bimNotices.vue






/* normalize component */

var bimNotices_component = normalizeComponent(
  bimNotices_bimNoticesvue_type_script_lang_js_,
  bimNoticesvue_type_template_id_3252723b_scoped_true_render,
  bimNoticesvue_type_template_id_3252723b_scoped_true_staticRenderFns,
  false,
  null,
  "3252723b",
  null
  
)

/* harmony default export */ var bimNotices = (bimNotices_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"449ddda8-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimTopBannerLine/bimTopBannerLine.vue?vue&type=template&id=1dae9183&scoped=true&
var bimTopBannerLinevue_type_template_id_1dae9183_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isHide)?_c('a',{staticClass:"banner-line",attrs:{"href":"https://events.webinar.ru/59717051/446527885?utm_source=bimlib.pro&utm_campaign=webinar22062023","target":"_blank","title":"Подробнее"}},[_c('bim-container',[_c('div',{staticClass:"bl-wrapper"},[_c('div',{staticClass:"bl-content"},[_c('span',{staticClass:"bl-content__icon",domProps:{"innerHTML":_vm._s(__webpack_require__("f7ba"))}}),_c('div',{staticClass:"bl-content__text"},[_vm._v("Регистрация на вебинар "),_c('span',{staticStyle:{"font-weight":"bold","white-space":"nowrap"}},[_vm._v("22 марта в 11:00 МСК")])]),_c('bim-button',{staticClass:"bl-content__btn",attrs:{"size":"s","outline":"","label":"Подробнее"}})],1),_c('div',{staticClass:"bl-close",attrs:{"title":"Скрыть"},domProps:{"innerHTML":_vm._s(__webpack_require__("ffed"))},on:{"click":function($event){$event.preventDefault();return _vm.close($event)}}})])])],1):_vm._e()}
var bimTopBannerLinevue_type_template_id_1dae9183_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ui/bimTopBannerLine/bimTopBannerLine.vue?vue&type=template&id=1dae9183&scoped=true&

// CONCATENATED MODULE: ./src/utils/prepareDate.js
var usePrepareDate = function usePrepareDate() {
  /**
   * @param date Date|undefined
   * */
  function setOffset(date) {
    if (!date) return date;
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  }
  /**
   * @param date Date|undefined
   * */
  function formatDate(date) {
    if (!date) return date;
    return date.toISOString().split('T')[0];
  }
  /**
   * @param date string|undefined
   * */
  function formattedToLocal(date) {
    if (!date) return date;
    return date.split('-').reverse().join('.');
  }
  /**
   * @param date string|undefined
   * */
  function localToFormatted(date) {
    if (!date) return date;
    return date.split('.').reverse().join('-');
  }
  return {
    setOffset: setOffset,
    formatDate: formatDate,
    formattedToLocal: formattedToLocal,
    localToFormatted: localToFormatted
  };
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimTopBannerLine/bimTopBannerLine.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _usePrepareDate = usePrepareDate(),
  setOffset = _usePrepareDate.setOffset;
var key = 'top_banner_22_03';
/* harmony default export */ var bimTopBannerLinevue_type_script_lang_js_ = ({
  name: 'bimTopBannerLine',
  components: {
    bimContainer: bimContainer,
    bimButton: bimButton
  },
  data: function data() {
    return {
      isClosed: 'hide'
    };
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      this.isClosed = sessionStorage.getItem(key);
    }
  },
  computed: {
    isHide: function isHide() {
      var dateNow = setOffset(new Date()).getTime();
      // Wed Mar 22 2023 13:00:00 GMT+0000
      var dateEnd = setOffset(new Date(1679472000000)).getTime();
      return !!(this.isClosed || dateNow > dateEnd);
    }
  },
  methods: {
    close: function close() {
      if (typeof window !== 'undefined') {
        sessionStorage.setItem(key, 'hide');
      }
      this.isClosed = 'hide';
    }
  }
});
// CONCATENATED MODULE: ./src/components/ui/bimTopBannerLine/bimTopBannerLine.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimTopBannerLine_bimTopBannerLinevue_type_script_lang_js_ = (bimTopBannerLinevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ui/bimTopBannerLine/bimTopBannerLine.vue?vue&type=style&index=0&id=1dae9183&prod&scoped=true&lang=scss&
var bimTopBannerLinevue_type_style_index_0_id_1dae9183_prod_scoped_true_lang_scss_ = __webpack_require__("6124");

// CONCATENATED MODULE: ./src/components/ui/bimTopBannerLine/bimTopBannerLine.vue






/* normalize component */

var bimTopBannerLine_component = normalizeComponent(
  bimTopBannerLine_bimTopBannerLinevue_type_script_lang_js_,
  bimTopBannerLinevue_type_template_id_1dae9183_scoped_true_render,
  bimTopBannerLinevue_type_template_id_1dae9183_scoped_true_staticRenderFns,
  false,
  null,
  "1dae9183",
  null
  
)

/* harmony default export */ var bimTopBannerLine = (bimTopBannerLine_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/@vue/cli-plugin-babel/node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ui/bimHeader/bimHeader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ChangeLang from '@/components/core/bimHeader/ChangeLang'







/* harmony default export */ var bimHeadervue_type_script_lang_js_ = ({
  name: 'bimHeader',
  components: {
    bimContainer: bimContainer,
    bimNotices: bimNotices,
    HeadLinks: HeadLinks,
    MobileMenu: MobileMenu,
    // ChangeLang,
    Avatar: Avatar,
    bimTopBannerLine: bimTopBannerLine
  },
  props: {
    /**
     * Логирующая функция для /log/event/
     */
    logActionEvent: {
      type: Function,
      default: function _default() {}
    },
    /**
     * Показывать 'колокольчик'
     */
    showNotices: {
      type: Boolean,
      default: false
    },
    /**
     * Возможность смены языка
     */
    makeChangeLanguage: {
      type: Boolean,
      default: true
    },
    /**
     * Адрес основного домена (использовать если домен отличается от основного сайта)
     */
    bimlibHost: {
      type: String,
      default: ''
    },
    /**
     * Адресс апи
     */
    apiHost: {
      type: String,
      default: '/api'
    },
    /**
     * Префикс до изображений Аватарки и логотипа компании
     */
    imgHost: {
      type: String,
      default: '/uploads/images/'
    },
    /**
     * Адреса ссылок в шапке
     * Array<link[]>{ linkRu: String, linkEng: String, url: String, links: Array<link[]> || [] },
     */
    headLinks: {
      type: Array,
      default: function _default() {
        return [{
          linkRu: 'Главная',
          linkEng: 'Home',
          url: '/',
          eventName: 'headerClickItemHome'
        }, {
          linkRu: 'BIM-<wbr>модели',
          linkEng: 'BIM-<wbr>models',
          url: '/models/',
          eventName: 'headerClickItemBimModels'
        }, {
          linkRu: 'Плагины',
          linkEng: 'Plugins',
          url: '/plugins/'
        }, {
          linkRu: 'Читальный <wbr>зал',
          linkEng: 'Reading <wbr>Room',
          url: '/articles/',
          eventName: 'headerClickItemArticles',
          links: [{
            linkRu: 'Партнёрские <wbr>программы',
            linkEng: 'Partners <wbr>programm',
            url: '/partners/',
            eventName: 'headerClickItemPartners'
          }]
        }, {
          separator: true,
          linkRu: 'separator-1',
          linkEng: 'separator-1'
        }, {
          linkRu: 'Производителям',
          linkEng: 'For <wbr>manufacturers',
          url: '/for-manufacturers/',
          eventName: 'headerClickItemForManufacturers',
          class: 'green-link',
          target: '_blank'
        }];
      }
    },
    /**
     * Объект пользователя
     * user { avatar: String, count_new_message: Number, firstName: String, lastName: String }
     */
    user: {
      type: Object,
      default: null
    },
    /**
     * Шапка на всю ширину
     */
    w100: {
      type: Boolean,
      default: false
    },
    /**
     * Текущий язык
     */
    activeLang: {
      type: String,
      default: 'ru',
      validator: function validator(value) {
        return ['ru', 'en'].indexOf(value) !== -1;
      }
    },
    /**
     * Элементы меню выпадающего списка
     */
    dropDownItems: {
      type: Array,
      default: function _default() {
        return ['home', 'models', 'contacts', 'statistics', 'logout'];
      }
    }
  },
  data: function data() {
    return {
      show: {
        mobileMenu: false,
        userMenu: false
      },
      headerHeight: 64
    };
  },
  mounted: function mounted() {
    this.initHeaderHide();
    document.addEventListener('click', this.onBodyClicked);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.onBodyClicked);
  },
  computed: {
    headerLinkTarget: function headerLinkTarget() {
      return String(this.bimlibHost).indexOf('http') >= 0 ? 'blank' : '';
    },
    headerLinks: function headerLinks() {
      var lang = this.activeLang;
      var linkTranslate = function linkTranslate(link) {
        link.name = lang === enumLang.ru ? link.linkRu : link.linkEng;
        if (link.links) {
          link.links.forEach(linkTranslate);
        }
        return link;
      };
      return [].concat(this.headLinks).map(linkTranslate);
    }
  },
  methods: {
    updateContext: function updateContext(context) {
      /**
       * Обновление контекста пользователя
       * @param {Object} context контекст пользователя
       */
      this.$emit('updateContext', context);
    },
    socialLinkClick: function socialLinkClick(name) {
      /**
       * Клик по иконке соц. сетей в мобильном меню<br/>
       * передает название соц. сети<br/>
       *
       * telegram, youtube, vk, telegram, linkedin, twitter
       * @param {String} name код соц. сети
       */
      this.$emit('socialLinkClick', name);
    },
    initHeaderHide: function initHeaderHide() {
      var self = this;
      var header = this.$refs.header;
      var scrollHeader = {
        self: self,
        header: header,
        position: window.pageYOffset,
        headerDown: function headerDown() {
          this.header.classList.add('nav-down');
          this.header.classList.remove('nav-up');
          this.position = window.pageYOffset;
        },
        headerUp: function headerUp() {
          var _this = this;
          setTimeout(function () {
            _this.header.classList.add('nav-up');
            _this.header.classList.remove('nav-down');
          }, 300);
          this.position = window.pageYOffset;
        },
        init: function init() {
          var _this2 = this;
          if (this.header) {
            var _this$header$offsetHe, _this$header;
            window.addEventListener('scroll', function () {
              if (_this2.position < window.pageYOffset && window.pageYOffset >= 200) {
                _this2.headerUp();
              } else if (window.pageYOffset === 0) {
                setTimeout(function () {
                  _this2.headerDown();
                }, 1000);
              } else {
                _this2.headerDown();
              }
            });
            self.headerHeight = (_this$header$offsetHe = (_this$header = this.header) == null ? void 0 : _this$header.offsetHeight) != null ? _this$header$offsetHe : 0;
            window.addEventListener('resize', function () {
              var _this2$header$offsetH, _this2$header;
              self.headerHeight = (_this2$header$offsetH = (_this2$header = _this2.header) == null ? void 0 : _this2$header.offsetHeight) != null ? _this2$header$offsetH : 0;
            });
          }
        }
      };
      scrollHeader.init();
    },
    handleMobileMenu: function handleMobileMenu() {
      var show = this.show.mobileMenu;
      this.show.mobileMenu = !show;
      document.body.style.setProperty('overflow', show ? 'auto' : 'hidden', 'important');
    },
    showMenuItem: function showMenuItem(menuItem) {
      return ~this.dropDownItems.indexOf(menuItem);
    },
    logoClicked: function logoClicked() {
      window.location = '/';
    },
    formLink: function formLink(link) {
      return "" + this.bimlibHost + link;
    },
    changeLang: function changeLang() {
      var nextLang = this.activeLang === enumLang.ru ? enumLang.eng : enumLang.ru;

      /**
       * Возвращает язык на который переключили ('ru', 'en')
       * @param {string} nextLang
       */
      this.$emit('changeLanguage', nextLang);
    },
    loginClicked: function loginClicked() {
      /**
       * Кликнули на кнопку войти
       * @param {void}
       */
      this.$emit('loginClicked');
      this.logActionEvent('headerClickLogin');
    },
    menuItemClicked: function menuItemClicked(menuItem) {
      /**
       * Произошел клик по меню пользователя
       * @param {string} menuItem
       */
      this.$emit('userMenuClicked', menuItem);
      this.show.userMenu = false;
    },
    onBodyClicked: function onBodyClicked() {
      if (this.show.userMenu) {
        this.show.userMenu = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/ui/bimHeader/bimHeader.vue?vue&type=script&lang=js&
 /* harmony default export */ var bimHeader_bimHeadervue_type_script_lang_js_ = (bimHeadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ui/bimHeader/bimHeader.vue?vue&type=style&index=0&id=bde68a26&prod&lang=scss&scoped=true&
var bimHeadervue_type_style_index_0_id_bde68a26_prod_lang_scss_scoped_true_ = __webpack_require__("c84a");

// CONCATENATED MODULE: ./src/components/ui/bimHeader/bimHeader.vue






/* normalize component */

var bimHeader_component = normalizeComponent(
  bimHeader_bimHeadervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "bde68a26",
  null
  
)

/* harmony default export */ var bimHeader = (bimHeader_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (bimHeader);



/***/ }),

/***/ "fb41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_9_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_9_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_style_index_0_id_e1d9552c_prod_lang_sass_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5595");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_9_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_9_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_style_index_0_id_e1d9552c_prod_lang_sass_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_9_oneOf_2_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_2_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_2_2_node_modules_postcss_loader_src_index_js_ref_9_oneOf_2_3_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_2_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_style_index_0_id_e1d9552c_prod_lang_sass_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "fd12":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".text__small[data-v-438fb726]{font-size:9px;font-weight:400;line-height:1.56;letter-spacing:.18px}.text__small.bold[data-v-438fb726]{font-weight:700}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "fda9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("daa1");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5b518a73", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ff67":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"20\" viewBox=\"0 0 18 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 7.985a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0 1 15 7.985v6l3 2v1H0v-1l3-2v-6zm8 10a2 2 0 1 1-4 0h4z\" fill=\"#3E3E3E\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "ffed":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path fill=\"#4d4d4d\" fill-rule=\"evenodd\" d=\"M2.039.28l.095.086 5.814 5.815L13.764.366l.095-.086c.49-.4 1.215-.372 1.673.086.488.488.488 1.28 0 1.768L9.716 7.948l5.816 5.816c.488.488.488 1.28 0 1.768-.458.457-1.182.486-1.673.086l-.095-.086-5.816-5.816-5.814 5.816-.095.086c-.491.4-1.215.371-1.673-.086-.488-.488-.488-1.28 0-1.768l5.815-5.816L.366 2.134c-.488-.488-.488-1.28 0-1.768C.824-.092 1.548-.12 2.04.28z\" opacity=\".5\"></path></svg>"

/***/ })

/******/ })["default"];
//# sourceMappingURL=bimHeader.common.js.map